// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%232a6b2a%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2020%2020%27%20fill%3D%27%236b7280%27%3E%3Cpath%20d%3D%27M5.23%207.21a.75.75%200%200%201%201.06.02L10%2010.13l3.71-2.9a.75.75%200%201%201%20.92%201.19l-4.17%203.26a.75.75%200%200%201-.92%200L5.21%208.42a.75.75%200%200%201%20.02-1.21z%27%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,700;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ro-bg: #f2f2f2;
  /* background */
  --ro-fg: #000000;
  /* text */
  --sel-radius: 10px;
  /* border radius for all selects */
  --sel-border: #c9ced6;
  /* default border */
  --sel-hover-border: #9ca3af;
  /* hover border */
  --sel-bg: #f5f6fa;
  /* default bg */
  --sel-hover-bg: #F5F6FA;
  /* hover bg */

  --sb-blue-1: #155dfc;
  /* top */
  --sb-blue-2: #155dfc;
  /* bottom */
  --sb-hover: rgba(255, 255, 255, .06);
  --disabled-color: #93c5fd;
}

body {
  color: #101828;
  background-color: #fefefe;
  font-family: "Roboto", sans-serif;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Roboto", sans-serif;
  color: #101828;
}

/* Bootstrap text inputs / textareas when read-only */
.form-control[readonly],
textarea.form-control[readonly],
input.form-control[readonly] {
  background-color: var(--ro-bg) !important;
  color: var(--ro-fg) !important;
  cursor: not-allowed;
  /* match disabled feel */
  opacity: 1;
  /* don't fade like disabled */
}


/* ensure parent li never paints a blue block */
.navbar-menu .navbar-nav .nav-item,
.navbar-menu .navbar-nav .nav-item.active {
  background: transparent !important;
}

/* make each link look like a button inside the rail */
.navbar-menu .navbar-nav .nav-item>.nav-link,
.navbar-menu .navbar-nav .menu-link {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 10px !important;
  /* space at left/right -> pill look */
  padding: 7px 14px !important;
  border-radius: 12px !important;
  background: transparent !important;
  color: #a7b4cc;
  text-decoration: none;
  background-clip: padding-box;
  /* crisp rounded edge */
  transition: background .18s ease, color .18s ease, box-shadow .18s ease;
}

/* hover */
.navbar-menu .navbar-nav .nav-item>.nav-link:hover,
.navbar-menu .navbar-nav .menu-link:hover {
  background: var(--sb-hover) !important;
  color: #cfe2ff !important;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .06);
}

/* ACTIVE – blue rounded button (exact look) */
.navbar-menu .navbar-nav .nav-item>.nav-link.active,
.navbar-menu .navbar-nav .menu-link.active,
.navbar-menu .navbar-nav .nav-item.active>.nav-link {
  background: linear-gradient(180deg, var(--sb-blue-1) 0%, var(--sb-blue-2) 100%) !important;
  color: #fff !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 28px rgba(37, 99, 235, .35) !important;
}

/* icons white on active */
.navbar-menu .navbar-nav .nav-item>.nav-link i,
.navbar-menu .navbar-nav .menu-link i {
  width: 22px;
  text-align: center;
  font-size: 18px;
}

.navbar-menu .navbar-nav .nav-item>.nav-link.active i,
.navbar-menu .navbar-nav .menu-link.active i {
  color: #fff !important;
  opacity: 1 !important;
}

/* some templates add a left stripe with ::before — kill it */
.navbar-menu .navbar-nav .nav-item>.nav-link::before {
  content: none !important;
}

/* Keep the same look on focus */
.form-control[readonly]:focus {
  background-color: var(--ro-bg) !important;
  color: var(--ro-fg) !important;
  box-shadow: none !important;
  border-color: #e5e7eb;
  /* subtle, optional */
}

/* Placeholder color inside read-only inputs */
.form-control[readonly]::placeholder {
  color: var(--ro-fg);
}

/* Safari/WebKit text color fix */
.form-control[readonly]::-webkit-text-fill-color {
  -webkit-text-fill-color: var(--ro-fg);
}

/* ----- Native <select> (Bootstrap) ----- */
select.form-select,
select.form-control {
  border-radius: var(--sel-radius) !important;
  background-color: var(--sel-bg) !important;
  border: 2px solid var(--sel-border) !important;
  box-shadow: none !important;
  transition: background-color .2s ease-in-out, border-color .2s ease-in-out;
}

select.form-select:focus,
select.form-control:focus {
  border-color: var(--sel-border) !important;
  /* keep gray, no blue ring */
  box-shadow: none !important;
}

select.form-select:hover:not(:disabled),
select.form-control:hover:not(:disabled) {
  background-color: var(--sel-hover-bg) !important;
  border-color: var(--sel-hover-border) !important;
}

/* Optional: if you want to remove the native caret everywhere
select.form-select,
select.form-control {
  appearance: none;
  background-image: none !important;
  padding-right: .75rem;
}
*/

/* ----- react-select (requires classNamePrefix="rs") ----- */
.rs__control {
  border-radius: var(--sel-radius) !important;
  background-color: var(--ro-bg) !important;
  border: 2px solid var(--sel-border) !important;
  box-shadow: none !important;
  transition: background-color .2s ease-in-out, border-color .2s ease-in-out;
}

.rs__control--is-focused {
  border-color: var(--sel-border) !important;
  /* keep same as default */
  box-shadow: none !important;
  background-color: var(--sel-bg) !important;
}

.rs__control:hover {
  background-color: var(--sel-hover-bg) !important;
  border-color: var(--sel-hover-border) !important;
}

.rs__indicator-separator {
  display: none !important;
}

/* Menu + options for a consistent feel */
.rs__menu {
  border: 1px solid var(--sel-border) !important;
  border-radius: var(--sel-radius) !important;
}

.rs__option--is-focused {
  background-color: var(--sel-hover-bg) !important;
}

.rs__option--is-selected {
  background-color: #e9edf7 !important;
  color: #111 !important;
}

/* Always show the dropdown arrow unless the control is disabled */
.rs__control .rs__indicators,
.rs__control .rs__dropdown-indicator {
  display: flex !important;
  align-items: center;
  opacity: 1 !important;
  visibility: visible !important;
}

/* Hide arrow only when disabled */
.rs__control--is-disabled .rs__indicators,
.rs__control--is-disabled .rs__dropdown-indicator {
  display: none !important;
}

/* Optional: remove default SVG caret if it ever appears under your custom icon */
.rs__dropdown-indicator svg {
  display: none;
  /* keeps only your <i class="ri-arrow-down-s-line"> */
}

/* Keep the border/hover you want (if you’re using the global select theme) */
.rs__control {
  border-color: #c9ced6 !important;
  box-shadow: none !important;
}

.rs__control:hover {
  background-color: #F5F6FA !important;
  border-color: #9ca3af !important;
}

.rs__control--is-focused {
  border-color: #c9ced6 !important;
  box-shadow: none !important;
}

.form-control:disabled {
  background-color: var(--ro-bg);
  opacity: 1;
}


.roboto-new-Paragraph,
p {
  font-family: "Roboto", sans-serif;
  font-optical-sizing: auto;
  /* font-weight: 500; */
  font-style: normal;
  font-variation-settings: "wdth" 100;
  color: #101828;
}

.roboto-new {
  font-family: "Roboto", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-variation-settings: "wdth" 100;
  color: #101828;
}


/* header css */
.header-item {
  height: 70px;
  display: flex;
  align-items: center;
  background-color: #ffffff !important;
}

.topbar-user {
  background-color: #ffffff !important;
}

.badge {
  line-height: .95;
  /* width: 20px; */
}

/* 1) Default: everything at 100% (mobiles + large desktops) */
body {
  zoom: 90%;
}

/* 2) Laptops & tablets: between 768px and 1440px → 90% zoom */
@media screen and (min-width: 768px) and (max-width: 1440px) {
  body {
    zoom: 90%;
  }
}

.topbar-badge {
  left: 30px;
}

.vertical-sidebar-enable {
  margin-left: 0 !important;
  z-index: 1004;
}

@media (min-width: 768px) {
  #page-topbar {
    left: 250px !important;
    right: 0 !important;
  }

  .footer {
    left: 250px !important;
    right: 0px !important;

  }

  .topbar-user {
    background-color: #ffffff !important;
  }
}

.logo-lg {
  color: #ffffff;
}

.logo-lg h2 {
  color: #ffffff !important;
  padding: 30px;
}

.navbar-menu {
  width: var(--vz-vertical-menu-width);
  z-index: 1002;
  background: #101828 !important;
  border-right: 1px solid var(--vz-vertical-menu-border);
  bottom: 0;
  margin-top: 0;
  /* position: fixed; */
  top: 0;
  box-shadow: var(--vz-vertical-menu-box-shadow);
  padding: 0 0 calc(70px + 25px) 0;
  transition: all .1s ease-out;
  overflow-y: auto;
  scrollbar-width: none;
}

.navbar-menu .navbar-nav .nav-link {
  display: flex;
  align-items: center;
  padding: .625rem 1.5rem;
  color: #e9ebec !important;
  font-size: var(--vz-vertical-menu-item-font-size);
  font-family: 'Roboto';
}

.profBlk {
  border: 1px solid #cccccc;
  padding: 5px;
}

.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  left: unset;
}

/* agent css */
.swiper-slide.swiper-slide-visible.swiper-slide-fully-visible.swiper-slide-active {
  /* height: 90vh; */
  /* border: 1px solid #cccccc; */
  width: 31vw !important;
  text-align: center;
  margin: 5px;
}

.swiper-slide.swiper-slide-visible.swiper-slide-fully-visible.swiper-slide-active img {
  height: 60px;
}

/* teammember css */
.combinations {
  width: 100%;
  height: 600px;
  border: 1px solid #cccccc;
}

.attributes {
  width: 100%;
  height: 600px;
  border: 1px solid #cccccc;
}

.attr-head {
  background-color: #405189;
  color: #ffffff;
  height: 30px;
  text-align: center;
  font-weight: 600;
  line-height: 30px;
}

.table-bordered>:not(caption)>*>* {
  border-width: 1px;
}

/* brokarage css */
.password-validation-box.mt-2 {
  width: 400px;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: #f4f4f4;
  padding: 10px;
  /* display: none; */
}

.table-container {
  width: 100%;
  overflow-x: auto;
  /* Enables horizontal scrolling */
  margin: 0 auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  /* border: 1px solid #ddd; */
}

@media (max-width: 768px) {

  th,
  td {
    font-size: 14px;
    /* Adjust font size for smaller screens */
  }
}

label {
  font-size: 14px !important;
}

.nav-link {
  color: #ffffff;
}

.nav-link:active,
.nav-link:hover,
.nav-link:focus {
  color: #ffffff;
}

/* sinage css */
.options {
  width: 100%;
  height: 200px;
  border: 1px solid #cccccc;
}

#myTab .nav-link {
  color: #ffffff !important;
}

.nav-link:active,
.nav-link:hover,
.nav-link:focus {
  color: #ffffff;
}

#myTab .nav-link.active {
  background-color: var(--vz-nav-tabs-link-active-bg);
  border-color: var(--vz-nav-tabs-link-active-border-color);
  color: #000000 !important;
}

.calculation-table {
  width: 100%;
  height: 200px;
  border-collapse: collapse;
  box-shadow: none;
  border: 0;
  margin-top: 20px;
}

.calculation-table th {
  background-color: #ffffff;
  color: #333333;
  height: 30px;
  text-align: left;
  font-weight: 600;
  line-height: 30px;
  border: 1px solid #cccccc;
}

.calculation-table td {
  background-color: #ffffff;
  color: #333333;
  height: 30px;
  text-align: left;
  line-height: 30px;
  border: 1px solid #cccccc;
}

.default-table {
  width: 100%;
  border: 1px solid #cccccc;
}

.default-table th {
  background-color: #e9ebec;
  color: #333333;
}

.default-table .btn-success {
  background-color: #0ab39c;
  color: #f4f4f4;
  border-radius: 8px;
}

.btn-success {
  border-radius: 8px;
}

/* Style for disabled success button */
.btn-success:disabled {
  background-color: #d1d5db !important;
  /* gray color */
  border-color: #d1d5db !important;
  opacity: 0.8;
  cursor: not-allowed;
}

.theme-table {
  width: 100%;
  margin-top: 10px;
}

.theme-table th {
  background-color: #004aad;
  color: white;
}

/* .status-badge {
  padding: 4px 10px;
  border-radius: 10px;
  font-size: 12px;
  color: white;
  display: inline-block;
} */

.status-draft {
  background-color: #6c757d;
}

.status-pending {
  background-color: #ffc107;
  color: black;
}

.status-accepted {
  background-color: #28a745;
}

.status-shipped {
  background-color: #17a2b8;
}

.status-delivered {
  background-color: #007bff;
}

.status-completed {
  background-color: #6f42c1;
}

.status-canceled {
  background-color: #dc3545;
}

.view-btn {
  background-color: #007bff;
  color: white;
}

.view-btn:hover {
  background-color: #0069d9;
}

label {
  color: #101828;
  font-size: 0.85rem;
}

.white-table {
  width: 100%;
  box-shadow: none;
}

.white-table th {
  background-color: #ffffff;
  color: #333333;
}

.white-table td {
  background-color: #ffffff;
  color: #333333;
}

/* UI improvements */
.form_container {
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 50px 40px 20px 40px;
  background-color: #ffffff;
  box-shadow: 0px 106px 42px rgba(0, 0, 0, 0.01),
    0px 59px 36px rgba(0, 0, 0, 0.05), 0px 26px 26px rgba(0, 0, 0, 0.09),
    0px 7px 15px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
  border-radius: 11px;
  font-family: 'Roboto';
}

.logo_container {
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  background: linear-gradient(180deg, rgba(248, 248, 248, 0) 50%, #F8F8F888 100%);
  border: 1px solid #F7F7F8;
  filter: drop-shadow(0px 0.5px 0.5px #EFEFEF) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  border-radius: 11px;
}

.title_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #212121;
}

.subtitle {
  font-size: 0.725rem;
  max-width: 80%;
  text-align: center;
  line-height: 1.1rem;
  color: #8B8E98
}

.input_container {
  width: 100%;
  height: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.icon {
  width: 20px;
  position: absolute;
  z-index: 99;
  left: 12px;
  bottom: 9px;
}

.input_label {
  font-size: 0.75rem;
  color: #8B8E98;
  font-weight: 600;
}

.input_field {
  width: auto;
  height: 40px;
  padding: 0 0 0 40px;
  border-radius: 7px;
  outline: none;
  border: 1px solid #e5e5e5;
  filter: drop-shadow(0px 1px 0px #efefef) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  transition: all 0.3s cubic-bezier(0.15, 0.83, 0.66, 1);
}

.input_field:focus {
  border: 1px solid transparent;
  box-shadow: 0px 0px 0px 2px #242424;
  background-color: transparent;
}

.sign-in_btn {
  width: 100%;
  height: 40px;
  border: 0;
  background: #115DFC;
  border-radius: 7px;
  outline: none;
  color: #ffffff;
  cursor: pointer;
}

.sign-in_ggl {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #ffffff;
  border-radius: 7px;
  outline: none;
  color: #242424;
  border: 1px solid #e5e5e5;
  filter: drop-shadow(0px 1px 0px #efefef) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  cursor: pointer;
}

.sign-in_apl {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #212121;
  border-radius: 7px;
  outline: none;
  color: #ffffff;
  border: 1px solid #e5e5e5;
  filter: drop-shadow(0px 1px 0px #efefef) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));
  cursor: pointer;
}

.separator {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  color: #8B8E98;
}

.separator .line {
  display: block;
  width: 100%;
  height: 1px;
  border: 0;
  background-color: #e8e8e8;
}

.note {
  font-size: 0.75rem;
  color: #8B8E98;
  text-decoration: underline;
}

/* .navbar-menu .navbar-nav .nav-link:hover {
  background-color: #1e2939 !important;
  border-left: 2px solid #0069d9;
} */

/* .status-badge {
  display: inline-block;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
} */

/* .status-badge {
  display: inline-block;
  padding: 4px 8px; 
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
}

@media (min-width: 1200px) {
  .status-badge {
    padding: 6px 12px;
    font-size: 14px;
  }
}

@media (min-width: 1600px) {
  .status-badge {
    padding: 8px 16px;
    font-size: 16px;
  }
} */



/* .status-draft-btn {
  background-color: #e2e3e5;
  color: #343a40;
} */

/* .status-pending-btn {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #856404;
} */

/* .status-accepted-btn {
  background-color: #d4edda;
  color: #0da06e;
  border: 1px solid #60d956;
} */

.status-shipped-btn {
  background-color: #d1ecf1;
  /* Light teal */
  color: #0c5460;
  /* Teal text */
}

.status-delivered-btn {
  background-color: #cce5ff;
  /* Light blue */
  color: #004085;
  /* Blue text */
}

.status-completed-btn {
  background-color: #e2d9f3;
  /* Soft purple */
  color: #3f2b75;
  /* Purple text */
}

.status-canceled-btn {
  background-color: #fff0f0;
  color: #c0392b;
  /* background-color: #f8d7da; */
  /* Light red */
  /* color: #721c24; */
  /* Dark red text */
}

.status-default-btn {
  background-color: #ffffff;
  /* Light gray */
  color: #343a40;
  /* Dark text */
}


.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  display: inline-block;
  min-width: 80px;
  text-align: center;
  white-space: nowrap;
}

/* Active */
.status-accepted-btn {
  background-color: #e8f9f1;
  color: #2e8b57;
  border: 1px solid #a3e4cd;
}

/* ✅ Subtle modern gray for Inactive */
.status-draft-btn {
  background-color: #d1d1d1;
  color: black;
  border: 1px solid #dee2e6;
}

/* Custom inactive types */
.status-inactive-btn {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-suspended-btn {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.status-pending-btn {
  background-color: #d1ecf1;
  color: #3434a1;
  /* border: 1px solid #bee5eb; */
}


.license-btn {
  font-size: 13px;
  font-weight: 500;
  border-radius: 10px;
  padding: 6px 14px;
  transition: all 0.2s ease-in-out;
  border: 1px solid transparent;
}

/* 🟢 Activate Button - Subtle green */
.license-activate {
  background-color: #2563eb;
  color: #292d32;
  /* border: 1px solid #27ae60; */
}

.license-activate:hover:not(:disabled) {
  background: #2563eb;
  /* color: #ffffff; */
}

/* 🔴 Deactivate Button - Soft red */
.license-deactivate {
  background-color: #fff0f0;
  color: #c0392b;
  /* border: 1px solid #f5b7b1; */
}

.license-deactivate:hover:not(:disabled) {
  background-color: #e3cece;
  /* color: #ffffff; */
}

.license-btn:hover {
  filter: brightness(0.95);
  cursor: pointer;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  font-size: 14.5px;
  font-weight: 500;
  border-radius: 20px;
  border: 1px solid transparent;
  min-width: 70px;
  text-align: center;
}

/* Active Badge */
.badge-active {
  background-color: #80d556;
  /* light green */
  color: #203D12;
  /* border-color: #b7eb8f; */
}

/* Inactive Badge */
.badge-inactive {
  background-color: #f9d4b0;
  /* soft orange */
  color: #6D4927;
  /* border-color: #ffd591; */
}

.linked-status {
  color: #955BE3;
  font-weight: bold;
}


/* Table wrapper styles */
.styled-datatable .rdt_TableHead {
  background-color: #f8f9fa;
  color: #212529;
  font-weight: bold;
  font-size: 0.95rem;
  border-bottom: 2px solid #dee2e6;
  text-transform: capitalize;
  white-space: wrap;
}

.styled-datatable .rdt_TableRow {
  border-bottom: 1px solid #e9ecef;
}

.submit_btn {
  width: 100%;
  height: 45px;
  border: none;
  background-color: #673AB7;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.submit_btn:hover {
  background-color: #0d4dcc;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.submit_btn:active {
  transform: scale(0.98);
}

.submit_btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(17, 93, 252, 0.4);
}

/* .btn-primary {
  background-color: #3F51B5;
  color: #ffffff;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
  text-align: center;
  display: inline-block;
} */

.btn-primary:hover {
  /* background-color: #0d4dcc; */
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.12);
  text-decoration: none;
}

.btn-primary:active {
  transform: scale(0.97);
}

.btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(17, 93, 252, 0.4);
}

button {
  background-color: #ffffff;
  border: 1px solid rgb(209, 213, 219);
  border-radius: 0.5rem;
  color: #111827;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  padding: 0.75rem 1rem;
  text-align: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

button:hover {
  background-color: #f9fafb;
}

button:focus {
  outline: 2px solid rgba(0, 0, 0, 0.1);
  outline-offset: 2px;
}

button:focus-visible {
  box-shadow: none;
}

.form-select:focus {
  border-color: var(--vz-primary-border-subtle);
  outline: 0;
  box-shadow: 0 0 0 1px rgba(var(--vz-primary-rgb), .25);
}

.info-btn {
  background-color: #ffffff;
  /* Light gray */
  color: #343a40;
  margin-right: 4px;
  width: auto;
  height: 30px;
  float: left;
}

.page-title {
  color: #10172A;
}

.css-vckj6b-MuiTableCell-root {
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  display: table-cell;
  vertical-align: inherit;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  text-align: left;
  padding: 16px;
  color: #10172A;
  border-right: none;
  border-left: none;
}

.MuiTable-root td {
  font-family: "Roboto";
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  display: table-cell;
  vertical-align: inherit;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  text-align: left;
  padding: 8px;
  color: rgba(0, 0, 0, 0.87);
  border-right: none;
  border-left: none;
  padding-left: 10px;
}

.pagination-blk button {
  /* background-color: #ffffff; */
  border: 1px solid rgb(255, 255, 255);
  border-radius: 0.5rem;
  color: #a251ad;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  padding: 0.75rem 1rem;
  text-align: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  border-radius: 20px !important;
}

.pagination-blk .btn:hover {
  color: #000000;
  background-color: #0ab39c;
  border-color: #0ab39c;
}

.pagination-blk .btn.disabled,
.pagination-blk .btn:disabled,
.pagination-blk fieldset:disabled .btn {
  color: #6c757d;
  background-color: #ffffff;
  border-color: #ffffff;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #2563EB;
  border-radius: 8px;
}

.btn-primary:hover {
  /* background-color: #1D4ED8; */
}

/* Datatable Listing page styles */
.datatable table,
th,
td {
  color: #10172A;
}

.datatable thead {
  background-color: #e5e7eb;
  color: #10172A;
  height: 48px;
  font-size: 15px;
}

.datatable thead th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.datatable tbody td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  color: #10172A;
}

.datatable .view {
  color: #5d6b96;
}

.datatable .edit {
  color: #5d6b96;
}

.datatable .del {
  color: #5d6b96;
}

.datatable .view:hover {
  color: #007bff;
}

.datatable .edit:hover {
  color: #ffc107;
}

.datatable .del:hover {
  color: #dc3545;
}

#pageSizeSelect,
.pageSizeSelect {
  width: 50px;
  height: 34px;
  margin-top: -5px;
  padding: 5px;
  background-position: right 0.4rem center;
}

.content .form-select {
  border-radius: 8px;
  height: 38px;
}

.content .card-body {
  border: 1px solid #e3e5e7;
  border-radius: 8px;
}

.content .right-radius {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.content .left-radius {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.content .btn.disabled {
  border: none;
}

.formmm label {
  font-size: 16px;
}

.formmm input,
select {
  height: 42px;
  line-height: 30px;
  border-radius: 8px;
}

.formmm .submit-btn {
  height: 42px;
  width: 120px;
}

.formmm #password-addon {
  width: 50px;
}

.formmm #assignedWarehouses div:first-child {
  /* height: 45px; */
  /* line-height: 25px; */
  /* border-radius: 8px;
  padding-top: 0;
  margin-top: -6px; */
}

.formmm #permissions div:first-child {
  /* height: 45px; */
  /* line-height: 25px; */
  /* border-radius: 8px;
  padding-top: 0;
  margin-top: -6px; */
}

.formmm .form-control {
  border-radius: 8px;
  /* color: #919da9; */
}

/* .formmm #assignedWarehouses div{
  border-radius: 8px;
} */

/* .formmm #permissions div {  
  border-radius: 8px;
} */

.formmm .cust-margin-4 {
  margin-left: -60px !important;
  margin-right: -60px !important;
}

/* .formmm .custom-select-control {
    border: 1px solid #cccccc;
    border-radius: 8px;
    background-color: #ffffff;
}

.formmm .custom-select-option {
    padding: 10px;
    cursor: pointer;
    color: #10172A;
} */

/* Container */
.my-select-container {
  width: 100%;
  font-family: 'Roboto';
}

/* Control (input box) */
.my-select-control {
  display: flex;
  align-items: center;
  height: 45px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
  padding-top: 0;
}

.my-select-control:focus-within {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Menu dropdown */
.my-select-menu {
  margin-top: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  position: absolute;
}

/* Option */
.my-select-option {
  padding: 8px 12px;
  cursor: pointer;
}

.my-select-option:hover,
.my-option-focused {
  background-color: #f0f0f0;
}

.my-select-option.is-selected {
  background-color: #007bff;
  color: white;
}

/* Multi-value (the selected tag) */
.my-multi-value {
  display: inline-flex;
  align-items: center;
  margin: 2px;
  padding: 2px 6px;
  border-radius: 8px;
  background-color: hsla(0, 6.48%, 49.68%, 0.37);
  color: rgb(43, 11, 11);
  font-size: 0.85rem;
}

/* Label inside the tag */
.my-multi-value__label {
  padding-right: 4px;
}

/* Remove icon */
.my-multi-value__remove {
  cursor: pointer;
  font-weight: bold;
}

.my-multi-value__remove:hover {
  color: #ffdddd;
}


/* .navbar-menu .navbar-nav .nav-link.active {
  background-color: #000000;
  color: #ffffff;
} */

.navbar-menu .navbar-nav .nav-link.active {
  background-color: #155dfc;
  color: #ffffff;
}

.text-secondary {
  color: #9E9E9E !important;
}

.saved-card {
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.3s;
  min-height: 180px;
  color: #fff;
  border-radius: 18px;
  min-height: 180px;
  box-shadow: 0 4px 16px rgba(20, 40, 60, .10);
}

.saved-card .card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(24, 28, 37, 0.60);
  /* semi-transparent dark */
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s;
  z-index: 10;
}

.saved-card:hover .card-overlay {
  opacity: 1;
  pointer-events: auto;
}

.saved-card .card-content {
  filter: none;
  transition: filter 0.3s;
}

.saved-card:hover .card-content {
  filter: blur(2px) brightness(0.85);
}

.saved-card .overlay-btn {
  min-width: 120px;
  margin-bottom: 12px;
  font-size: 1.05rem;
  z-index: 1;
}

.search-blk {
  border-color: "#cccccc";
  white-space: "nowrap";
  overflow: "hidden";
  text-overflow: "ellipsis";
}

.add-image {
  width: 120px;
  height: 160px;
  box-shadow: 0 0 1px 1px #cccccc;
  margin: 10px;
  text-align: center;
  line-height: 150px;
  font-size: xxx-large;
  cursor: pointer;
  color: #cccccc;
}

.gallery-image {
  width: 120px;
  height: 160px;
  box-shadow: 0 0 2px 1px #cccccc;
  margin: 10px;
}

.gallery-image img {
  width: 120px;
  height: 130px;
}

.no-image {
  width: 34vw;
  height: 96vh;
  padding: 60px;
  border: 1px solid #cccccc;
  text-align: center;
  font-size: 18px;
}

.br-8 {
  border-radius: 10px !important;
}

form input {
  border-radius: 10px !important;
}

.small-input {
  width: 250px;
  border-radius: 10px;
  padding: 8px;
  border: 1px solid #ccc;
}

.lines {
  border: none;
  border-top: 2px solid #405189;
  margin-top: 0;
}

.w-11 {
  width: 11%;
}

.profile {
  width: 100px;
  height: 100px;
  background-color: #e0e7ff;
  font-size: 36px;
  font-weight: bold;
  color: #2563eb;
}

.css-14oxtc6 {
  height: 42px !important;
}

.bg-light {
  background-color: transparent !important;
}

/* .row>* {
  margin-top: 15px !important;
  padding-left: 24px;
} */

.custom-input {
  border-color: #c6dce5 !important;
  /* Default light border */
}

.custom-input:focus {
  border-color: #0d6efd !important;
  /* Bootstrap primary color on focus */
  box-shadow: none;
}

.custom-floating-group {
  position: relative;
}

.custom-floating-label {
  position: absolute;
  top: 14px;
  left: 0;
  font-size: 16px;
  color: #6c757d;
  pointer-events: none;
  transition: all 0.2s ease;
  padding-left: 2px;
}

.custom-floating-group input:focus+.custom-floating-label,
.custom-floating-group input:not(:placeholder-shown)+.custom-floating-label {
  top: -8px;
  font-size: 13px;
  color: #0d6efd;
  background: white;
  padding: 0 4px;
}

.top-27 {
  top: 27%;
  left: 8%;
}

.radio-width {
  width: 1.5em;
  height: 1.5em;
  border: 1px solid #6a6767
}

.sticky-top {
  top: -1px !important
}

.Attributes-table {
  max-height: 500px;
  overflow-y: auto;
  background-color: #f8f9fa;
  padding: 1rem;
}

.combinationstable {
  width: 100%;
  height: 470px;
  border: 1px solid #cccccc;
  background-color: #f8f9fa;
}

.react-select-container {
  min-height: 38px;
}

.react-select__control {
  min-height: 38px;
  border-radius: 4px;
}

#row-overlap {
  margin-top: 0px !important;
  padding-left: 0px !important;
}

.fixed-header-table {
  max-height: 300px;
  overflow-y: auto;
  display: block;
}

.fixed-header-table table {
  width: 100%;
  border-collapse: collapse;
}

.fixed-header-table thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  /* same as Bootstrap's .table-light */
  z-index: 2;
  text-align: center;
}


.custom-table-wrapper {
  overflow-x: auto;
}

.table {
  width: 100%;
  table-layout: fixed;
}

.responsive-btn {
  font-size: 12px;
  padding: 3px 8px;
}

@media (min-width: 1200px) {
  .responsive-btn {
    font-size: 10px;
    padding: 5px 12px;
  }
}

@media (min-width: 1600px) {
  .responsive-btn {
    font-size: 14px;
    padding: 6px 16px;
  }
}


/* Responsive font scaling */
@media (min-width: 1200px) {

  .table-header-text,
  .table-cell-text {
    font-size: 13px;
  }
}

@media (min-width: 1600px) {

  .table-header-text,
  .table-cell-text {
    font-size: 17px;
  }
}

@media (max-width: 1199.98px) {
  .input-group-responsive {
    width: 25% !important;
  }
}

@media (min-width: 1200px) and (max-width: 1594.98px) {
  .input-group-responsive {
    width: 39% !important;
  }
}

@media (min-width: 1595px) {
  .input-group-responsive {
    width: 28% !important;
  }
}

.page-container {
  /* background-color: #ecf0f4;  */
  padding: 1rem 1.5rem;
  /* vertical & horizontal padding */
  border-radius: 8px;
  /* box-shadow: 0 0 8px rgba(31, 29, 29, 0.05); */
  display: flex;
  /* justify-content: center; */
  align-items: center;
  min-height: 70px;
  /* ensures height and vertical centering */
}

.addheaders {
  padding-left: 1.1rem;
}

.addheaders-content {
  border: 1px solid #e3e5e7;
  border-radius: 8px;
}

.viewdetailsfont {
  font-size: 15px;
}

.form-check-input[disabled] {
  opacity: 1;
}

#selectwidthdecrease {
  width: 90% !important;
}

/* pagination.css */
/* wrap everything in a soft pill with a subtle inset border */
.pagination-container {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 40px;
  box-shadow: inset 0 0 0 1px #e0e0e0;
}

.pagination-arrow {
  width: 36px;
  height: 36px;
  margin: 0 6px;
  border: none;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a251ad;
  font-size: 20px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.pagination-arrow:hover:not(:disabled) {
  background: #a251ad;
  color: #ffffff;
}

.export-button {
  background-color: #00a63e !important;
  color: white;
  font-weight: 500 !important;
  border-radius: 0.625rem;

}

.export-button:hover{
  background-color: #008236 !important;
}

.export-button:hover:not(:disabled) {
  background: #3e995e;
  color: #ffffff;
}

.pagination-arrow:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* page bubbles: white circles, coral ring when active */
.pagination-circle {
  width: 36px;
  height: 36px;
  margin: 0 4px;
  border: 2px solid transparent;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #555555;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}

.pagination-circle:hover {
  background: #f0f0f0;
}

.pagination-circle.active {
  border-color: #bec1c7;
  color: #292d32;
  background: #ffffff;
}

/* the “…” bubble */
.pagination-ellipsis {
  width: 36px;
  height: 36px;
  margin: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  /* color: #888888; */
  -webkit-user-select: none;
          user-select: none;
}

.table-headers {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 15px !important;
  white-space: nowrap;
}

.table-cells {
  font-family: "Roboto", sans-serif;
  font-size: 15px !important;
  white-space: nowrap;
  /* overflow: hidden; */
  text-overflow: ellipsis;
}

.table-cellsvalues {
  font-family: "Roboto";
  font-size: 13px !important;
  white-space: nowrap;
}

.viewheaders {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 20px !important;
  white-space: nowrap;
}

.viewecells {
  font-family: "Roboto", sans-serif;
  font-size: 18px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fw-semibold {
  font-size: 15px !important;

}

/* .btn:hover {
  background-color: #1D4ED8 !important;
} */

.btn-danger:hover {
  background-color: #ef0d25 !important;
}

.warebutton:hover {
  background-color: #E5E7EB !important;
}

/* .btn-info:hover {
  background-color: #119de9 !important;
} */
/* .btn-danger:hover {
  background-color: #d11d1d !important;
}  */

.css-1jqq78o-placeholder {
  font-family: "Roboto", sans-serif;
  font-size: 13px !important;
  color: black !important;
}

.activetabs {
  padding: 0.5rem 1.2rem;
  font-weight: 500;
  color: #333;
  background-color: #f1f5f9;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  display: inline-block;
  text-align: center;
}

/* .activetabs.active {
  background-color: #93C5FD !important;
  color: #000 !important;
  font-weight: 600;
  border-radius: 8px;
} */

.activetabs:hover:not(.active) {
  background-color: #e0eefe;
  color: #222 !important;
}




.modal-content {
  left: -26px;
  border-radius: 26px;
}


#checvkoutpopup {
  left: -3px !important;
  border-radius: 26px;
}


.modal-backdrop {
  width: 125vw !important;
  height: 125vh !important;
}

#selectwidthdecreaseWarehouse {
  width: 35% !important;
  padding: .5rem 4.7rem .5rem .9rem !important
}

#selectwidthdecreaseWarehouseagent {
  width: 71% !important;
  padding: .5rem 4.7rem .5rem .9rem !important
}

#selectionagentproduct {
  background-position: right 2.7rem center;
  width: 35% !important;
}

#selectionagentproduct1 {
  /* background-position: right 2.9rem center; */
  width: 32% !important;
}


#selectionincomingagentproduct {
  width: 34% !important;
}

.css-1u9des2-indicatorSeparator {
  width: 0 !important;
}

.css-13cymwt-control {
  border-radius: 8px !important;
}

.calculation-input:focus {
  box-shadow: none;
  border-color: #86b7fe;
}

.calculation-table th,
.calculation-table td {
  border: none !important;
  background: transparent !important;
}

#warehousemodel {
  left: 382px !important;
  border-radius: 26px;
  width: 15vw !important;
}

#model-adjust {
  left: 118px !important;
  border-radius: 26px;
}

#modal-shipping {
  left: 118px !important;
  border-radius: 26px;
}

#selectionInstallationsdates {
  width: 15% !important;
}

#selectionInstallationspayments {
  width: 17% !important;
}

#selectionInstallationspriority {
  width: 12% !important;
}

#modeladdress {
  left: 118px !important;
  border-radius: 26px;
}

.css-894a34-indicatorSeparator {
  width: 0 !important;
}

.css-16xfy0z-control {
  border-radius: 10px !important;
}

/* 1) Enable ellipsis on the input box */
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 2) Make the placeholder itself obey ellipsis too */
input.text-ellipsis::placeholder,
input.text-ellipsis:focus::placeholder {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.office-list {
  display: flex;
  overflow-x: auto;
  max-width: 200px;
}

.office-list::-webkit-scrollbar {
  display: none;
}

.officetooltip {
  color: white;
}

.mt-9 {
  margin-top: 80px;
}

.leftmodel {
  left: 8% !important;
}

.css-9jq23d {
  font-size: 105% !important;
}

/* .isResizing {
  background-color: #1976d2 !important; 
} */

.table-colors {
  color: black !important;
}

/* input::placeholder {
  text-align: center !important;
} */


.product-location-status-badge {
  border: 1px solid #fbf6f6;
  border-radius: 8px;
  background-color: #d4a8da;
  color: #292d32;
  width: 100px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  margin: 0 auto;
  /* Center horizontally if used in a table cell */
}

/* Force Google Places dropdown to appear above the input field */
.pac-container {
  transform: translateY(56%) !important;
  /* margin-top: -4px !important; */
  z-index: 9999 !important;
}

.file-upload-form {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-upload-label input {
  display: none;
}

.file-upload-label svg {
  height: 50px;
  fill: rgb(82, 82, 82);
  margin-bottom: 20px;
}

.file-upload-label {
  cursor: pointer;
  background-color: #ddd;
  padding: 30px 70px;
  border-radius: 40px;
  border: 2px dashed rgb(82, 82, 82);
  box-shadow: 0px 0px 200px -50px rgba(0, 0, 0, 0.719);
}

.file-upload-design {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.browse-button {
  background-color: rgb(82, 82, 82);
  padding: 5px 15px;
  border-radius: 10px;
  color: white;
  transition: all 0.3s;
}

.browse-button:hover {
  background-color: rgb(14, 14, 14);
}

.timeline-item {
  position: relative;
}

.timeline-item .badge {
  font-size: 0.8rem;
  padding: 0.4em 0.6em;
  border-radius: 0.4rem;
}


.timeline {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
}

.timeline::before {
  content: '';
  /* position: absolute; */
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 100%;
  /* background-color: #dee2e6; */
  z-index: 0;
}

.timeline-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
}

.timeline-icon {
  position: relative;
  z-index: 1;
  background-color: #fff;
}

.timeline-icon::before,
.timeline-icon::after {
  content: '';
  position: absolute;
  left: 50%;
  width: 2px;
  background-color: #dee2e6;
  transform: translateX(-50%);
}

.timeline-icon::before {
  top: -40px;
  height: 40px;
}

.timeline-icon::after {
  bottom: -107px;
  height: 107px;
}


.mdi:before,
.mdi-set {
  margin-top: 2px !important;
  margin-left: 2px ! important;
  padding: 5px !important
}

.ms-8 {
  margin-left: 94px !important;
}

.payment-cards-save {
  max-height: 410px;
  overflow-y: auto;
  scrollbar-width: none;
}

.mr-5 {
  margin-right: 5vw !important;
}

.timeline-icon.delivered-last::after {
  height: 40px;
  /* shorter line before Delivered */
  bottom: -40px;
}

.select-control {
  font-size: 0.875rem;
  border: 1px solid #ced4da;
  border-radius: 8px;
  background-color: white;
  height: 41px;
}

.select-option {
  padding: 6px 12px;
  font-size: 0.875rem;
  line-height: 1.5;
  cursor: pointer;
}

.select-option.focused {
  background-color: #f1f1f1;
}

.select-option.selected {
  background-color: #e9ecef;
  font-weight: 600;
}

.select-menu {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Prevent clipping by table or modal */
.table-responsive,
.modal,
.modal-body {
  overflow: visible !important;
  /* position: static !important; if it's position: relative, dropdowns get misaligned */
}

.notestablesdata {
  font-size: 17px !important;
  font-family: "roboto" !important;
}

.producttittle {
  font-size: 24px !important;
  font-family: "roboto" !important;
}

@media print {
  .invoice-container {
    font-size: 13px;
    line-height: 1.5;
    letter-spacing: 0.25px;
    -webkit-font-smoothing: antialiased;
    print-color-adjust: exact;
  }

  .table th,
  .table td {
    padding: 6px !important;
  }

  .alert {
    page-break-inside: avoid;
  }

  hr {
    margin: 0.5rem 0;
  }

  body {
    margin: 0;
    padding: 0;
  }
}

.Invoice-headers {
  font-size: 23px !important;
  font-family: "roboto" !important;
  letter-spacing: 2px;
}

.inovice-subheaders {
  font-size: 19px !important;
  font-family: "roboto" !important;
}

.tight-label,
.tight-value {
  padding: 6px 10px !important;
  font-size: 14px;
  vertical-align: middle;
}

.paymentcards::-webkit-scrollbar {
  display: none;
}

.ordercard {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.22);
  margin-bottom: 1.5rem;
}

#allocate-model {
  left: 120px !important;
  border-radius: 26px;
}

.dashed-line {
  border-top: 1px dashed #999;
  width: 100%;
}

.product-gallery .main-image-container {
  width: 100%;
  max-width: 600px;
  margin: auto;
}

.product-gallery .main-image {
  width: 100%;
  height: 500px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}

.thumbnail-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: 0.3s;
}

.thumbnail-image:hover {
  border-color: #007bff;
  /* hover effect */
}

.thumbnail-image.active {
  border-color: #007bff;
  /* ✅ highlight active thumbnail */
  box-shadow: 0 0 6px rgba(0, 123, 255, 0.6);
}


.quantity-overlay {
  position: relative;
  top: 10px;
  z-index: 10;
}

.product-image {
  position: relative;
}

.product-image-wrapper {
  position: relative;
  display: inline-block;
}

.quantity-overlay {
  position: absolute;
  bottom: 10px;
  /* moves it up from bottom */
  left: 50%;
  /* centers horizontally */
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 5px 10px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
}

.select-center-control {
  /* text-align: center; */
  justify-content: center;
}

.select-center-value {
  /* text-align: center; */
  width: 100%;
}

.select-center-option {
  /* text-align: center; */
  padding: 8px 0;
}

.select-center-option.is-focused {
  background-color: #f1f1f1;
}

.select-center-option.is-selected {
  background-color: #1e63e9;
  color: #fff;
}

.swiper-button-next::after {
  content: "\\276F" !important;
  font-size: 22px !important;
}

.swiper-button-prev::after {
  content: "\\276E" !important;
  font-size: 22px !important;
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: var(--swiper-navigation-top-offset, 40%) !important;
}

.image-box {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  border: 1px solid #ddd;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  margin-right: 12px;
}

.imageuploadui {
  border: 2px dashed rgb(0, 123, 255);
  border-radius: 12px;
  padding: 30px;
  background-color: #f8f9fa;
  cursor: pointer;
}

.imagepreview {
  width: 20px;
  height: 20px;
  text-align: center;
  cursor: pointer;
  z-index: 2;
}

.uploadedimages {
  height: 150px;
  object-fit: contain;
  width: 100%;
}

.quantitybutton {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f8f9fa;
  /* padding: 6px 12px; */
  width: 110px;
}

.quantityaddsubbutton {
  border: none;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

.quantitytext {
  font-weight: 500;
  font-size: 16px;
}

.profileimage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profileimagecircle {
  width: 60px;
  height: 60px;
  background-color: #007bff;
  /* default color when no image */
  display: flex;
  justify-content: center;
  align-items: center;
}

.profileimagecircle.image-mode {
  background-color: transparent !important;
  /* removes bg when image is present */
  border: 2px solid #007bff;
  /* only show border */
}

/* ✅ Smooth slide-in animation */
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.css-1xc3v61-indicatorContainer {
  display: none !important;
}

.custom-fields-container {
  /* word-break: break-word; */
  max-width: 400px;
}

.custom-fields-container img {
  /* border: 1px solid #ccc; */
  border-radius: 6px;
  padding: 4px;
  background-color: #fff;
}

.custom-cells {
  font-family: "Roboto", sans-serif !important;
  font-size: 15px !important;
  font-weight: 400;
}


[data-sonner-toaster],
[data-sonner-toaster][data-sonner-toaster-position="top-right"] {
  --gap: 5px !important;
  --offset-top: 12px !important;
  --offset-right: 12px !important;
  --offset-bottom: 12px !important;
  --offset-left: 12px !important;
  --mobile-offset-top: 8px !important;
  --mobile-offset-right: 8px !important;
  --mobile-offset-bottom: 8px !important;
  --mobile-offset-left: 8px !important;
}

[data-sonner-toast]>button[data-close-button="true"] {
  position: absolute !important;
  top: 8px;
  right: 8px;
  left: auto !important;
  z-index: 10;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

[data-sonner-toast]>button[data-close-button="true"] svg {
  width: 14px;
  height: 14px;
}

[data-sonner-toast] button[aria-label="Close"] {
  position: absolute !important;
  top: 8px;
  right: 8px;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  font-size: 16px;
  color: #555;
  cursor: pointer;
  opacity: 0.9;
}

[data-sonner-toast] button[aria-label="Close"]:hover {
  color: #000;
  opacity: 1;
  transform: scale(1.1);
}




[data-sonner-toast][data-type="success"] {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

/* ✅ Error Toast (Soft Red) */
[data-sonner-toast][data-type="error"] {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

/* ✅ Info Toast (Soft Blue) */
[data-sonner-toast][data-type="info"] {
  background: #eff6ff;
  color: #1e3a8a;
  border: 1px solid #bfdbfe;
}

/* ✅ Hover effect for premium feel */
[data-sonner-toast]:hover {
  transform: scale(1.02);
  transition: transform 0.2s ease;
}


.shipping-option-card {
  transition: all 0.3s ease;
  border: 2px solid #e9ecef;
}

.shipping-option-card:hover {
  border-color: #0d6efd;
  box-shadow: 0 0.125rem 0.25rem rgba(13, 110, 253, 0.075);
  transform: translateY(-1px);
}

.shipping-option-card.border-primary {
  border-color: #0d6efd !important;
  background-color: rgba(13, 110, 253, 0.05) !important;
  box-shadow: 0 0.125rem 0.25rem rgba(13, 110, 253, 0.15);
}

.shipping-cost .badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input.invoice-sent-checkbox:checked:disabled {
  background-color: #d2f5d2 !important;
  border-color: #368727 !important;
  color: #2a6b2a;
  opacity: 1;
  --vz-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-image: var(--vz-form-check-bg-image) !important;
}

.cursor-pointer {
  cursor: pointer;
}

.transition-all {
  transition: all 0.3s ease;
}

.customizations-header {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  min-height: 60px
}

.customizations-fieldname {
  flex: 0 0 120px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  text-align: left
}

.customizations-fieldimage {
  width: 70px;
  height: 70px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 4px;
  background: #fff
}

.customizations-fonts {
  font-size: 14px;
  color: #555
}

.marker-legend-container {
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 10px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}

.marker-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-radius: 999px;
  background-color: #fff;
  transition: background 0.3s;
  cursor: default;
}

.marker-legend-item:hover {
  background-color: #f0f0f0;
}

.marker-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #999;
  display: inline-block;
}

.dot-finalized {
  background-color: #fdf569;
}

.dot-scheduled {
  background-color: #6993fd;
}

.dot-inprogress {
  background-color: #ff9900;
}

.dot-completed {
  background-color: #00e74c;
}

.dot-cancelled {
  background-color: #e74c3c;
}

.marker-label {
  font-size: 14px;
  font-weight: 500;
  color: #555;
}

.custom-scroll {
  scrollbar-width: none;
  /* Firefox */
}

.custom-scroll::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari */
}

/* #checkoutpopup {
  top: 50px;
  left: 126px !important;
  border-radius: 26px;
} */

/* ===== Desktop base ===== */
#installationoutpopup {
  /* your original offsets */
  top: 50px;
  left: 155px !important;
  width: 100% !important;
  border-radius: 18px;

  /* make modal-content a flex column with capped height */
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 80px);
  overflow: hidden;
  /* header/footer fixed; inner body scrolls */
}

/* Only the inner body/table wrapper scrolls */
#installationoutpopup .modal-body {
  flex: 1 1 auto;
  overflow: hidden;
  /* table wrapper controls scroll */
}

/* Header & footer stick */
#installationoutpopup .modal-header {
  position: sticky;
  top: 0;
  z-index: 3;
  background: var(--bs-body-bg, #fff);
}

#installationoutpopup .modal-footer {
  position: sticky;
  bottom: 0;
  z-index: 3;
  background: var(--bs-body-bg, #fff);
}

/* Search sizing */
#installationoutpopup .search-group {
  width: 320px;
}

/* Table readability */
#installationoutpopup .table {
  border-collapse: separate;
  border-spacing: 0;
}

#installationoutpopup th,
#installationoutpopup td {
  vertical-align: middle;
}

/* wrap ONLY the Product Name column; others stay tight */
#installationoutpopup .td-name {
  white-space: normal;
  word-break: break-word;
}

#installationoutpopup .td-tight {
  white-space: nowrap;
}

/* Ensure both scrollbars appear when needed */
#installationoutpopup .table-responsive {
  overflow-y: auto !important;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

/* ===== Tablet ===== */
@media (min-width: 768px) and (max-width: 1199.98px) {
  #installationoutpopup {
    position: fixed;
    top: 32px !important;
    left: 4% !important;
    width: 92% !important;
    border-radius: 22px;
    max-height: calc(100vh - 64px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    background: var(--bs-body-bg, #fff);
  }

  #installationoutpopup .search-group {
    width: 360px;
  }
}

/* ===== Mobile ===== */
@media (max-width: 767.98px) {
  #installationoutpopup {
    position: fixed;
    top: calc(env(safe-area-inset-top, 0px) + 16px) !important;
    left: 50% !important;
    transform: translateX(-50%);
    width: 94% !important;
    border-radius: 16px;
    max-height: calc(100vh - (env(safe-area-inset-top, 0px) + env(safe-area-inset-bottom, 0px) + 40px));
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
    background: var(--bs-body-bg, #fff);
    padding: 12px;
  }

  #installationoutpopup .search-group {
    width: 100%;
    order: 3;
    /* push under title on small screens */
  }

  #installationoutpopup .modal-title {
    font-size: 18px;
  }

  /* keep columns readable: enforce a minimum table width */
  #installationoutpopup .table {
    min-width: 560px;
  }
}

/* Mobile landscape (short v-height) */
@media (max-width: 767.98px) and (orientation: landscape) {
  #installationoutpopup {
    max-height: calc(100vh - 24px);
  }
}

/* Ultra-small phones */
@media (max-width: 360px) {
  #installationoutpopup {
    width: 96% !important;
    border-radius: 12px;
    padding: 8px;
  }
}


.variant-name {
  font-size: 15px;
}

/* Let the browser size columns by content */
.content-sized-table {
  table-layout: auto;
  /* default, but make it explicit */
  width: 100%;
}

/* Center headers and cells */
.content-sized-table th,
.content-sized-table td {
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  /* keep content on one line so columns can shrink */
}

/* Make a few tiny columns shrink-to-fit */
.content-sized-table col.serial,
.content-sized-table col.image,
.content-sized-table col.sku,
.content-sized-table col.category {
  width: 1%;
  /* forces minimal width based on content */
}

/* horizontal + vertical scrollbar size */
.product-picker-wrap::-webkit-scrollbar {
  height: 8px;
  /* horizontal scrollbar thickness */
  width: 8px;
  /* vertical scrollbar thickness */
}

.product-picker-wrap::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.product-picker-wrap::-webkit-scrollbar-track {
  background: transparent;
}

/* Firefox */
.product-picker-wrap {
  scrollbar-width: thin;
  /* 'auto' | 'thin' | 'none' */
  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
}
@media screen and (max-width: 1021px) {

#newAddressAddmodal {
  left: -3px !important;
  border-radius: 26px;
}
}
@media screen and (min-width: 1022px) {
 #newAddressAddmodal {
  left: 120px !important;
  border-radius: 26px;
}
}


.min-h-50 {
  min-height: 50%;
  max-height: 50%;
  overflow-y: scroll;
  scrollbar-width: thin;
}

/* === Order Stepper (Installation + Removal) =============================== */
/* Card container */
.os-card {
  border: 1px solid var(--bs-border-color, #e9ecef);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(16, 24, 40, .06);
}

/* Grid rail */
.os-line {
  display: grid;
  grid-template-columns: repeat(var(--steps, 6), 1fr);
  gap: 0;
  list-style: none;
  padding-top: 10px;
  margin: 0;
}

/* Step base */
.os-step {
  position: relative;
  text-align: center;
  padding: 18px 8px 6px;
  -webkit-user-select: none;
          user-select: none;
}

/* Connector rail (gray) and fill (blue/red/purple) */
.os-step::before,
.os-step::after {
  content: "";
  position: absolute;
  top: 34px;
  /* center with node */
  height: 2px;
  left: -50%;
  width: 100%;
  z-index: 0;
}

.os-step::before {
  background: #e5e7eb;
}

/* rail */
.os-step::after {
  background: #34c38f;
  /* normal fill */
  transform: scaleX(0);
  transform-origin: left;
  transition: transform .3s ease;
  box-shadow: 0 2px 8px rgba(13, 110, 253, .18);
}

.os-step.is-first::before,
.os-step.is-first::after {
  display: none;
}

.os-step.is-done::after,
.os-step.is-active::after {
  transform: scaleX(1);
}

/* Completed steps should have green connecting lines */
.os-step.is-done::after {
  background: #34c38f;
  box-shadow: 0 2px 8px rgba(52, 195, 143, .18);
}

/* Node (circle) */
.os-node {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: #fff;
  border: 2px solid #d1d5db;
  color: #6b7280;
  box-shadow: 0 2px 6px rgba(16, 24, 40, .05);
  z-index: 1;
  position: relative;
}

.os-step.is-active .os-node {
  border-color: #0d6efd;
  color: #0d6efd;
  background: radial-gradient(ellipse at center, #e6f0ff 0, #fff 55%);
  box-shadow: 0 0 0 6px rgba(13, 110, 253, .12);
}

.os-step.is-done .os-node {
  border-color: #34c38f;
  color: #1b7a55;
  background: #e9fff4;
}

/* Next step styling (blue node but green connecting line) */
.os-step.is-next .os-node {
  border-color: #0d6efd;
  color: #0d6efd;
  background: radial-gradient(ellipse at center, #e6f0ff 0, #fff 55%);
  box-shadow: 0 0 0 6px rgba(13, 110, 253, .12);
}

/* The line before the next step (coming from current) should be green */
.os-step.is-next::before {
  background: #34c38f !important;
  box-shadow: 0 2px 8px rgba(52, 195, 143, .18);
}

/* The line after the next step remains blue */
.os-step.is-next::after {
  background: #0d6efd;
  box-shadow: 0 2px 8px rgba(13, 110, 253, .18);
}

/* Payment variants (applies to the Payment step only) */
.os-step.is-pay-success .os-node {
  /* Paid / Overpaid */
  border-color: #34c38f;
  color: #1b7a55;
  background: #e9fff4;
  box-shadow: 0 0 0 6px rgba(52, 195, 143, .12);
}

.os-step.is-pay-warning .os-node {
  /* Partial Payment */
  border-color: #f0ad4e;
  color: #a26a00;
  background: #fff7e6;
  box-shadow: 0 0 0 6px rgba(240, 173, 78, .12);
}

/* Pending / Awaiting / No payment → neutral (keep default gray ring) */
.os-step.is-pay-neutral .os-node {
  border-color: #d1d5db;
  color: #6b7280;
  background: #fff;
}

/* Completed — only when active or done */
.os-step.is-complete.is-active .os-node,
.os-step.is-complete.is-done .os-node {
  border-color: #34c38f;
  color: #1b7a55;
  background: #e9fff4;
}

/* Terminal states (cancel/void) affect active step underline + node */
.os-step.is-cancel.is-active::after {
  background: #dc3545;
  box-shadow: 0 2px 8px rgba(220, 53, 69, .18);
}

/* Cancelled — only when active */
.os-step.is-cancel.is-active .os-node {
  border-color: #dc3545;
  color: #dc3545;
  background: #fff5f5;
}

.os-step.is-void.is-active::after {
  background: #6f42c1;
  box-shadow: 0 2px 8px rgba(111, 66, 193, .18);
}

/* Void — only when active */
.os-step.is-void.is-active .os-node {
  border-color: #6f42c1;
  color: #6f42c1;
  background: #f6f0ff;
}

/* Labels */
.os-label {
  display: block;
  margin-top: 10px;
  font-weight: 500;
  color: #64748b;
  /* slate-500 */
}

/* Icon size inside node */
.os-node i {
  font-size: 18px;
}

/* Hover (optional) */
.os-step:hover .os-node {
  filter: brightness(0.98);
}

/* Responsive */
@media (max-width:768px) {
  .os-node {
    width: 38px;
    height: 38px;
  }

  .os-step {
    padding: 14px 6px 4px;
  }

  .os-label {
    font-size: .9rem;
  }
}

/* Optional: dark mode tweaks (if you toggle .dark on <html> or <body>) */
.dark .os-card {
  background: #0f1115;
  border-color: #222733;
  box-shadow: none;
}

.dark .os-step::before {
  background: #202736;
}

.dark .os-node {
  background: #0f1115;
  border-color: #2a3242;
  color: #9aa4b2;
}

.dark .os-label {
  color: #95a0ad;
}

.dark .os-step.is-active .os-node {
  background: radial-gradient(ellipse at center, #0f244a 0, #0f1115 55%);
  border-color: #5b8dff;
  color: #85a9ff;
  box-shadow: 0 0 0 6px rgba(91, 141, 255, .12);
}

.dark .os-step.is-done .os-node {
  border-color: #29c08a;
  color: #7be0ba;
  background: #0f1f1a;
}

.dark .os-step.is-next .os-node {
  border-color: #5b8dff;
  color: #85a9ff;
  background: radial-gradient(ellipse at center, #0f244a 0, #0f1115 55%);
  box-shadow: 0 0 0 6px rgba(91, 141, 255, .12);
}

/* Dark mode: line before next step (from current) should be green */
.dark .os-step.is-next::before {
  background: #29c08a !important;
  box-shadow: 0 2px 8px rgba(41, 192, 138, .18);
}

/* Dark mode: line after next step remains blue */
.dark .os-step.is-next::after {
  background: #5b8dff;
  box-shadow: 0 2px 8px rgba(91, 141, 255, .18);
}

.dark .os-step.is-pay-success .os-node {
  border-color: #29c08a;
  color: #7be0ba;
  background: #0f1f1a;
}

.dark .os-step.is-pay-warning .os-node {
  border-color: #e3a23c;
  color: #ffd28a;
  background: #1f1a0f;
}

.dark .os-step.is-cancel .os-node {
  border-color: #ff6b81;
  color: #ff9aaa;
  background: #271318;
}

.dark .os-step.is-void .os-node {
  border-color: #9d7eff;
  color: #c3b6ff;
  background: #1b1630;
}

.dark .os-step.is-active::after {
  box-shadow: 0 2px 8px rgba(91, 141, 255, .18);
}

/* Dark mode: completed steps should have green connecting lines */
.dark .os-step.is-done::after {
  background: #29c08a;
  box-shadow: 0 2px 8px rgba(41, 192, 138, .18);
}

.dark .os-step.is-cancel.is-active::after {
  box-shadow: 0 2px 8px rgba(255, 107, 129, .18);
}

.dark .os-step.is-void.is-active::after {
  box-shadow: 0 2px 8px rgba(157, 126, 255, .18);
}



/* ---used in add installation sections icons core --- */
/* Base */
.section-header {
  --section-accent: var(--bs-primary);
  color: var(--bs-body-color);
}

.section-header--divider {
  border-bottom: 1px solid var(--bs-border-color);
  padding-bottom: .25rem;
}

/* Icon */
.section-header__icon {
  color: var(--section-accent);
  line-height: 1;
}

/* Title */
.section-header__title {
  font-weight: 600;
  letter-spacing: .15px;
}

/* Sizes */
.section-header--sm .section-header__icon i {
  font-size: 18px;
}

.section-header--md .section-header__icon i {
  font-size: 20px;
}

.section-header--lg .section-header__icon i {
  font-size: 22px;
}

.section-header--sm .section-header__title {
  font-size: 1rem;
}

.section-header--md .section-header__title {
  font-size: 1.10rem;
}

.section-header--lg .section-header__title {
  font-size: 1.25rem;
}

/* Bootstrap variant mapping */
.section-header[data-variant="primary"] {
  --section-accent: var(--bs-primary);
}

.section-header[data-variant="success"] {
  --section-accent: var(--bs-success);
}

.section-header[data-variant="info"] {
  --section-accent: var(--bs-info);
}

.section-header[data-variant="warning"] {
  --section-accent: var(--bs-warning);
}

.section-header[data-variant="danger"] {
  --section-accent: var(--bs-danger);
}

.section-header[data-variant="secondary"] {
  --section-accent: var(--bs-secondary);
}


/* 
global css class Names */

.box-shadow {
  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f
}

.box-shadow-datatables {
  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f
}

.shadow-border-datatables {
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background: #fff;
}

.supplier-select {
  height: 37px !important;
}

.supplier-select-r {
  height: 39px !important;
}

.shadow-border-1 {
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background: #fff;
}

.shadow-border-2 {
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #fff;
}

.shadow-border-3 {
  border: 3px solid #e5e7eb;
  border-radius: 20px;
  background: #fff;
}

.surface-btn {
  border-radius: 12px;
  min-width: 90px;
  padding: 8px 16px;
}

.br-gray {
  border: 0.5px solid #80808052
}

.back-btn {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  color: #101828;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
}

.back-btn:hover {
  background: #f9fafb;
  border-color: #d0d5dd;
}

.save-btn {
  background: #155dfc;
  border: 0;
  color: #fff;
  box-shadow: 0 6px 12px rgba(21, 93, 252, 0.20);
  transform: translateY(0);
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;
}

.save-btn:hover {
  color: #fff;
  background-color: #2563eb !important;
  transform: translateY(-3px);
  /* bottom → top */
  box-shadow: 0 12px 20px rgba(21, 93, 252, 0.28);
}

.save-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 8px 14px rgba(21, 93, 252, 0.22);
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.no-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.bg-gray-50 {
  background-color: #fbf9fa
}

.form-select:focus {
  border-color: #c9ced6 !important;
  box-shadow: none !important;
  /* removes blue */
}

.form-select:hover:not(:disabled) {
  background-color: #F5F6FA;
  border-color: #c9ced6;
}

/* square checkbox look to match screenshot */
.square-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 3px !important;
  /* slight rounding like the image */
  border: 1px solid #c8ced6;
  box-shadow: none;
  margin-top: 0;
  /* keep aligned with label baseline */
}

.square-checkbox:focus {
  box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .15);
}

.square-checkbox:checked {
  background-color: #fff;
  /* white box with tick (Bootstrap default) */
  border-color: #5b9bd5;
  /* subtle blue border when checked */
}

/* tighten label look */
.form-check-label {
  font-size: 13px;
  color: #1f2d3d;
}

.form-check-input.square-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 1.5px solid #D0D5DD;
  cursor: pointer;
  transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;
  accent-color: #155dfc;
  background-color: #eaeef5;
  /* modern browsers */
}

.form-check-input.square-checkbox:checked {
  background-color: #155dfc;
  /* fallback */
  border-color: #155dfc;
}

.form-check-input.square-checkbox:focus {
  box-shadow: 0 0 0 .2rem rgba(21, 93, 252, .2);
}

/* Optional: bold label when checked */
.form-check-input.square-checkbox:checked+.form-check-label {
  font-weight: 600;
}

/* Only interactive fields get the hover styling */
/* input.form-control:hover:not(:focus):not([readonly]):not(:disabled),
[role="combobox"]:hover:not(:focus):not([aria-disabled="true"]),
button[role="combobox"]:hover:not(:focus):not([aria-disabled="true"]) {
  background-color: #fafafa;
  transition: background-color .2s ease-in-out, border-color .2s ease-in-out;
  border-color: #9ca3af !important;
} */


/* file upload css */
.border-dashed {
  border-style: dashed
}


/* dropzone behavior */
.dropzone {
  transition: border-color .2s ease, background-color .2s ease, box-shadow .2s ease;
}

.view-cards {
  font-size: 15px;
  font-weight: 500;
}

.dropzone.editable {
  cursor: pointer;
}

.dropzone.disabled {
  cursor: not-allowed;
}

/* hover highlight like your 2nd screenshot */
.dropzone.editable:hover,
.dropzone.editable:focus-within {
  border-color: var(--bs-primary) !important;
  background-color: var(--bs-primary-bg-subtle, rgba(13, 110, 253, .06));
  box-shadow: 0 0 0 .125rem rgba(13, 110, 253, .12);
}

/* thumbnail hover-remove */
.thumb {
  position: relative;
}

.thumb .thumb-remove {
  position: absolute;
  top: -9px;
  right: -7px;
  opacity: 0;
  transition: opacity .15s ease;
  z-index: 1;
}

.thumb:hover .thumb-remove {
  opacity: 1;
}

.image-icons {
  width: 20px;
  height: 20px;
  display: inline-block;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  line-height: 1
}

.image-icons-sub {
  width: 19px;
  height: 19px;
  display: inline-block;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  line-height: 1
}

.order-card {
  box-shadow: 0 4px 6px -1px #0000001a, 0 2px 4px -1px #0000000f;
  background-color: #fff;
  border-radius: .625rem;
  border-width: 1px;
}

.order-tittle {
  font-size: 16px;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
}

.order-card-title {
  font-size: 14px;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
}

.order-card-cells {
  font-size: 17px;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;

}

.order-card-log {
  font-size: 12px;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;

}

.header-color-product {
  font-size: 18px;
  color: #101828;
  font-weight: 400;
}

/* ===== Allocate modal v2 (scoped) ===== */
#allocModalV2 {
  left: auto !important;
  /* neutralize any old left:120px */
  border-radius: 26px;
  display: flex;
  flex-direction: column;
  background: var(--bs-body-bg, #fff);
}

/* Sticky header/footer (stay visible) */
#allocModalV2 .re-alloc__header,
#allocModalV2 .re-alloc__footer {
  position: sticky;
  z-index: 3;
  background: var(--bs-body-bg, #fff);
}

#allocModalV2 .re-alloc__header {
  top: 0;
}

#allocModalV2 .re-alloc__footer {
  bottom: 0;
}

/* Body: the vertical scroller (force scroll even if other CSS tries to override) */
.modal-dialog-scrollable #allocModalV2 .re-alloc__body {
  overflow-y: auto !important;
  /* V scroll */
  overflow-x: hidden;
  max-height: calc(100vh - 160px) !important;
  /* header+footer buffer */
  -webkit-overflow-scrolling: touch;
}

/* Table wrapper: horizontal scrolling only */
#allocModalV2 .re-alloc__tableWrap {
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}

/* Table: keep readable and allow H-scroll on small widths */
#allocModalV2 .re-alloc__table {
  border-collapse: separate;
  border-spacing: 0;
  min-width: 720px;
  /* triggers H-scroll when viewport is narrow */
}

#allocModalV2 th,
#allocModalV2 td {
  vertical-align: middle;
  white-space: nowrap;
}

#allocModalV2 td:first-child {
  white-space: normal;
  /* Serial No. can wrap if long */
  word-break: break-word;
}

/* React-Select (scoped via classNamePrefix="allocV2") */
#allocModalV2 .allocV2__control {
  min-height: 40px;
  border-radius: 8px;
}

#allocModalV2 .allocV2__value-container {
  padding: 2px 8px;
}

#allocModalV2 .allocV2__menu,
.allocV2__menu-portal {
  z-index: 99999 !important;
}

/* sit above modal + sticky table header */

#allocModalV2 .re-alloc__table thead.sticky-top {
  z-index: 2;
}

/* Add Brokerage Teammember modal — narrower width + scrollable body */

.brokerage-teammember-add-modal-content {
 left :125px !important
}
.brokerage-teammember-add-modal {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
  overflow: hidden !important;
  overflow-y: hidden !important;
}

.brokerage-teammember-add-modal .brokerage-teammember-add-modal-dialog {
  max-width: 900px;
  width: 100%;
  margin: 0;
  max-height: calc(100vh - 2rem) !important;
  height: calc(100vh - 2rem) !important;
  min-height: 0 !important;
  display: flex;
  flex-direction: column;
}

.brokerage-teammember-add-modal .brokerage-teammember-add-modal-content {
  max-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.brokerage-teammember-add-modal .brokerage-teammember-add-modal-body {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
}

.brokerage-teammember-add-modal .modal-dialog-scrollable .brokerage-teammember-add-modal-body {
  overflow-y: scroll !important;
}

.brokerage-teammember-add-modal .brokerage-teammember-add-modal-body .brokerage-teammember-creation-embedded {
  padding: 1rem 1.25rem 1.5rem;
}

@media (max-width: 767.98px) {
  /* Mobile: right-side drawer panel */
  .brokerage-teammember-add-modal {
    justify-content: flex-end !important;
    align-items: stretch !important;
    padding: 0 !important;
  }

  .brokerage-teammember-add-modal .brokerage-teammember-add-modal-dialog {
    max-width: min(92vw, 420px);
    width: min(92vw, 420px);
    margin: 0 !important;
    margin-left: auto !important;
    max-height: 100vh !important;
    height: 100vh !important;
    min-height: 100vh !important;
    animation: brokerage-teammember-drawer-in 0.28s ease-out forwards;
  }

  .brokerage-teammember-add-modal.fade .brokerage-teammember-add-modal-dialog,
  .brokerage-teammember-add-modal.show .brokerage-teammember-add-modal-dialog {
    transform: translate3d(0, 0, 0) !important;
  }

  .brokerage-teammember-add-modal .brokerage-teammember-add-modal-content {
    height: 100%;
    max-height: 100vh;
    border-radius: 14px 0 0 14px;
    border-right: none;
  }

  .brokerage-teammember-add-modal .brokerage-teammember-add-modal-body {
    overflow-y: scroll !important;
    -webkit-overflow-scrolling: touch;
  }

  .brokerage-teammember-add-modal
    .brokerage-teammember-add-modal-body
    .brokerage-teammember-creation-embedded {
    padding: 0.75rem 1rem 1.25rem;
  }
}

@keyframes brokerage-teammember-drawer-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* ===== Tablet ===== */
@media (min-width: 768px) and (max-width: 1199.98px) {
  .modal-dialog.modal-xl {
    max-width: 960px;
  }

  .modal-dialog-scrollable #allocModalV2 .re-alloc__body {
    max-height: calc(100vh - 140px) !important;
  }
}

/* ===== Mobile ===== */
@media (max-width: 767.98px) {
  .modal-dialog.modal-xl {
    margin: 0 auto;
    max-width: 94%;
  }

  #allocModalV2 {
    border-radius: 16px;
  }

  #allocModalV2 .re-alloc__table {
    min-width: 560px;
  }

  /* keep columns readable */
  .modal-dialog-scrollable #allocModalV2 .re-alloc__body {
    max-height: calc(100vh - (env(safe-area-inset-top, 0) + env(safe-area-inset-bottom, 0) + 120px)) !important;
  }
}

/* Mobile landscape (short screens) */
@media (max-width: 767.98px) and (orientation: landscape) {
  .modal-dialog-scrollable #allocModalV2 .re-alloc__body {
    max-height: calc(100vh - 96px) !important;
  }
}




/* datatables most importent css */



/* =========================
   Responsive Data Table CSS
   ========================= */

/* Scroll wrapper for desktop/tablet */
/* ===== Horizontal scrollbar skin (matches your screenshot) ===== */
.production-scroll {
  position: relative;
  overflow-x: auto;
  overflow-y: visible;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;

  /* keep a little room so the pill isn't glued to the bottom edge */
  padding-bottom: 6px;

  /* Firefox fallback */
  scrollbar-width: thin;
  scrollbar-color: #c9ced6;
  /* scrollbar-color: #9fb6e9 #eaf2ff;
   */
  /* thumb track */
}

/* WebKit (Chrome/Edge/Safari) */
.production-scroll::-webkit-scrollbar {
  height: 10px;
  /* thickness of the bar */
}

.production-scroll::-webkit-scrollbar-track {
  background: #eaf2ff;
  /* soft blue track */
  border-radius: 999px;
  /* fully rounded */
  margin: 0 10px;
  /* inset from left/right to show curved ends */
}

.production-scroll::-webkit-scrollbar-thumb {
  background: #9fb6e9;
  /* thumb color */
  border-radius: 999px;
  border: 2px solid #eaf2ff;
  /* creates that “pill inset” look */
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .35);
}

.production-scroll::-webkit-scrollbar-thumb:hover {
  background: #8fb0ea;
  /* slight hover brighten */
}

.production-scroll::-webkit-scrollbar-thumb:active {
  background: #6e9ded;
  /* pressed */
}

/* Make the pill visually sit inside the table’s rounded container */
.production-scroll {
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  background-clip: padding-box;
  margin-bottom: 13px;
}

/* .table-1>:not(caption)>*>* {
  padding: 1.75rem .6rem !important;
} */

/* ===== Table sizing so the bar actually appears ===== */
/* Fill wide containers, but force overflow on smaller ones via min-width */
.production-table {
  width: 100% !important;
  min-width: 1100px;
  /* tweak this to taste */
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0;
}

/* Sticky header */
.production-thead {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f6f8fb;
}

.production-th {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1f2937;
  padding: 16px 24px;
  border: 0;
  white-space: nowrap;
  /* prevent wrapping so columns take full width */
}

.production-th .table-headers {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: inherit;
  color: inherit;
}

.production-td .table-cells {
  display: block;
  width: 100%;
  text-align: center;
}

.text-sm {
  font-size: 0.875rem;
  color: "#364153";
  font-family: "Roboto", sans-serif;
}

/* Body cells */
.production-td {
  padding: 10px 8px !important;
  border: 0;
  vertical-align: middle;
  white-space: nowrap;
  /* default: no wrap = table expands -> scroll appears */
}

.production-tr:not(:last-child) .production-td {
  box-shadow: inset 0 -1px 0 #eef2f6;
}

/* If you want a specific cell to wrap (e.g., email/product),
   add className="rdt-wrap" to that cell’s renderer. */
.rdt-wrap {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.form-check-input {
  background-color: #e9ebec;
}

/* Common inline bits */
.order-link-1 {
  color: #155dfc;
  /* font-weight: 700; */
  /* text-decoration: none; */
}

.order-link:hover {
  text-decoration: underline;
}

.email-muted {
  color: #8a94a6;
}

/* Action buttons */
.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e5eaf0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 0 rgba(0, 0, 0, .02);
  color: #111827;
}

.action-btn:hover {
  background: #e9ebef;
  border-color: #cbd5e1;
}

/* Keep react-select menus above sticky header when used inside cells */
.production-scroll .rs__menu {
  z-index: 50;
}

.view-value {
  font-size: 18px;
  color: #495363;
}

/* images uploadbutton */

/* soft rounded outline button like the screenshot */
.upload-btn {
  height: 38px;
  /* close to your image */
  padding: 0 16px;
  border: 1.5px solid #d6dbe6;
  /* light gray outline */
  border-radius: 11px;
  /* rounded corners */
  background: #fff;
  color: #1f2937;
  /* dark slate text */
  font-weight: 600;
  /* semi-bold label */
  box-shadow: 0 2px 6px rgba(15, 23, 42, .08);
  /* soft shadow */
  line-height: 38px;
  /* vertically center text */
}

.upload-btn:hover {
  border-color: #c3cbda;
  box-shadow: 0 3px 10px rgba(15, 23, 42, .12);
}

.upload-btn:active {
  transform: translateY(1px);
}

.upload-btn:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, .15), 0 2px 6px rgba(15, 23, 42, .08);
}

.view-circle {
  background-color: #2b7fff;
  color: #fff
}

/* Entity profile header card (team member / agent / brokerage view pages) */
.re-profile-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04);
  padding: 26px 32px;
  margin-bottom: 22px;
}

.re-profile-card__top {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding-bottom: 22px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 22px;
}

.re-profile-card__top--no-fields {
  padding-bottom: 0;
  border-bottom: none;
  margin-bottom: 0;
}

.re-profile-card__avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #3b6fe8;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  flex-shrink: 0;
  overflow: hidden;
}

.re-profile-card__avatar--image {
  background: transparent;
  border-radius: 0;
}

.re-profile-card__avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.re-profile-card__id {
  flex: 1 1;
  min-width: 0;
  padding-top: 2px;
}

.re-profile-card__name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.re-profile-card__name {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  line-height: 1.2;
}

.re-profile-card__subtitle {
  font-size: 13px;
  color: #6b7280;
  margin-top: 3px;
}

.re-profile-card__status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 500;
  color: #111827;
}

.re-profile-card__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #059669;
  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.16);
  flex-shrink: 0;
}

.re-profile-card__dot--inactive {
  background: #9ca3af;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.16);
}

.re-profile-card__edit-btn {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #3b6fe8;
  transition: background 0.15s;
  text-decoration: none;
  line-height: 0;
}

.re-profile-card__edit-btn svg {
  display: block;
  width: 16px;
  height: 16px;
}

.re-profile-card__edit-btn:hover {
  background: #f3f6ff;
  color: #3b6fe8;
}

.re-profile-card__fields {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px 40px;
}

.re-profile-card__label {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  letter-spacing: 0.2px;
  margin-bottom: 5px;
}

.re-profile-card__value {
  font-size: 15px;
  color: #495363 !important;
  font-weight: 400;
  word-break: break-word;
}

.re-profile-card__value.empty {
  color: #495363 !important;
}

.re-profile-card__link {
  color: #495363 !important;
  text-decoration: none;
}

.re-profile-card__link:hover {
  color: #3b6fe8 !important;
  text-decoration: underline;
}

@media (max-width: 720px) {
  .re-profile-card {
    padding-left: 18px;
    padding-right: 18px;
  }

  .re-profile-card__fields {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 480px) {
  .re-profile-card__fields {
    grid-template-columns: 1fr;
  }
}

/* =========================
   MOBILE CARD VIEW
   ========================= */
.po-card {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 8px 20px rgba(2, 6, 23, .06);
}

/* Top-right actions (supports multiple buttons) */
.po-card-actions {
  align-items: center;
}

.po-card-actions>* {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Stacked fields: label above value */
.po-field {
  padding: 10px 0;
  border-top: 1px solid #eef2f6;
}

.po-field:first-child {
  border-top: 0;
  padding-top: 0;
}

.po-field-label {
  color: #64748b;
  font-size: .9rem;
  line-height: 1.2;
  margin-bottom: 6px;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.po-field-value {
  color: #0f172a;
  /* font-weight: 600; */
  line-height: 1.35;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.po-header {
  position: relative;
  background: #fff;
  border: 1px solid #e9edf2;
  border-radius: 14px;
  padding: 18px 20px;
  border-left: 6px solid #2563eb;
  /* box-shadow: 0 8px 20px rgba(2, 6, 23, 0.06); */
  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;
}


.po-title-search {
  color: #0b1320;
  font-size: 16px;
}

/* Title + subtitle */
.po-title {
  /* font-weight: 800; */
  color: #101828;
  letter-spacing: -0.2px;
}

.po-subtitle {
  font-size: 0.95rem;
  color: #4a5565;
  margin-top: 2px;
}

/* Pill search (double-ring feel, soft bg, icon on the left) */
.po-search {
  height: 42px;
  border-radius: 12px;
  overflow: hidden;
  background: #f3f3f5;
  border-color: #d1d5dc;
  box-shadow:
    inset 0 0 0 2px #c9ced6,
    0 8px 20px rgba(2, 6, 23, .06);
}

.po-search .input-group-text {
  background: transparent;
  border: none;
  padding: 8px 10px 8px 12px;
  color: #7587a3;
  display: flex;
  align-items: center;
}

.po-search .form-control {
  border: none !important;
  background: transparent;
  padding: 8px 12px 8px 0;
  font-weight: 500;
  color: #0f172a;
}

.po-search .form-control::placeholder {
  color: #99a1af;
}

.po-search:focus-within {
  box-shadow:
    inset 0 0 0 2px #93c5fd,
    /* blue ring on focus */
    0 0 0 4px rgba(59, 130, 246, .14),
    /* subtle glow */
    0 8px 20px rgba(2, 6, 23, .06);
}

/* Make sure input height stays pill-perfect across browsers */
.po-search .form-control,
.po-search .input-group-text {
  height: 42px;
  line-height: 42px;
}


/* Footer bar container (rounded, subtle shadow & border like screenshot) */
/* .po-pagination {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  padding: 10px 14px;
  box-shadow: 0 8px 20px rgba(2, 6, 23, 0.06);
  font-size: 0.9rem;
} */

/* left text */
.po-range {
  color: #1f2937;
  /* slate-800 */
}

/* "Rows per page:" label in blue like ref */
.po-rows-label {
  color: #3e434d;
  white-space: nowrap;
  /* font-weight: 600; */
}

/* pill-like select */
.po-page-size {
  /* height: 36px; */
  /* line-height: 36px;
  padding: 4px 32px 4px 10px; */
  border-radius: 10px;
  border: 1px solid #d1d8e2;
  background-color: #ffffff;
  box-shadow: inset 0 0 0 1px #d1d8e2;
  font-weight: 600;
}

.po-page-size:focus {
  border-color: #93c5fd;
  box-shadow:
    inset 0 0 0 1px #93c5fd,
    0 0 0 4px rgba(59, 130, 246, 0.14);
}

/* nav buttons */
.po-nav .po-btn {
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #6b7280;
  /* gray-500 */
  font-weight: 600;
}

.po-nav .po-btn:hover:not(:disabled) {
  border-color: #cfd7e3;
  background: #f8fafc;
  color: #374151;
}

.po-nav .po-btn:disabled {
  opacity: .55;
  cursor: not-allowed;
}

/* current page pill (blue rounded square, white text) */
.po-nav .po-page {
  height: 36px;
  min-width: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #111827;
  font-weight: 700;
}

.po-nav .po-page.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15) inset;
}

.page-item.disabled .page-link:disabled {
  pointer-events: none;
  opacity: .65;
}

.label-1 {
  font-weight: 300 !important;
}

.clear-button {
  border-radius: 7px !important;
}

.pagination-button {
  background-color: #2563eb !important;
  border: 1px solid #2563eb !important;
}

/* keep the whole right area on one line */
.po-pagination>.d-flex {
  flex-wrap: nowrap;
}

/* (optional) if any global styles force wrapping inside buttons/selects */
.po-page-size,
.po-btn,
.po-page {
  white-space: nowrap;
}

.preview-buttons {
  font-weight: 100 !important;
}

/* Outer container: same rounded white card feel */
.po-pagination {
  /* background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 12px; */
  padding: 12px 14px;
  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;

  /* NEW: grid for bulletproof responsiveness */
  display: grid;
  grid-template-columns: 1fr auto;
  /* range | actions */
  align-items: center;
  gap: 12px;
}


/* Range text */
.po-range {
  color: #1f2937;
}

/* Right side cluster */
.po-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  min-width: 0;
}

/* Rows-per-page (kept on one line) */
.rows-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  min-width: max-content;
}

/* .po-page-size {
  height: 36px;
  line-height: 36px;
  padding: 2px 32px 2px 10px;
  border-radius: 10px;
  border: 1px solid #d1d8e2;
  background: #fff;
  box-shadow: inset 0 0 0 1px #d1d8e2;
  font-weight: 600;
} */

.po-page-size:focus {
  border-color: #93c5fd;
  box-shadow: inset 0 0 0 1px #93c5fd, 0 0 0 4px rgba(59, 130, 246, .14);
}

/* Pager buttons */
.po-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.po-btn {
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #6b7280;
  font-weight: 600;
}

.po-btn:hover:not(:disabled) {
  border-color: #cfd7e3;
  background: #f8fafc;
  color: #374151;
}

.po-btn:disabled {
  opacity: .55;
  cursor: not-allowed;
}

.po-page {
  height: 36px;
  min-width: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #111827;
  font-weight: 700;
}

.po-page.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, .15) inset;
}

/* ===== Responsive ===== */

/* Tablets and down (≤ 768px): keep two rows, actions on the second row right-aligned */
@media (max-width: 768px) {
  .po-pagination {
    grid-template-columns: 1fr;
    /* single column */
    grid-auto-rows: minmax(0, auto);
  }

  .po-range {
    text-align: center;
    /* like your screenshot */
  }

  .po-actions {
    width: 100%;
    justify-content: flex-end;
    /* controls stay on the right */
    flex-wrap: wrap;
    /* if too tight, lines wrap cleanly */
    gap: 10px 12px;
  }

  .po-page-size,
  .po-btn,
  .po-page {
    height: 34px;
    border-radius: 8px;
    /* slightly smaller controls */
  }
}

/* Extra small phones (≤ 400px): rows-group and pager still align right */
@media (max-width: 400px) {
  .rows-group {
    order: 2;
  }

  /* pager first if you prefer: set order:1 here */
  .po-nav {
    order: 1;
  }
}



/* Desktop table row hover */
.table-row-hover {
  transition: background-color .15s ease, box-shadow .15s ease;
}

.table-row-hover:hover {
  background-color: #f7f8fb;
  /* subtle gray like your screenshot */
  box-shadow: inset 0 0 0 1px #eef2f7;
  /* faint inner border to “lift” the row */
}

/* Mobile: card-style rows (≤1021px) */
@media (max-width: 1021px) {
  .mobile-row-card {
    transition: background-color .15s ease, box-shadow .15s ease;
  }

  .mobile-row-card:hover {
    background-color: #f7f8fb;
    box-shadow: inset 0 0 0 1px #eef2f7;
  }
}




/* fillter expand css */

/* header card (you already use this) */
/* .po-header {
  position: relative;
  background: #fff;
  border: 1px solid #e9edf2;
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: 0 8px 20px rgba(2, 6, 23, .06);
} */

/* .po-header::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 6px;
  background: linear-gradient(180deg, #3b82f6 0%, #60a5fa 100%);
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
} */

/* Title + subtitle */
/* .po-title {
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -.2px;
} */

.po-subtitle {
  font-size: .95rem;
  color: #64748b;
}

/* tools area */
.po-tools {
  display: flex;
  align-items: center;
  gap: 12px;
}


.po-search {
  flex: 0 0 360px;
  /* don't grow; fixed-ish width */
  width: 360px;
}

@media (min-width: 1200px) {
  .po-search {
    flex-basis: 345px;
    width: 420px;
  }
}

/* Tablets & phones: stack and make search full-width */
@media (max-width: 992px) {
  .po-tools {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .po-search {
    flex: 1 1 100%;
    width: 100%;
  }

  .po-tools .btn {
    width: 100%;
    justify-content: center;
  }
}

/* filter toggle */
.po-filter-btn {
  height: 42px;
  border-radius: 12px;
  border-color: #d5deeb;
  background: #fff;
}

.po-filter-btn.active,
.po-filter-btn:focus {
  border-color: #93c5fd;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, .14);
}

.po-filter-btn .ri-filter-3-line {
  color: #2563eb;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform .2s ease;
}

/* collapsible panel */
.po-filters {
  border-top: 1px solid #eef2f6;
  margin-top: 12px;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height .25s ease, opacity .25s ease;
}

.po-filters.show {
  max-height: 260px;
  opacity: 1;
}

/* Brokerage teammembers filter: menu opens below select inside panel (same as Agents) */
.po-header:has(#brokerage-teammembers-filters.show) {
  overflow: visible;
  z-index: 10;
}

#brokerage-teammembers-filters.show {
  overflow: visible;
  max-height: 420px;
}

#brokerage-teammembers-filters.show .po-filters-bar {
  overflow: visible;
}

.brokerage-teammember-firm-select {
  position: relative;
  z-index: 20;
  width: 220px;
  max-width: 100%;
}

.brokerage-teammember-firm-select > div {
  width: 220px;
  max-width: 100%;
}

.brokerage-teammember-firm-select .rs__menu {
  z-index: 9999 !important;
}

.po-filters-bar {
  background: #f8fafc;
  border-radius: 12px;
  padding: 14px;
  margin-top: 12px;
}

/* make selects consistent height */
.po-filters .form-select {
  height: 40px;
  border-radius: 10px;
}

/* Default: mobile visible, desktop hidden */
.rdt-mobile {
  display: block;
}

.rdt-desktop {
  display: none;
}

/* ≥ 1022px: desktop visible, mobile hidden */
@media (min-width: 1022px) {
  .rdt-mobile {
    display: none;
  }

  .rdt-desktop {
    display: block;
  }
}

@media (max-width: 992px) {
  .po-filters.show {
    max-height: 100%;
  }
}

/* Ensure dropdowns don't get clipped and fit at mobile sizes */
@media (max-width: 576px) {
  .supplier-actions-grid {
    width: 100%;
  }

  .po-card,
  .po-field,
  .po-field-value {
    overflow: visible;
  }

  .po-select,
  .po-notes {
    width: 100% !important;
    max-width: 100%;
  }
}

/* keep pill look */
.po-select {
  height: 38px;
  line-height: 36px;
  border-radius: 12px;
  border: 1px solid #cfe3ff;
  background: #f8fbff;
  padding: 4px 32px 4px 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, .02);
}

.po-notes {
  min-height: 40px;
  border-radius: 12px;
  border: 1px solid #d1d8e2;
}

/* focus ring on top of base Bootstrap shadow */
.bs-focus-ring {
  box-shadow:
    0 1px 2px rgba(0, 0, 0, .05);
  /* fallback base */
  transition: box-shadow .2s ease;
}

.bs-focus-ring.is-focused {
  box-shadow:
    0 0 0 var(--bs-focus-ring-width, .25rem) rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity, .25)),
    var(--bs-box-shadow, 0 1px 2px rgba(0, 0, 0, .05));
}

/* brokerage data table css */

/* License buttons */
.license-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .5rem;
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1;
  border: 1px solid transparent;
  box-shadow: 0 1px 2px rgba(16, 24, 40, .08);
}

.license-activate {
  background-color: #155dfc;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.license-activate:hover {
  background-color: #1447e6;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
}

.license-deactivate {
  background: #fff;
  /* white + red outline */
  color: #ef4444;
  border-color: #fca5a5;
}

.license-deactivate:hover {
  border-color: #fef2f2;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, .12);
  color: #030213;
}

/* Status dot (uses your radio input – visually a dot) */
.status-radio {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 999px;
  border: 2px solid transparent;
  margin: 0;
  /* keep perfectly centered */
  background: #e5e7eb;
}

.status-radio-active {
  background: #10b981;
  /* green */
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, .15);
}

.status-radio-inactive {
  background: #99a1af;
  /* muted gray */
  border-color: #99a1af;
}

.ri-search-line:before {
  content: "\\f0d1";
  color: blue;
}

/* Square icon buttons */
.icon-square {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #0b1320;
  box-shadow: 0 1px 2px rgba(16, 24, 40, .06);
  transition: background .15s, box-shadow .15s, border-color .15s;
}


.icon-square.danger {
  color: #ef4444;
  /* border-color: #fca5a5; */
  padding: 15px;
}

.icon-square.cancel {
  color: #dc2626;
  background: #fef2f2;
  border-color: #fecaca;
  padding: 15px;
}

.icon-square:hover {
  background: #e9ebef;
}

.icon-square.danger:hover {
  /* border-color: #ef4444; */
  color: #000;
  background-color: #fef2f2;
}

.icon-square.cancel:hover {
  color: #b91c1c;
  background: #fee2e2;
  border-color: #fca5a5;
}



.table-addbutton {
  background-color: #155dfc;
  color: #fff;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.table-addbutton:hover {
  background-color: #1447e6;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.icon-square1 {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #0b1320;
  box-shadow: 0 1px 2px rgba(16, 24, 40, .06);
  transition: background .15s, box-shadow .15s, border-color .15s;
}

.icon-square1:hover {
  background: #f8fafc;
}

.icon-square1.danger {
  color: #ef4444;
  border-color: #fca5a5;
}

.icon-square1.danger:hover {
  border-color: #ef4444;
}

#incoming-filters,
#incoming-filters .po-filters,
#incoming-filters .po-filters-bar,
#incoming-filters .po-title-wrap {
  overflow: visible !important;
}

/* Batch Invoice filters: keep Payment/Status menus above the table UI */
.po-header:has(#batch-payment-filters.show) {
  overflow: visible;
  z-index: 10;
}

#batch-payment-filters,
#batch-payment-filters.po-filters,
#batch-payment-filters .po-filters-bar {
  overflow: visible !important;
}

#batch-payment-filters.show {
  max-height: 420px;
  opacity: 1;
}

.pi-badge {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pi-icon {
  width: 16px;
  height: 16px;
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
  mask-position: center;
}

.upload-tile {
  width: 88px;
  height: 88px;
  border: 2px dashed #d0d5dd;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: background .15s ease, border-color .15s ease, box-shadow .15s ease;
}

.upload-tile:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  box-shadow: 0 1px 6px rgba(16, 24, 40, .06);
}

.upload-ghost {
  border: 1px solid #d0d5dd;
  background: #fff;
  border-radius: 10px;
  font-weight: 600;
  padding: 8px 14px;
}

.upload-ghost:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}



.wrap-anywhere {
  max-width: clamp(160px, 22vw, 420px);
  /* adjust once, used everywhere */
  white-space: normal;
  /* allow wrapping */
  overflow-wrap: anywhere;
  /* break long tokens (no spaces) */
  word-break: break-word;
  /* legacy fallback */
  line-height: 1.25;
}

.wrap-anywhere1 {
  white-space: normal;
  max-width: 100%;
  /* allow wrapping */
  overflow-wrap: anywhere;
  /* break long tokens (no spaces) */
  word-break: break-word;
  /* legacy fallback */
  line-height: 1.25;
}

/* Base square */
.sqbtn {
  --sq-size: 28px;
  --sq-radius: 8px;
  --sq-inset: 3px;

  /* defaults (overridden by variant classes) */
  --sq-icon-color: #0A0A0A;
  --sq-border: #E5E7EB;
  /* --sq-hover-fill: #F1F5F9; */

  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: var(--sq-size);
  height: var(--sq-size);
  border-radius: var(--sq-radius);

  background: #fff;
  border: 1px solid var(--sq-border);
  color: var(--sq-icon-color);
  padding: 0;
  text-decoration: none;
  overflow: hidden;
  transition: border-color .12s ease;
}

.sqbtn::after {
  content: "";
  position: absolute;
  inset: var(--sq-inset);
  border-radius: calc(var(--sq-radius) - 2px);
  background: var(--sq-hover-fill);
  opacity: 0;
  transition: opacity .12s ease;
  z-index: 0;
}

.sqbtn:hover::after {
  opacity: 1;
}

.sqbtn:hover {
  border-color: #D1D5DB;
}

.sqbtn__icon {
  position: relative;
  z-index: 1;
  line-height: 0;
  display: inline-flex;
}


.sqbtn:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, .18);
  border-color: #cbd5e1;
}

.sqbtn[disabled] {
  opacity: .6;
  cursor: not-allowed;
}

/* Variants */
.sqbtn--neutral {
  --sq-icon-color: #0A0A0A;
  --sq-border: #E5E7EB;
  /* --sq-hover-fill: #F1F5F9; */
  padding: 15px;
  /* gray hover for view/edit */
}

.sqbtn--neutral:hover {
  background: #e9ebef;
  /* --sq-hover-fill: #F1F5F9; */
  padding: 15px;
  /* gray hover for view/edit */
}

.sqbtn--danger {
  --sq-icon-color: #DC2626;
  /* red icon */
  --sq-border: #F3D4D4;
  /* red border tint */
  padding: 15px;
  /* red inner fill on hover */
}

.sqbtn--danger:hover {
  background: #fef2f2;
  padding: 15px;
  color: #000
    /* red inner fill on hover */
}

.sqbtn--cancel {
  --sq-icon-color: #DC2626;
  --sq-border: #FECACA;
  background: #fef2f2;
  padding: 15px;
}

.sqbtn--cancel:hover {
  background: #fee2e2;
  border-color: #FCA5A5;
  color: #B91C1C;
}

.S-No {
  padding-left: 20px;
}

.S-No-V {
  padding-left: 17px;
}

.custombutton.rc-tab-active,
.rc-tab.custombutton.rc-tab-active {
  background-color: #f97316 !important;
  /* your blue */
  color: #fff !important;
  box-shadow: 0 1px 28px rgba(37, 99, 235, .35);
  border-radius: 12px;
  /* pill look */
}

.imagebutton.rc-tab-active,
.rc-tab.imagebutton.rc-tab-active {
  background-color: #8b5cf6 !important;
  /* your blue */
  color: #fff !important;
  box-shadow: 0 1px 28px rgba(37, 99, 235, .35);
  border-radius: 12px;
  /* pill look */
}

/* ACTIVE */
.detailsbutton.rc-tab-active,
.rc-tab.detailsbutton.rc-tab-active {
  background-color: #2563eb !important;
  /* your blue */
  color: #fff !important;
  box-shadow: 0 1px 28px rgba(37, 99, 235, .35);
  border-radius: 12px;
  /* pill look */
}


/* Card shell */
.gall-card {
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(2, 6, 23, .06);
  padding: 2px;
}

/* Big light area + subtle white base at bottom (like your ref) */
.gall-main {
  position: relative;
  /* background: #f6f8fb; */
  border-radius: 16px;
  min-height: 520px;
  /* tweak 480–560 if you want */
  display: grid;
  place-items: center;
  overflow: hidden;
}

.gall-main::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 14px;
  background: #fff;
  /* white strip at bottom */
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  box-shadow: 0 -1px 0 rgba(2, 6, 23, .03) inset;
}

/* Swiper inside the light area */
.gall-swiper {
  width: 100%;
  height: 100%;
}

.gall-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  margin: auto;
  border-radius: 14px;
}

/* Hide default nav arrows (your ref shows none) */
.swiper-button-next,
.swiper-button-prev {
  display: none !important;
}

/* Thumbs row */
.gall-thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  padding: 14px 4px 14px;
}

/* Individual thumb */
.gall-thumb {
  width: 80px;
  height: 80px;
  padding: 6px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  box-shadow: 0 8px 18px rgba(2, 6, 23, .08);
  display: grid;
  place-items: center;
  transition: transform .15s ease;
  overflow: hidden;
  flex-shrink: 0;
}

.gall-thumb:hover {
  transform: translateY(-2px);
}

.gall-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
  display: block;
}

/* Active thumb with strong blue ring, like your first image */
.gall-thumb.is-active {
  outline: 3px solid #3b82f6;
  /* blue */
  outline-offset: 0;
}

/* Header styles */
.p2-name {
  font-size: 1.2rem;
  font-weight: 400;
  color: #101828;
  margin: 0 0 6px
}

.bg-colors {
  background-color: #155dfc !important;
}

.p2-price {
  color: #00a63e;
  font-size: 26px;
  font-weight: 800;
  line-height: 1
}

.p2-sku {
  color: #6b7280;
  font-size: 14px;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* Badges */
.p2-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 9999px;
  font-weight: 500;
  font-size: 12px;
  border: 1px solid transparent
}

.p2-pill-review {
  background: #fff7ed;
  border-color: #f6d8b0;
  color: #b45309
}

.p2-pill-stock {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46
}

.p2-pill-popular {
  background: #fff7ed;
  border-color: #fde2c7;
  color: #b45309
}

/* Card */
.p2-card {
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(2, 6, 23, .06)
}

.p2-card-title {
  font-weight: 500;
  color: #111827;
  font-size: 20px;
}

/* Attributes line (label left, control/value right) */
.p2-fieldrow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px
}

.p2-fieldlabel {
  color: #6b7280;
  font-weight: 600
}

.p2-select {
  min-width: 140px;
  height: 38px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0 10px;
  background: #fff;
  color: #111827;
  font-weight: 600
}

.p2-attrval {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 10px;
  background: #eef2f7;
  color: #111827;
  font-weight: 500
}

/* Customization fields */
.p2-label {
  display: block;
  font-weight: 700;
  font-size: 14px;
  color: #111827;
  margin-bottom: 6px
}

.p2-input {
  height: 44px;
  border-radius: 12px;
  background: #f6f7fb;
  border: 1px solid #e5e7eb;
  color: #111827
}

.p2-input:focus {
  background: #fff;
  border-color: #3b82f6;
  box-shadow: none
}

.p2-input.is-invalid {
  border-color: #ef4444 !important;
  background: #fff
}

.p2-error {
  margin-top: 4px;
  font-size: 12px;
  color: #ef4444
}

/* File input row like screenshot */
.p2-file {
  width: 100%;
  height: 44px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  color: #ef4444;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700
}

.p2-file.is-invalid {
  border-color: #ef4444
}

/* Card shell */
.desc-card {
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 18px;
  box-shadow: 0 12px 30px rgba(2, 6, 23, .06);
  padding: 18px;
  margin-top: 18px
}

.desc-title {
  font-weight: 700;
  color: #111827;
  margin-bottom: 10px
}

/* Pill tab bar */
.desc-tabbar {
  background: #eef2f7;
  border-radius: 9999px;
  padding: 6px;
  display: inline-flex;
  gap: 8px
}

.desc-tab {
  border: 0;
  background: transparent;
  border-radius: 9999px;
  padding: 8px 18px;
  font-weight: 700;
  color: #6b7280;
  position: relative
}

.desc-tab.is-active {
  background: #fff;
  color: #1d4ed8;
  box-shadow:
    0 1px 3px rgba(2, 6, 23, .08),
    inset 0 0 0 2px #dbeafe,
    /* inner ring */
    inset 0 0 0 4px #e5e7eb;
  /* second ring for double outline look */
}

/* Body spacing */
.desc-body {
  margin-top: 18px
}

/* Specs table */
.desc-key {
  color: #6b7280;
  font-weight: 700;
  white-space: nowrap;
  width: 220px
}

.desc-val {
  color: #111827
}

.table> :not(caption)>*>* {
  border-bottom-color: #eef2f7
}

/* Details defaults */
.desc-details .desc-subtitle {
  font-weight: 700;
  margin-bottom: 6px
}

.desc-list {
  margin: 0;
  padding-left: 1.2rem
}

.desc-list li {
  margin: 4px 0
}

.desc-details-html p {
  margin-bottom: 10px
}

/* Reviews list */
.desc-reviews {
  display: flex;
  flex-direction: column;
  gap: 16px
}

.desc-review {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  box-shadow: 0 6px 16px rgba(2, 6, 23, .05);
  padding: 16px
}

.desc-avatar {
  width: 42px;
  height: 42px;
  border-radius: 9999px;
  background: #eaf2ff;
  color: #3b82f6;
  display: grid;
  place-items: center;
  font-size: 22px
}

.desc-stars {
  color: #f59e0b;
  font-weight: 700
}

.desc-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  padding: 5px 10px;
  font-weight: 700;
  font-size: 12px;
  border: 1px solid transparent
}

.desc-chip-green {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46
}

.desc-chip-blue {
  background: #eaf2ff;
  border-color: #c7ddff;
  color: #1e63da
}

.desc-help {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 10px;
  padding: 4px 10px;
  font-weight: 600;
  color: #374151
}

.desc-help:hover {
  background: #f9fafb
}

.desc-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px dashed #c7d2fe;
  background: #f8fafc;
  padding: 8px 12px;
  border-radius: 10px;
  color: #334155
}


/* ---------- general small fixes ---------- */
.desc-key,
.desc-val {
  word-break: break-word;
}

/* Smooth horizontal scroll for tabs on touch */
.desc-tabbar {
  /* keep your existing lines */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #c7d2fe transparent;
}

.desc-tabbar::-webkit-scrollbar {
  height: 6px;
}

.desc-tabbar::-webkit-scrollbar-thumb {
  background: #c7d2fe;
  border-radius: 9999px;
}

/* ---------- tablet (≤ 992px) ---------- */
@media (max-width: 991.98px) {
  .desc-card {
    padding: 14px;
    border-radius: 16px;
  }

  .desc-title {
    font-size: 18px;
  }

  .desc-tabbar {
    width: 100%;
    justify-content: flex-start;
    gap: 6px;
    padding: 4px 6px;
  }

  .desc-tab {
    padding: 8px 14px;
    font-size: 14px;
  }

  .desc-body {
    margin-top: 14px;
  }

  /* Loosen the fixed key width so table doesn’t overflow */
  .desc-key {
    width: 180px;
  }

  .desc-review {
    padding: 14px;
  }

  .desc-avatar {
    width: 38px;
    height: 38px;
    font-size: 19px;
  }
}

/* ---------- mobile (≤ 768px) ---------- */
@media (max-width: 767.98px) {
  .desc-card {
    padding: 12px;
    border-radius: 14px;
    margin-top: 14px;
  }

  .desc-title {
    margin-bottom: 8px;
    font-size: 16px;
  }

  .desc-tabbar {
    gap: 6px;
    padding: 4px;
    border-radius: 14px;
  }

  .desc-tab {
    padding: 6px 12px;
    font-size: 13px;
    flex: 0 0 auto;
  }

  /* pills scroll horizontally */
  .desc-tab.is-active {
    box-shadow: 0 1px 2px rgba(2, 6, 23, .06), inset 0 0 0 2px #dbeafe;
  }

  .desc-body {
    margin-top: 12px;
  }

  /* Specs table: allow wrapping + auto width keys */
  .desc-key {
    width: auto;
    white-space: normal;
  }

  .table.mb-0 td,
  .table.mb-0 th {
    padding: .55rem .6rem;
  }

  .desc-details .row>[class*="col-"] {
    margin-bottom: 6px;
  }

  /* tighter rows */
  .desc-details-html p {
    margin-bottom: 8px;
  }

  .desc-reviews {
    gap: 12px;
  }

  .desc-review {
    padding: 12px;
  }

  .desc-avatar {
    width: 34px;
    height: 34px;
    font-size: 17px;
  }

  .desc-chip {
    padding: 4px 8px;
    font-size: 11px;
  }

  .desc-help {
    padding: 4px 8px;
    font-weight: 600;
    font-size: 12px;
  }

  /* On small screens, make the yes/no sit side-by-side nicely */
  .desc-review .d-flex.align-items-center.gap-3 {
    gap: 8px !important;
    flex-wrap: wrap;
  }

  .desc-review .desc-help {
    flex: 1 1 auto;
  }
}

/* ---------- small mobile (≤ 480px) ---------- */
@media (max-width: 480px) {
  .desc-card {
    padding: 10px;
    border-radius: 12px;
  }

  .desc-tabbar {
    padding: 3px;
    gap: 4px;
  }

  .desc-tab {
    padding: 6px 10px;
    font-size: 12px;
  }

  .desc-chip {
    padding: 3px 7px;
    font-size: 10.5px;
  }

  .desc-loading {
    padding: 6px 8px;
    font-size: 12px;
  }

  /* Stack the “helpful?” row cleanly */
  .desc-review .d-flex.align-items-center.gap-3 {
    gap: 6px !important;
  }

  .desc-review .desc-help {
    width: 48%;
    text-align: center;
  }
}

.p2-card {
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(2, 6, 23, .06)
}

.qty-label {
  font-weight: 500;
  color: #334155
}

.qty-wrap {
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(2, 6, 23, .12);
  border-radius: 14px;
  overflow: hidden
}

.qty-btn {
  width: 40px;
  height: 40px;
  border: 0;
  background: #fff
}

.qty-btn:hover {
  background: #f3f4f6
}

.qty-val {
  min-width: 54px;
  text-align: center;
  font-weight: 800;
  color: #0f172a
}

.qty-input {
  border: none;
  outline: none;
  background: transparent;
}

.qty-input:focus {
  outline: none;
  box-shadow: none;
}

/* Hide spin buttons in Chrome, Safari, Edge, Opera */
.qty-input::-webkit-outer-spin-button,
.qty-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide spin buttons in Firefox */
.qty-input {
  -moz-appearance: textfield;
}

.btn-pill {
  border-radius: 14px;
  padding: 10px 16px;
  font-weight: 500;
}

.btn-ghost {
  border: 1px solid rgba(2, 6, 23, .12);
  background: #fff;
  color: #374151
}

.btn-ghost:hover {
  background: #f9fafb
}

.btn-cart {
  background: #1292e6;
  color: #fff;
  border: none
}

.btn-cart:hover {
  background: #0f86d6
}

.btn-cart:disabled {
  opacity: .6;
  cursor: not-allowed
}

.pd-page {
  background: #fbf9fa;
}

.container-xl {
  max-width: 1200px
}

.pd-back {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  background: #fff;
  color: #1e63da;
  font-weight: 700;
  box-shadow: 0 4px 10px rgba(2, 6, 23, .05)
}

.pd-back:hover {
  background: #f8fafe
}

.pd-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #101828;
  margin: 10px 0 18px
}









/* Page BG + container rhythm */
.prd-page {
  background: #f2f6fb;
}

.prd-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin: 16px 0 18px;
}

.container-xl {
  max-width: 1200px
}

/* Back pill */
.prd-back {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  margin-top: 18px;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  background: #fff;
  color: #1e63da;
  font-weight: 700;
  box-shadow: 0 4px 10px rgba(2, 6, 23, .05);
}

.prd-back:hover {
  background: #f8fafe
}

/* Generic soft card */
.card-soft {
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(2, 6, 23, .06);
}

.card-soft-title {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

/* Gallery */
.prd-main-img {
  width: 100%;
  aspect-ratio: 4 / 3;
  display: grid;
  place-items: center;
}

.prd-main-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 14px;
}

.prd-thumb {
  width: 58px;
  height: 58px;
  border-radius: 14px;
  padding: 6px;
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  box-shadow: 0 8px 20px rgba(2, 6, 23, .08);
}

.prd-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px
}

.prd-thumb.active {
  outline: 3px solid #3b82f6;
  outline-offset: 0
}

/* Right header */
.prd-name {
  font-size: 32px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px
}

.prd-price {
  color: #22c55e;
  font-size: 26px;
  font-weight: 800
}

.prd-sku {
  color: #6b7280;
  font-size: 14px
}

/* Pills / badges */
.badge-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 9999px;
  font-weight: 700;
  font-size: 12px
}

.badge-review {
  background: #fff3e6;
  border: 1px solid #f6d8b0;
  color: #b45b07
}

.badge-stock {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #065f46
}

.badge-popular {
  background: #fff7ed;
  border: 1px solid #fde2c7;
  color: #b45309
}

/* Attributes row */
.attr-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e9eef5;
  background: #fbfcfe;
  border-radius: 14px;
  padding: 10px 14px
}

.attr-key {
  color: #6b7280;
  font-size: 14px
}

.attr-val {
  color: #0f172a;
  font-weight: 800;
  font-size: 14px;
  background: #eef2f7;
  border-radius: 10px;
  padding: 6px 10px
}

/* Labels + inputs */
.lbl {
  display: block;
  font-weight: 700;
  font-size: 14px;
  color: #0f172a;
  margin-bottom: 6px
}

.inpt {
  height: 44px;
  border-radius: 12px;
  border: 1px solid #e5e7eb
}

.inpt.is-invalid {
  border-color: #fda4af !important
}

.err {
  margin-top: 4px;
  font-size: 12px;
  color: #e11d48
}

.file-btn {
  width: 100%;
  height: 44px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600
}

.file-btn:hover {
  background: #f9fafb
}

.file-preview {
  margin-top: 8px;
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #e5e7eb
}

/* Quantity + buttons */
.qty-label {
  font-weight: 500;
  color: #334155
}

.qty-wrap {
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(2, 6, 23, .12);
  border-radius: 14px;
  overflow: hidden
}

.qty-btn {
  width: 40px;
  height: 40px;
  border: 0;
  background: #fff
}

.qty-btn:hover {
  background: #f3f4f6
}

.qty-val {
  min-width: 54px;
  text-align: center;
  font-weight: 800;
  color: #0f172a
}

.btn-pill {
  border-radius: 14px;
  padding: 10px 16px;
  font-weight: 800
}

.btn-ghost {
  border: 1px solid rgba(2, 6, 23, .12);
  background: #fff;
  color: #374151
}

.btn-ghost:hover {
  background: #f9fafb
}

.btn-cart {
  background: #1292e6;
  color: #fff;
  border: none
}

.btn-cart:hover {
  background: #0f86d6
}

.btn-cart:disabled {
  opacity: .6;
  cursor: not-allowed
}

/* Description */
.desc-title {
  font-weight: 700;
  color: #0f172a
}

.pillbar {
  background: #eef2f7;
  border-radius: 9999px;
  padding: 6px;
  display: inline-flex;
  gap: 6px
}

.pill {
  border: 0;
  background: transparent;
  border-radius: 9999px;
  padding: 8px 16px;
  font-weight: 800;
  color: #6b7280
}

.pill.active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 4px rgba(2, 6, 23, .08)
}

.spec-key {
  color: #6b7280;
  font-weight: 800
}

.spec-val {
  color: #0f172a
}



/* supplier Details page css */


/* Page scaffold */
.vd-page {
  background: #f7f9fc;
  padding-bottom: 28px
}

.container-xl {
  max-width: 1200px
}

/* Back + breadcrumbs */
.vd-back {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  background: #fff;
  color: #1e63da;
  font-weight: 700;
  box-shadow: 0 4px 10px rgba(2, 6, 23, .05);
  text-decoration: none
}

.vd-back:hover {
  background: #f8fafe
}


/* Vendor header card */
.vd-vendor-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 18px;
  padding: 18px 20px;
  margin-bottom: 18px
}

.vd-vendor-card1 {
  gap: 16px;
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 18px;
  padding: 18px 20px;
  margin-bottom: 18px
}

.vd-logo {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(#eef2ff, #eaf2ff);
  display: grid;
  place-items: center;
  overflow: hidden
}

.vd-logo img {
  width: 44px;
  height: 44px;
  object-fit: contain
}

.vd-vendor-name {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a
}

.vd-subtitle {
  color: #1e63da;
  font-weight: 700;
  text-decoration: none;
  display: block;
  margin-top: 2px
}

.vd-rating {
  color: #b45309;
  font-weight: 700
}

.vd-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  padding: 6px 10px;
  font-weight: 700;
  font-size: 12px;
  background: #fff;
  color: #334155
}

.vd-chip-green {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46
}

.vd-chip-blue {
  background: #eaf2ff;
  border-color: #c7ddff;
  color: #1e63da
}

.vd-chip-amber {
  background: #fff7ed;
  border-color: #fde2c7;
  color: #b45309
}

.vd-chip-gray {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #475569
}

.vd-ghost-btn {
  border: 1px solid rgba(2, 6, 23, .12);
  background: #fff;
  color: #334155;
  border-radius: 12px;
  padding: 10px 14px;
  font-weight: 700;
  text-decoration: none;
  display: inline-flex;
  align-items: center
}

.vd-ghost-btn:hover {
  background: #f9fafb
}

/* === Filters container stays as a card (yours already adds vd-vendor-card) === */
.vd-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

/* ---- Search box ---- */
.vd-search {
  position: relative;
  flex: 1 1 420px;
  min-width: 280px;
  height: 48px;
  border-radius: 14px;

  /* exact look */
  background: #F6F7FB;
  /* soft gray fill */
  border: 1.5px solid #E6EBF1;
  /* precise border color/width */
  box-shadow: none;
  /* remove blue-ish shadow */
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.vd-search i {
  color: #98A2B3;
  font-size: 18px;
}

.vd-search-input {
  border: 0;
  outline: 0;
  background: transparent;
  width: 100%;
  height: 100%;
  font-weight: 600;
  color: #0F172A;
}

.vd-search-input::placeholder {
  color: #9AA3B2;
  font-weight: 600;
}

.vd-search:focus-within {
  background: #FFFFFF;
  /* ref shows white on focus */
  border-color: #BCD6FF;
  /* subtle blue border */
  box-shadow: inset 0 0 0 2px #DBEAFE;
  /* inner ring (double-outline feel) */
}

/* ---- Selects ---- */
.vd-select {
  height: 48px;
  min-width: 150px;
  border-radius: 14px;
  padding: 0 14px;
  font-weight: 700;
  color: #0F172A;

  /* exact look */
  background: #F6F7FB;
  /* same as search */
  border: 1.5px solid #E6EBF1;
  /* same border as search */
  box-shadow: none;
  appearance: none;
  /* cleaner across browsers */
  background-clip: padding-box;
}

.vd-select:focus {
  outline: none;
  background: #FFFFFF;
  border-color: #BCD6FF;
  box-shadow: inset 0 0 0 2px #DBEAFE;
}

/* Optional: consistent radius + spacing for the filters-as-card row */
.vd-filters.vd-vendor-card {
  padding: 18px;
  /* match header card padding */
  border-radius: 18px;
}

/* Product card */
.vd-card {
  background: #fff;
  border: 1px solid rgba(2, 6, 23, .06);
  border-radius: 18px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column
}

/* consistent image box */
.vd-figure {
  height: 180px;                 /* pick a single height */
  background:#f6f8fb;
  display:flex;
  align-items:center;
  justify-content:center;
  overflow:hidden;               /* crop overflow */
  border-top-left-radius:18px;
  border-top-right-radius:18px;
}

/* make all images fill the box consistently */
.vd-img {
  width:100%;
  height:100%;
  object-fit:contain;              /* use 'contain' if you prefer no cropping */
  display:block;
}

/* optional alt text */
.vd-noimg {
  color:#94a3b8;
  font-weight:700;
}

.vd-card-title {
  display: block;
  margin-top: 4px;
  color: #0f172a;
  font-weight: 500;
  text-decoration: none;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.vd-card-title:hover {
  text-decoration: underline
}

.vd-card-desc {
  color: #64748b;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: 4px
}

.vd-price {
  color: #16a34a;
  font-weight: 900;
  font-size: 20px;
  flex-shrink: 0;
}

/* Price / stock row on supplier product cards */
.vd-card-meta-row {
  min-width: 0;
}

.vd-card-meta-row .vd-chip {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  text-align: center;
}

.vd-cta {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1e63da;
  color: #fff;
  border-radius: 12px;
  padding: 10px 14px;
  text-decoration: none;
  font-weight: 800
}

.vd-cta:hover {
  background: #1856bf
}

/* Footer */
.vd-footer-note {
  color: #94a3b8;
  text-align: right;
  margin-top: 20px;
  font-size: 12px
}

.success-btn{
  background-color: #009966;
  color: white;
}

.success-btn:hover{
  background-color: #007a55;
  color: white;
}
.container-1440 { width: 100%; }
@media (min-width: 1440px) {
  .container-1440 {
    max-width: 1320px;     /* or whatever width you want */
    margin-left: auto;
    margin-right: auto;
    padding-left: 12px;    /* match Bootstrap gutter if you want */
    padding-right: 12px;
  }
}



.form-select.po-select {
  /* size & spacing */
  height: 48px;
  padding: 10px 40px 10px 12px;
  /* leave room on right for caret */
  border-radius: 10px;

  /* look & feel (match your existing palette) */
  background-color: #f5f6fa;
  border: 2px solid #c9ced6;
  line-height: 1.4;
  /* ensures vertical centering */
  color: #111827;

  /* remove native arrows so we can draw our own */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  /* custom caret (down arrow), centered vertically on right — single-line data URI (multiline breaks CssMinimizer) */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  /* right aligned + vertically centered */
  background-size: 16px;
}


.form-select.po-select:focus {
  border-color: #9ca3af;
  background-color: #fafafa;
  box-shadow: none;
  outline: 0;
}


.form-select.po-select::-ms-expand {
  display: none;
}


.form-select.po-select:disabled {
  background-color: #f2f2f2;
  color: #000;
  cursor: not-allowed;
  opacity: 1;
}

/* ===== Product Description Textarea ===== */
/* Desktop and Tablet - 280px default height */
@media (min-width: 768px) {
  .product-description-textarea {
    height: 340px;
    min-height: 100px !important;
    resize: vertical !important;
  }
}

/* Mobile view - no fixed height, normal behavior */
@media (max-width: 767.98px) {
  .product-description-textarea {
    height: auto;
    min-height: auto !important;
    resize: vertical !important;
  }
}

.table-addbutton:disabled , .save-btn:disabled{
  color: #000000;
  background-color: #93c5fd;
  opacity:0.8;
  border: none;
}


/* ===== Email Template Styles ===== */
/* Email Typography */
.email-heading-h2 {
  margin: 0 0 16px 0;
  color: #111827;
  font-size: 24px;
  font-weight: 500;
  font-family: 'Roboto', Arial, sans-serif;
}

.email-heading-h3 {
  margin: 0 0 16px 0;
  color: #111827;
  font-size: 20px;
  font-weight: 500;
  font-family: 'Roboto', Arial, sans-serif;
  display: flex;
  gap: 5px ! important;
}

.email-paragraph {
  margin: 0 0 32px 0;
  color: #4b5563;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Roboto', Arial, sans-serif;
}

.email-paragraph-small {
  margin: 0 0 24px 0;
  color: #4b5563;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Roboto', Arial, sans-serif;
}

/* Order Details Card */
.email-order-details-card {
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 25px;
  margin: 0 0 32px 0;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.email-order-details-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  max-width: 100%;
}

.email-order-details-field {
  padding: 8px 0;
  color: #6b7280;
  font-size: 14px;
  vertical-align: top;
  width: 35%;
  word-wrap: break-word;
  border-top: 1px solid #e5e7eb !important;
}

.email-order-details-value {
  padding: 8px 0;
  color: black;
  font-size: 14px;
  font-weight: 600;
  vertical-align: top;
  border-top: 1px solid #e5e7eb !important;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 0;
}

.email-order-details-value-first {
  padding: 8px 0;
  color: #111827;
  font-size: 13px;
  font-weight: 600;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 0;
}

.email-order-details-value-bold {
  padding: 8px 0;
  color: #111827;
  font-size: 13px;
  font-weight: 600;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 0;
  border-top: 1px solid #e5e7eb !important;
}

.email-order-details-value-bold-first {
  padding: 8px 0;
  color: #111827;
  font-size: 13px;
  font-weight: 600;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 0;
  /* border-top: 1px solid #e5e7eb !important; */
}

.email-order-details-value-link {
  padding: 8px 0;
  color: #2563EB;
  font-size: 13px;
  font-weight: 600;
  vertical-align: top;
  border-top: 1px solid #e5e7eb !important;
  word-break: break-all;
  overflow-wrap: anywhere;
  max-width: 0;
}

.email-order-details-field-first {
  padding: 8px 0;
  color: #6b7280;
  font-size: 13px;
  vertical-align: top;
  width: 35%;
  word-wrap: break-word;
}

/* Line Items Card */
.email-line-items-heading {
  margin: 32px 0 16px 0;
  color: #111827;
  font-size: 20px;
  font-weight: 500;
  font-family: 'Roboto', Arial, sans-serif;
  display: flex;
  gap: 5px;
}

.email-line-items-container {
background-color: #f9fafb ! important;
  border-radius: 8px;
  padding: 16px;
  margin: 0 0 32px 0;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.email-line-item-row {
  padding: 12px 0;
  /* border-top: 1px solid #e5e7eb; */
  background-color: #f9fafb;
}

.email-line-item-row:first-child {
  padding: 0;
  border-top: none;
}

.email-line-item-table {
  width: 100%;
  border-collapse: collapse;
}

.email-line-item-product {
  padding: 0;
  vertical-align: top;
}

.email-line-item-product-name {
  color: black;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.email-line-item-product-desc {
  color: #6b7280;
  font-size: 14px;
  line-height: 18px;
}

.email-line-item-qty {
  padding: 0 0 0 16px;
  vertical-align: top;
  text-align: right;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  color:black;
}

.email-line-item-qty-text {
  color: #111827;
  font-size: 13px;
  font-weight: 400;
}

/* Email Footer */
.email-footer {
  background-color: #f8f8f8;
  padding: 32px 20px;
  border-top: 1px solid #e5e7eb;
}

.email-footer-link {
  color: #6b7280 !important;
  font-size: 14px;
  text-decoration: none;
  padding: 0 8px;
}

.email-footer-separator {
  color: #d1d5db;
}

.email-footer-text {
  margin: 0;
  color: #9ca3af;
  font-size: 12px;
  line-height: 18px;
}

.email-footer-social-icon {
  display: block;
  width: 32px;
  height: 32px;
  background-color: #e5e7eb;
  border-radius: 50%;
  text-decoration: none;
}

.email-footer-social-icon-table {
  width: 32px;
  height: 32px;
}

.email-footer-social-icon-text {
  font-size: 18px;
  color: #6b7280;
  font-weight: bold;
}

.t-dashboards{
  color: #1f2937 !important;
}
.t-dashboards:hover{
  color: #1e63da !important;
}

.logcolor{
   color: #1f2937 !important;
}

.logcolor:hover{
  color: #1e63da !important;
}

/* Cart header icon (RealtorHeader / CartDropdown trigger) */
.cart-header-icon {
  position: relative;
  font-size: 20px;
  color: #666666;
  cursor: pointer;
  text-decoration: none;
  overflow: visible;
}
.cart-header-icon:hover {
  color: #1e5db8;
}
.cart-header-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.cart-header-icon .cart-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #e53935;
  color: white;
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Prevent Bootstrap dropdown toggle from breaking cart trigger layout */
.cart-dropdown-trigger.btn {
  line-height: 1;
}
.cart-dropdown-trigger.dropdown-toggle::after {
  display: none;
}


.btn-success{
  background-color: #00a63e !important;
  border-color: #00a63e !important;
  color: white;
}

.btn-success:hover{
  background-color: #008236 !important;
  border-color: #008236 !important;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,aAAa;;EAEb,oBAAoB;EACpB,QAAQ;EACR,oBAAoB;EACpB,WAAW;EACX,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;;;;;;;;;;;;EAYE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,qDAAqD;AACrD;;;EAGE,yCAAyC;EACzC,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,6BAA6B;AAC/B;;;AAGA,+CAA+C;AAC/C;;EAEE,kCAAkC;AACpC;;AAEA,sDAAsD;AACtD;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,uEAAuE;AACzE;;AAEA,UAAU;AACV;;EAEE,sCAAsC;EACtC,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA,8CAA8C;AAC9C;;;EAGE,0FAA0F;EAC1F,sBAAsB;EACtB,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA,0BAA0B;AAC1B;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;;EAEE,2CAA2C;EAC3C,0CAA0C;EAC1C,8CAA8C;EAC9C,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;;EAEE,0CAA0C;EAC1C,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;;;;;;;CAOC;;AAED,6DAA6D;AAC7D;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,8CAA8C;EAC9C,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yCAAyC;AACzC;EACE,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;;EAEE,wBAAwB;AAC1B;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,qDAAqD;AACvD;;AAEA,6EAA6E;AAC7E;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ;;;AAGA;;EAEE,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;;AAGA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;;EAEvB;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,sDAAsD;EACtD,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,MAAM;EACN,8CAA8C;EAC9C,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE;;IAEE,eAAe;IACf,yCAAyC;EAC3C;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,yDAAyD;EACzD,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;;;GAMG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;EACzB;;mEAEiE;EACjE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,yBAAyB;EACzB,gGAAgG;EAChG,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,4FAA4F;EAC5F,sDAAsD;AACxD;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,4FAA4F;EAC5F,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,4FAA4F;EAC5F,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;GAGG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;;;;;;;;;;;;;;;GAsBG;;;;AAIH;;;GAGG;;AAEH;;;;GAIG;;AAEH;;;;GAIG;;AAEH;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;AACjC;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;;AAGA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAElB,2CAA2C;EAC3C,eAAe;EAGf,iBAAiB;EACjB,yBAAyB;EAEzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;;;EAGE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;;qBAEmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;;qBAEmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;;;;;;;;;GAUG;;AAEH,cAAc;AACd;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;GAGG;;AAEH;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,qCAAqC;EACrC,UAAU;EACV,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;;AAGA,4BAA4B;AAC5B;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;;AAEzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;;AAE5B;;AAEA;;GAEG;;AAEH;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;GAEG;AACH;;IAEI;;AAEJ;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;GAKG;;AAEH;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;;;;AAKA;EACE,WAAW;EACX,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;;AAGA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qDAAqD;AACrD;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;;GAEG;;;AAGH;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA,iEAAiE;AACjE;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;;AAGA;;EAEE,0BAA0B;EAC1B,4BAA4B;EAC5B;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,uCAAuC;AACvC;;;EAGE,4BAA4B;EAC5B,sFAAsF;AACxF;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mCAAmC;IACnC,yBAAyB;EAC3B;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;EAEE,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,0CAA0C;AAC5C;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,gBAAgB;AAClB;;;AAGA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;AACvB;;;;;AAKA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,qDAAqD;EACrD,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;EACd,UAAU;EACV,iEAA0P;EAC1P,0DAA0D;AAC5D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;GAIG;;AAEH,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;;EAEnB,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,0CAA0C;IAC1C,mCAAmC;EACrC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;IACf,0DAA0D;IAC1D,oBAAoB;IACpB,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;IACnB,mGAAmG;IACnG,0CAA0C;IAC1C,mCAAmC;IACnC,aAAa;EACf;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,sCAAsC;EACxC;;EAEA;IACE,eAAe;EACjB;;EAEA,yDAAyD;EACzD;IACE,gBAAgB;EAClB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;EACd;AACF;;;AAGA;EACE,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;AACb;;AAEA,6BAA6B;AAC7B;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA,0CAA0C;AAC1C;;;;EAIE,SAAS;EACT,0CAA0C;AAC5C;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,mCAAmC;EACnC,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,gDAAgD;AAClD;AACA;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;AACA;CACC;EACC,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;AAGA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,+EAA+E;AAC/E,mBAAmB;AACnB;EACE,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mDAAmD;EACnD,MAAM;EACN,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mEAAmE;EACnE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,qBAAqB;EACrB,cAAc;EACd,mEAAmE;EACnE,6CAA6C;AAC/C;;AAEA,wEAAwE;AACxE;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,uEAAuE;AACvE;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;EAEE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sEAAsE;EACtE,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,sEAAsE;EACtE,6CAA6C;AAC/C;;AAEA,oEAAoE;AACpE;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;;;AAIA,wDAAwD;AACxD,SAAS;AACT;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;;AAGA;wBACwB;;AAExB;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,8CAA8C;EAC9C,wBAAwB;EACxB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE;AACF;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,oFAAoF;EACpF,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;;;;;;GAMG;;;AAGH,oBAAoB;AACpB;EACE;AACF;;;AAGA,sBAAsB;AACtB;EACE,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;;EAEE,0CAA0C;EAC1C,sEAAsE;EACtE,iDAAiD;AACnD;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EAErB,sBAAsB;EAEtB,qBAAqB;EAErB,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EAErB,sBAAsB;EAEtB,qBAAqB;EAErB,kBAAkB;EAClB;AACF;;AAEA;EACE,8DAA8D;EAC9D,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;;AAEjC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,+BAA+B;;AAEjC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,wCAAwC;AACxC;;EAEE,gBAAgB;EAChB,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA,mFAAmF;AACnF;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,0CAA0C;;AAE1C;EACE,UAAU;AACZ;;AAEA,sEAAsE;;AAEtE;CACC;AACD;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,yCAAyC;EACzC,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC;IACE,oCAAoC;IACpC,+BAA+B;IAC/B,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;IAC5B,4BAA4B;IAC5B,wBAAwB;IACxB,4BAA4B;IAC5B,iEAAiE;EACnE;;EAEA;;IAEE,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;;;IAGE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,2GAA2G;EAC7G;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,yCAAyC;EAC3C;AACF;;;;;AAKA,kCAAkC;;;;AAIlC;;8BAE8B;;AAE9B,sCAAsC;AACtC,oEAAoE;AACpE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;;EAEjC,kEAAkE;EAClE,mBAAmB;;EAEnB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB;IACE;EACF,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH,yDAAyD;AACzD,2EAA2E;AAC3E;EACE,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;sDACsD;AACtD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uEAAuE;AACvE;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;;AAExB,oDAAoD;AACpD;EACE,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,8EAA8E;AAChF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;8BAE8B;AAC9B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,iDAAiD;EACjD,6DAA6D;AAC/D;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB;;kCAEgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;;;;kCAKgC;AAClC;;AAEA,8DAA8D;AAC9D;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;;AAGA,2EAA2E;AAC3E;;;;;;;GAOG;;AAEH,cAAc;AACd;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB;+BAC6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;;sCAEoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;AACnB;;AAEA,0EAA0E;AAC1E;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE;;wBAEsB;EACtB,kBAAkB;EAClB,6DAA6D;;EAE7D,6CAA6C;EAC7C,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;;AAGA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kDAAkD;AACpD;;AAEA,2BAA2B;;AAE3B,uFAAuF;AACvF;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,qCAAqC;IACrC,cAAc;EAChB;;EAEA;;;IAGE,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;EAChC;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,QAAQ;EACV;;EAEA,gDAAgD;EAChD;IACE,QAAQ;EACV;AACF;;;;AAIA,4BAA4B;AAC5B;EACE,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,sCAAsC;AACtC;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,yBAAyB;IACzB,mCAAmC;EACrC;AACF;;;;;AAKA,uBAAuB;;AAEvB,uCAAuC;AACvC;;;;;;;GAOG;;AAEH;;;;;;;;GAQG;;AAEH,qBAAqB;AACrB;;;;GAIG;;AAEH;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,eAAe;EACf,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA,wFAAwF;AACxF;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,WAAW;EACb;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE;gCAC8B;EAC9B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE;;sDAEoD;AACtD;;AAEA,6BAA6B;;AAE7B,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,+DAA+D;AACjE;;;AAGA;EACE,cAAc;EACd,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;;;AAIA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,oBAAoB;EAEpB,sBAAsB;EAEtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;;;AAIA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;;EAEf,6CAA6C;EAC7C,wBAAwB;EACxB,oBAAoB;EACpB,8BAA8B;;EAE9B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;;EAE/B,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;EAC3C,gCAAgC;EAChC,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE,UAAU;EACV,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,wBAAwB;EACxB,oBAAoB;EACpB,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;IACR,4BAA4B;AAChC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;AAChB;;AAEA,WAAW;AACX;;EAEE,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,eAAe;AACf;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;;EAEE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB;AACF;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;;;;2BAIyB;EACzB,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE;AACF;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB;AACF;;;AAGA,8CAA8C;AAC9C;;EAEE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,yDAAyD;EACzD;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA,8BAA8B;EAC9B;IACE,kEAAkE;EACpE;;EAEA;IACE,gBAAgB;EAClB;;EAEA,kDAAkD;EAClD;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,8DAA8D;EAC9D;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd;AACF;;;;;;;;;;AAUA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE;AACF;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB;AACF;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB;AACF;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB;AACF;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;;;AAIA,8BAA8B;;;AAG9B,kBAAkB;AAClB;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;EAC1C;AACF;;AAEA;EACE;AACF;;;AAGA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;;EAEnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa,kBAAkB,yBAAyB;EACxD,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe,gBAAgB,kBAAkB;EACjD,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,WAAW;EACX,kBAAkB,eAAe,4CAA4C;EAC7E,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA,WAAW;AACX;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA,kBAAkB,WAAW,EAAE;AAC/B;EACE;IACE,iBAAiB,MAAM,+BAA+B;IACtD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB,KAAK,uCAAuC;IAC9D,mBAAmB;EACrB;AACF;;;;AAIA;EACE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,kCAAkC;EAClC,mBAAmB;;EAEnB,8CAA8C;EAC9C,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;;EAEd,gDAAgD;EAChD,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;;EAErB,mHAAmH;EACnH,yDAAyX;EACzX,4BAA4B;EAC5B,sCAAsC;EACtC,wCAAwC;EACxC,qBAAqB;AACvB;;;AAGA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;;;AAGA;EACE,aAAa;AACf;;;AAGA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA,6CAA6C;AAC7C,8CAA8C;AAC9C;EACE;IACE,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;;AAGA,sCAAsC;AACtC,qBAAqB;AACrB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,QAAQ;AACV;;AAEA;AACA,qCAAqC;EACnC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,wEAAwE;AACxE;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;;AAGA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,YAAY;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,700;1,700&display=swap');\n\n:root {\n  --ro-bg: #f2f2f2;\n  /* background */\n  --ro-fg: #000000;\n  /* text */\n  --sel-radius: 10px;\n  /* border radius for all selects */\n  --sel-border: #c9ced6;\n  /* default border */\n  --sel-hover-border: #9ca3af;\n  /* hover border */\n  --sel-bg: #f5f6fa;\n  /* default bg */\n  --sel-hover-bg: #F5F6FA;\n  /* hover bg */\n\n  --sb-blue-1: #155dfc;\n  /* top */\n  --sb-blue-2: #155dfc;\n  /* bottom */\n  --sb-hover: rgba(255, 255, 255, .06);\n  --disabled-color: #93c5fd;\n}\n\nbody {\n  color: #101828;\n  background-color: #fefefe;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Roboto\", sans-serif;\n  color: #101828;\n}\n\n/* Bootstrap text inputs / textareas when read-only */\n.form-control[readonly],\ntextarea.form-control[readonly],\ninput.form-control[readonly] {\n  background-color: var(--ro-bg) !important;\n  color: var(--ro-fg) !important;\n  cursor: not-allowed;\n  /* match disabled feel */\n  opacity: 1;\n  /* don't fade like disabled */\n}\n\n\n/* ensure parent li never paints a blue block */\n.navbar-menu .navbar-nav .nav-item,\n.navbar-menu .navbar-nav .nav-item.active {\n  background: transparent !important;\n}\n\n/* make each link look like a button inside the rail */\n.navbar-menu .navbar-nav .nav-item>.nav-link,\n.navbar-menu .navbar-nav .menu-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 4px 10px !important;\n  /* space at left/right -> pill look */\n  padding: 7px 14px !important;\n  border-radius: 12px !important;\n  background: transparent !important;\n  color: #a7b4cc;\n  text-decoration: none;\n  background-clip: padding-box;\n  /* crisp rounded edge */\n  transition: background .18s ease, color .18s ease, box-shadow .18s ease;\n}\n\n/* hover */\n.navbar-menu .navbar-nav .nav-item>.nav-link:hover,\n.navbar-menu .navbar-nav .menu-link:hover {\n  background: var(--sb-hover) !important;\n  color: #cfe2ff !important;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .06);\n}\n\n/* ACTIVE – blue rounded button (exact look) */\n.navbar-menu .navbar-nav .nav-item>.nav-link.active,\n.navbar-menu .navbar-nav .menu-link.active,\n.navbar-menu .navbar-nav .nav-item.active>.nav-link {\n  background: linear-gradient(180deg, var(--sb-blue-1) 0%, var(--sb-blue-2) 100%) !important;\n  color: #fff !important;\n  border-radius: 12px !important;\n  box-shadow: 0 10px 28px rgba(37, 99, 235, .35) !important;\n}\n\n/* icons white on active */\n.navbar-menu .navbar-nav .nav-item>.nav-link i,\n.navbar-menu .navbar-nav .menu-link i {\n  width: 22px;\n  text-align: center;\n  font-size: 18px;\n}\n\n.navbar-menu .navbar-nav .nav-item>.nav-link.active i,\n.navbar-menu .navbar-nav .menu-link.active i {\n  color: #fff !important;\n  opacity: 1 !important;\n}\n\n/* some templates add a left stripe with ::before — kill it */\n.navbar-menu .navbar-nav .nav-item>.nav-link::before {\n  content: none !important;\n}\n\n/* Keep the same look on focus */\n.form-control[readonly]:focus {\n  background-color: var(--ro-bg) !important;\n  color: var(--ro-fg) !important;\n  box-shadow: none !important;\n  border-color: #e5e7eb;\n  /* subtle, optional */\n}\n\n/* Placeholder color inside read-only inputs */\n.form-control[readonly]::placeholder {\n  color: var(--ro-fg);\n}\n\n/* Safari/WebKit text color fix */\n.form-control[readonly]::-webkit-text-fill-color {\n  -webkit-text-fill-color: var(--ro-fg);\n}\n\n/* ----- Native <select> (Bootstrap) ----- */\nselect.form-select,\nselect.form-control {\n  border-radius: var(--sel-radius) !important;\n  background-color: var(--sel-bg) !important;\n  border: 2px solid var(--sel-border) !important;\n  box-shadow: none !important;\n  transition: background-color .2s ease-in-out, border-color .2s ease-in-out;\n}\n\nselect.form-select:focus,\nselect.form-control:focus {\n  border-color: var(--sel-border) !important;\n  /* keep gray, no blue ring */\n  box-shadow: none !important;\n}\n\nselect.form-select:hover:not(:disabled),\nselect.form-control:hover:not(:disabled) {\n  background-color: var(--sel-hover-bg) !important;\n  border-color: var(--sel-hover-border) !important;\n}\n\n/* Optional: if you want to remove the native caret everywhere\nselect.form-select,\nselect.form-control {\n  appearance: none;\n  background-image: none !important;\n  padding-right: .75rem;\n}\n*/\n\n/* ----- react-select (requires classNamePrefix=\"rs\") ----- */\n.rs__control {\n  border-radius: var(--sel-radius) !important;\n  background-color: var(--ro-bg) !important;\n  border: 2px solid var(--sel-border) !important;\n  box-shadow: none !important;\n  transition: background-color .2s ease-in-out, border-color .2s ease-in-out;\n}\n\n.rs__control--is-focused {\n  border-color: var(--sel-border) !important;\n  /* keep same as default */\n  box-shadow: none !important;\n  background-color: var(--sel-bg) !important;\n}\n\n.rs__control:hover {\n  background-color: var(--sel-hover-bg) !important;\n  border-color: var(--sel-hover-border) !important;\n}\n\n.rs__indicator-separator {\n  display: none !important;\n}\n\n/* Menu + options for a consistent feel */\n.rs__menu {\n  border: 1px solid var(--sel-border) !important;\n  border-radius: var(--sel-radius) !important;\n}\n\n.rs__option--is-focused {\n  background-color: var(--sel-hover-bg) !important;\n}\n\n.rs__option--is-selected {\n  background-color: #e9edf7 !important;\n  color: #111 !important;\n}\n\n/* Always show the dropdown arrow unless the control is disabled */\n.rs__control .rs__indicators,\n.rs__control .rs__dropdown-indicator {\n  display: flex !important;\n  align-items: center;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n/* Hide arrow only when disabled */\n.rs__control--is-disabled .rs__indicators,\n.rs__control--is-disabled .rs__dropdown-indicator {\n  display: none !important;\n}\n\n/* Optional: remove default SVG caret if it ever appears under your custom icon */\n.rs__dropdown-indicator svg {\n  display: none;\n  /* keeps only your <i class=\"ri-arrow-down-s-line\"> */\n}\n\n/* Keep the border/hover you want (if you’re using the global select theme) */\n.rs__control {\n  border-color: #c9ced6 !important;\n  box-shadow: none !important;\n}\n\n.rs__control:hover {\n  background-color: #F5F6FA !important;\n  border-color: #9ca3af !important;\n}\n\n.rs__control--is-focused {\n  border-color: #c9ced6 !important;\n  box-shadow: none !important;\n}\n\n.form-control:disabled {\n  background-color: var(--ro-bg);\n  opacity: 1;\n}\n\n\n.roboto-new-Paragraph,\np {\n  font-family: \"Roboto\", sans-serif;\n  font-optical-sizing: auto;\n  /* font-weight: 500; */\n  font-style: normal;\n  font-variation-settings: \"wdth\" 100;\n  color: #101828;\n}\n\n.roboto-new {\n  font-family: \"Roboto\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-variation-settings: \"wdth\" 100;\n  color: #101828;\n}\n\n\n/* header css */\n.header-item {\n  height: 70px;\n  display: flex;\n  align-items: center;\n  background-color: #ffffff !important;\n}\n\n.topbar-user {\n  background-color: #ffffff !important;\n}\n\n.badge {\n  line-height: .95;\n  /* width: 20px; */\n}\n\n/* 1) Default: everything at 100% (mobiles + large desktops) */\nbody {\n  zoom: 90%;\n}\n\n/* 2) Laptops & tablets: between 768px and 1440px → 90% zoom */\n@media screen and (min-width: 768px) and (max-width: 1440px) {\n  body {\n    zoom: 90%;\n  }\n}\n\n.topbar-badge {\n  left: 30px;\n}\n\n.vertical-sidebar-enable {\n  margin-left: 0 !important;\n  z-index: 1004;\n}\n\n@media (min-width: 768px) {\n  #page-topbar {\n    left: 250px !important;\n    right: 0 !important;\n  }\n\n  .footer {\n    left: 250px !important;\n    right: 0px !important;\n\n  }\n\n  .topbar-user {\n    background-color: #ffffff !important;\n  }\n}\n\n.logo-lg {\n  color: #ffffff;\n}\n\n.logo-lg h2 {\n  color: #ffffff !important;\n  padding: 30px;\n}\n\n.navbar-menu {\n  width: var(--vz-vertical-menu-width);\n  z-index: 1002;\n  background: #101828 !important;\n  border-right: 1px solid var(--vz-vertical-menu-border);\n  bottom: 0;\n  margin-top: 0;\n  /* position: fixed; */\n  top: 0;\n  box-shadow: var(--vz-vertical-menu-box-shadow);\n  padding: 0 0 calc(70px + 25px) 0;\n  transition: all .1s ease-out;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n.navbar-menu .navbar-nav .nav-link {\n  display: flex;\n  align-items: center;\n  padding: .625rem 1.5rem;\n  color: #e9ebec !important;\n  font-size: var(--vz-vertical-menu-item-font-size);\n  font-family: 'Roboto';\n}\n\n.profBlk {\n  border: 1px solid #cccccc;\n  padding: 5px;\n}\n\n.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {\n  left: unset;\n}\n\n/* agent css */\n.swiper-slide.swiper-slide-visible.swiper-slide-fully-visible.swiper-slide-active {\n  /* height: 90vh; */\n  /* border: 1px solid #cccccc; */\n  width: 31vw !important;\n  text-align: center;\n  margin: 5px;\n}\n\n.swiper-slide.swiper-slide-visible.swiper-slide-fully-visible.swiper-slide-active img {\n  height: 60px;\n}\n\n/* teammember css */\n.combinations {\n  width: 100%;\n  height: 600px;\n  border: 1px solid #cccccc;\n}\n\n.attributes {\n  width: 100%;\n  height: 600px;\n  border: 1px solid #cccccc;\n}\n\n.attr-head {\n  background-color: #405189;\n  color: #ffffff;\n  height: 30px;\n  text-align: center;\n  font-weight: 600;\n  line-height: 30px;\n}\n\n.table-bordered>:not(caption)>*>* {\n  border-width: 1px;\n}\n\n/* brokarage css */\n.password-validation-box.mt-2 {\n  width: 400px;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background-color: #f4f4f4;\n  padding: 10px;\n  /* display: none; */\n}\n\n.table-container {\n  width: 100%;\n  overflow-x: auto;\n  /* Enables horizontal scrolling */\n  margin: 0 auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth,\ntd {\n  padding: 8px;\n  text-align: left;\n  /* border: 1px solid #ddd; */\n}\n\n@media (max-width: 768px) {\n\n  th,\n  td {\n    font-size: 14px;\n    /* Adjust font size for smaller screens */\n  }\n}\n\nlabel {\n  font-size: 14px !important;\n}\n\n.nav-link {\n  color: #ffffff;\n}\n\n.nav-link:active,\n.nav-link:hover,\n.nav-link:focus {\n  color: #ffffff;\n}\n\n/* sinage css */\n.options {\n  width: 100%;\n  height: 200px;\n  border: 1px solid #cccccc;\n}\n\n#myTab .nav-link {\n  color: #ffffff !important;\n}\n\n.nav-link:active,\n.nav-link:hover,\n.nav-link:focus {\n  color: #ffffff;\n}\n\n#myTab .nav-link.active {\n  background-color: var(--vz-nav-tabs-link-active-bg);\n  border-color: var(--vz-nav-tabs-link-active-border-color);\n  color: #000000 !important;\n}\n\n.calculation-table {\n  width: 100%;\n  height: 200px;\n  border-collapse: collapse;\n  box-shadow: none;\n  border: 0;\n  margin-top: 20px;\n}\n\n.calculation-table th {\n  background-color: #ffffff;\n  color: #333333;\n  height: 30px;\n  text-align: left;\n  font-weight: 600;\n  line-height: 30px;\n  border: 1px solid #cccccc;\n}\n\n.calculation-table td {\n  background-color: #ffffff;\n  color: #333333;\n  height: 30px;\n  text-align: left;\n  line-height: 30px;\n  border: 1px solid #cccccc;\n}\n\n.default-table {\n  width: 100%;\n  border: 1px solid #cccccc;\n}\n\n.default-table th {\n  background-color: #e9ebec;\n  color: #333333;\n}\n\n.default-table .btn-success {\n  background-color: #0ab39c;\n  color: #f4f4f4;\n  border-radius: 8px;\n}\n\n.btn-success {\n  border-radius: 8px;\n}\n\n/* Style for disabled success button */\n.btn-success:disabled {\n  background-color: #d1d5db !important;\n  /* gray color */\n  border-color: #d1d5db !important;\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.theme-table {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.theme-table th {\n  background-color: #004aad;\n  color: white;\n}\n\n/* .status-badge {\n  padding: 4px 10px;\n  border-radius: 10px;\n  font-size: 12px;\n  color: white;\n  display: inline-block;\n} */\n\n.status-draft {\n  background-color: #6c757d;\n}\n\n.status-pending {\n  background-color: #ffc107;\n  color: black;\n}\n\n.status-accepted {\n  background-color: #28a745;\n}\n\n.status-shipped {\n  background-color: #17a2b8;\n}\n\n.status-delivered {\n  background-color: #007bff;\n}\n\n.status-completed {\n  background-color: #6f42c1;\n}\n\n.status-canceled {\n  background-color: #dc3545;\n}\n\n.view-btn {\n  background-color: #007bff;\n  color: white;\n}\n\n.view-btn:hover {\n  background-color: #0069d9;\n}\n\nlabel {\n  color: #101828;\n  font-size: 0.85rem;\n}\n\n.white-table {\n  width: 100%;\n  box-shadow: none;\n}\n\n.white-table th {\n  background-color: #ffffff;\n  color: #333333;\n}\n\n.white-table td {\n  background-color: #ffffff;\n  color: #333333;\n}\n\n/* UI improvements */\n.form_container {\n  width: fit-content;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  padding: 50px 40px 20px 40px;\n  background-color: #ffffff;\n  box-shadow: 0px 106px 42px rgba(0, 0, 0, 0.01),\n    0px 59px 36px rgba(0, 0, 0, 0.05), 0px 26px 26px rgba(0, 0, 0, 0.09),\n    0px 7px 15px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 11px;\n  font-family: 'Roboto';\n}\n\n.logo_container {\n  box-sizing: border-box;\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(180deg, rgba(248, 248, 248, 0) 50%, #F8F8F888 100%);\n  border: 1px solid #F7F7F8;\n  filter: drop-shadow(0px 0.5px 0.5px #EFEFEF) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));\n  border-radius: 11px;\n}\n\n.title_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #212121;\n}\n\n.subtitle {\n  font-size: 0.725rem;\n  max-width: 80%;\n  text-align: center;\n  line-height: 1.1rem;\n  color: #8B8E98\n}\n\n.input_container {\n  width: 100%;\n  height: fit-content;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.icon {\n  width: 20px;\n  position: absolute;\n  z-index: 99;\n  left: 12px;\n  bottom: 9px;\n}\n\n.input_label {\n  font-size: 0.75rem;\n  color: #8B8E98;\n  font-weight: 600;\n}\n\n.input_field {\n  width: auto;\n  height: 40px;\n  padding: 0 0 0 40px;\n  border-radius: 7px;\n  outline: none;\n  border: 1px solid #e5e5e5;\n  filter: drop-shadow(0px 1px 0px #efefef) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));\n  transition: all 0.3s cubic-bezier(0.15, 0.83, 0.66, 1);\n}\n\n.input_field:focus {\n  border: 1px solid transparent;\n  box-shadow: 0px 0px 0px 2px #242424;\n  background-color: transparent;\n}\n\n.sign-in_btn {\n  width: 100%;\n  height: 40px;\n  border: 0;\n  background: #115DFC;\n  border-radius: 7px;\n  outline: none;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.sign-in_ggl {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background: #ffffff;\n  border-radius: 7px;\n  outline: none;\n  color: #242424;\n  border: 1px solid #e5e5e5;\n  filter: drop-shadow(0px 1px 0px #efefef) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));\n  cursor: pointer;\n}\n\n.sign-in_apl {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background: #212121;\n  border-radius: 7px;\n  outline: none;\n  color: #ffffff;\n  border: 1px solid #e5e5e5;\n  filter: drop-shadow(0px 1px 0px #efefef) drop-shadow(0px 1px 0.5px rgba(239, 239, 239, 0.5));\n  cursor: pointer;\n}\n\n.separator {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n  color: #8B8E98;\n}\n\n.separator .line {\n  display: block;\n  width: 100%;\n  height: 1px;\n  border: 0;\n  background-color: #e8e8e8;\n}\n\n.note {\n  font-size: 0.75rem;\n  color: #8B8E98;\n  text-decoration: underline;\n}\n\n/* .navbar-menu .navbar-nav .nav-link:hover {\n  background-color: #1e2939 !important;\n  border-left: 2px solid #0069d9;\n} */\n\n/* .status-badge {\n  display: inline-block;\n  padding: 8px 12px;\n  border-radius: 999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  text-transform: capitalize;\n} */\n\n/* .status-badge {\n  display: inline-block;\n  padding: 4px 8px; \n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  text-transform: capitalize;\n}\n\n@media (min-width: 1200px) {\n  .status-badge {\n    padding: 6px 12px;\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 1600px) {\n  .status-badge {\n    padding: 8px 16px;\n    font-size: 16px;\n  }\n} */\n\n\n\n/* .status-draft-btn {\n  background-color: #e2e3e5;\n  color: #343a40;\n} */\n\n/* .status-pending-btn {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #856404;\n} */\n\n/* .status-accepted-btn {\n  background-color: #d4edda;\n  color: #0da06e;\n  border: 1px solid #60d956;\n} */\n\n.status-shipped-btn {\n  background-color: #d1ecf1;\n  /* Light teal */\n  color: #0c5460;\n  /* Teal text */\n}\n\n.status-delivered-btn {\n  background-color: #cce5ff;\n  /* Light blue */\n  color: #004085;\n  /* Blue text */\n}\n\n.status-completed-btn {\n  background-color: #e2d9f3;\n  /* Soft purple */\n  color: #3f2b75;\n  /* Purple text */\n}\n\n.status-canceled-btn {\n  background-color: #fff0f0;\n  color: #c0392b;\n  /* background-color: #f8d7da; */\n  /* Light red */\n  /* color: #721c24; */\n  /* Dark red text */\n}\n\n.status-default-btn {\n  background-color: #ffffff;\n  /* Light gray */\n  color: #343a40;\n  /* Dark text */\n}\n\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  display: inline-block;\n  min-width: 80px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* Active */\n.status-accepted-btn {\n  background-color: #e8f9f1;\n  color: #2e8b57;\n  border: 1px solid #a3e4cd;\n}\n\n/* ✅ Subtle modern gray for Inactive */\n.status-draft-btn {\n  background-color: #d1d1d1;\n  color: black;\n  border: 1px solid #dee2e6;\n}\n\n/* Custom inactive types */\n.status-inactive-btn {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.status-suspended-btn {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeeba;\n}\n\n.status-pending-btn {\n  background-color: #d1ecf1;\n  color: #3434a1;\n  /* border: 1px solid #bee5eb; */\n}\n\n\n.license-btn {\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 10px;\n  padding: 6px 14px;\n  transition: all 0.2s ease-in-out;\n  border: 1px solid transparent;\n}\n\n/* 🟢 Activate Button - Subtle green */\n.license-activate {\n  background-color: #2563eb;\n  color: #292d32;\n  /* border: 1px solid #27ae60; */\n}\n\n.license-activate:hover:not(:disabled) {\n  background: #2563eb;\n  /* color: #ffffff; */\n}\n\n/* 🔴 Deactivate Button - Soft red */\n.license-deactivate {\n  background-color: #fff0f0;\n  color: #c0392b;\n  /* border: 1px solid #f5b7b1; */\n}\n\n.license-deactivate:hover:not(:disabled) {\n  background-color: #e3cece;\n  /* color: #ffffff; */\n}\n\n.license-btn:hover {\n  filter: brightness(0.95);\n  cursor: pointer;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  font-size: 14.5px;\n  font-weight: 500;\n  border-radius: 20px;\n  border: 1px solid transparent;\n  min-width: 70px;\n  text-align: center;\n}\n\n/* Active Badge */\n.badge-active {\n  background-color: #80d556;\n  /* light green */\n  color: #203D12;\n  /* border-color: #b7eb8f; */\n}\n\n/* Inactive Badge */\n.badge-inactive {\n  background-color: #f9d4b0;\n  /* soft orange */\n  color: #6D4927;\n  /* border-color: #ffd591; */\n}\n\n.linked-status {\n  color: #955BE3;\n  font-weight: bold;\n}\n\n\n/* Table wrapper styles */\n.styled-datatable .rdt_TableHead {\n  background-color: #f8f9fa;\n  color: #212529;\n  font-weight: bold;\n  font-size: 0.95rem;\n  border-bottom: 2px solid #dee2e6;\n  text-transform: capitalize;\n  white-space: wrap;\n}\n\n.styled-datatable .rdt_TableRow {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.submit_btn {\n  width: 100%;\n  height: 45px;\n  border: none;\n  background-color: #673AB7;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.submit_btn:hover {\n  background-color: #0d4dcc;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n}\n\n.submit_btn:active {\n  transform: scale(0.98);\n}\n\n.submit_btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(17, 93, 252, 0.4);\n}\n\n/* .btn-primary {\n  background-color: #3F51B5;\n  color: #ffffff;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);\n  text-align: center;\n  display: inline-block;\n} */\n\n.btn-primary:hover {\n  /* background-color: #0d4dcc; */\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.12);\n  text-decoration: none;\n}\n\n.btn-primary:active {\n  transform: scale(0.97);\n}\n\n.btn-primary:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(17, 93, 252, 0.4);\n}\n\nbutton {\n  background-color: #ffffff;\n  border: 1px solid rgb(209, 213, 219);\n  border-radius: 0.5rem;\n  color: #111827;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25rem;\n  padding: 0.75rem 1rem;\n  text-align: center;\n  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n}\n\nbutton:hover {\n  background-color: #f9fafb;\n}\n\nbutton:focus {\n  outline: 2px solid rgba(0, 0, 0, 0.1);\n  outline-offset: 2px;\n}\n\nbutton:focus-visible {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.form-select:focus {\n  border-color: var(--vz-primary-border-subtle);\n  outline: 0;\n  box-shadow: 0 0 0 1px rgba(var(--vz-primary-rgb), .25);\n}\n\n.info-btn {\n  background-color: #ffffff;\n  /* Light gray */\n  color: #343a40;\n  margin-right: 4px;\n  width: auto;\n  height: 30px;\n  float: left;\n}\n\n.page-title {\n  color: #10172A;\n}\n\n.css-vckj6b-MuiTableCell-root {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.43;\n  letter-spacing: 0.01071em;\n  display: table-cell;\n  vertical-align: inherit;\n  border-bottom: 1px solid rgba(224, 224, 224, 1);\n  text-align: left;\n  padding: 16px;\n  color: #10172A;\n  border-right: none;\n  border-left: none;\n}\n\n.MuiTable-root td {\n  font-family: \"Roboto\";\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.43;\n  letter-spacing: 0.01071em;\n  display: table-cell;\n  vertical-align: inherit;\n  border-bottom: 1px solid rgba(224, 224, 224, 1);\n  text-align: left;\n  padding: 8px;\n  color: rgba(0, 0, 0, 0.87);\n  border-right: none;\n  border-left: none;\n  padding-left: 10px;\n}\n\n.pagination-blk button {\n  /* background-color: #ffffff; */\n  border: 1px solid rgb(255, 255, 255);\n  border-radius: 0.5rem;\n  color: #a251ad;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25rem;\n  padding: 0.75rem 1rem;\n  text-align: center;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  border-radius: 20px !important;\n}\n\n.pagination-blk .btn:hover {\n  color: #000000;\n  background-color: #0ab39c;\n  border-color: #0ab39c;\n}\n\n.pagination-blk .btn.disabled,\n.pagination-blk .btn:disabled,\n.pagination-blk fieldset:disabled .btn {\n  color: #6c757d;\n  background-color: #ffffff;\n  border-color: #ffffff;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: #2563EB;\n  border-radius: 8px;\n}\n\n.btn-primary:hover {\n  /* background-color: #1D4ED8; */\n}\n\n/* Datatable Listing page styles */\n.datatable table,\nth,\ntd {\n  color: #10172A;\n}\n\n.datatable thead {\n  background-color: #e5e7eb;\n  color: #10172A;\n  height: 48px;\n  font-size: 15px;\n}\n\n.datatable thead th {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.datatable tbody td {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 180px;\n  color: #10172A;\n}\n\n.datatable .view {\n  color: #5d6b96;\n}\n\n.datatable .edit {\n  color: #5d6b96;\n}\n\n.datatable .del {\n  color: #5d6b96;\n}\n\n.datatable .view:hover {\n  color: #007bff;\n}\n\n.datatable .edit:hover {\n  color: #ffc107;\n}\n\n.datatable .del:hover {\n  color: #dc3545;\n}\n\n#pageSizeSelect,\n.pageSizeSelect {\n  width: 50px;\n  height: 34px;\n  margin-top: -5px;\n  padding: 5px;\n  background-position: right 0.4rem center;\n}\n\n.content .form-select {\n  border-radius: 8px;\n  height: 38px;\n}\n\n.content .card-body {\n  border: 1px solid #e3e5e7;\n  border-radius: 8px;\n}\n\n.content .right-radius {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.content .left-radius {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.content .btn.disabled {\n  border: none;\n}\n\n.formmm label {\n  font-size: 16px;\n}\n\n.formmm input,\nselect {\n  height: 42px;\n  line-height: 30px;\n  border-radius: 8px;\n}\n\n.formmm .submit-btn {\n  height: 42px;\n  width: 120px;\n}\n\n.formmm #password-addon {\n  width: 50px;\n}\n\n.formmm #assignedWarehouses div:first-child {\n  /* height: 45px; */\n  /* line-height: 25px; */\n  /* border-radius: 8px;\n  padding-top: 0;\n  margin-top: -6px; */\n}\n\n.formmm #permissions div:first-child {\n  /* height: 45px; */\n  /* line-height: 25px; */\n  /* border-radius: 8px;\n  padding-top: 0;\n  margin-top: -6px; */\n}\n\n.formmm .form-control {\n  border-radius: 8px;\n  /* color: #919da9; */\n}\n\n/* .formmm #assignedWarehouses div{\n  border-radius: 8px;\n} */\n\n/* .formmm #permissions div {  \n  border-radius: 8px;\n} */\n\n.formmm .cust-margin-4 {\n  margin-left: -60px !important;\n  margin-right: -60px !important;\n}\n\n/* .formmm .custom-select-control {\n    border: 1px solid #cccccc;\n    border-radius: 8px;\n    background-color: #ffffff;\n}\n\n.formmm .custom-select-option {\n    padding: 10px;\n    cursor: pointer;\n    color: #10172A;\n} */\n\n/* Container */\n.my-select-container {\n  width: 100%;\n  font-family: 'Roboto';\n}\n\n/* Control (input box) */\n.my-select-control {\n  display: flex;\n  align-items: center;\n  height: 45px;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: white;\n  cursor: pointer;\n  padding-top: 0;\n}\n\n.my-select-control:focus-within {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* Menu dropdown */\n.my-select-menu {\n  margin-top: 4px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: white;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  position: absolute;\n}\n\n/* Option */\n.my-select-option {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.my-select-option:hover,\n.my-option-focused {\n  background-color: #f0f0f0;\n}\n\n.my-select-option.is-selected {\n  background-color: #007bff;\n  color: white;\n}\n\n/* Multi-value (the selected tag) */\n.my-multi-value {\n  display: inline-flex;\n  align-items: center;\n  margin: 2px;\n  padding: 2px 6px;\n  border-radius: 8px;\n  background-color: hsla(0, 6.48%, 49.68%, 0.37);\n  color: rgb(43, 11, 11);\n  font-size: 0.85rem;\n}\n\n/* Label inside the tag */\n.my-multi-value__label {\n  padding-right: 4px;\n}\n\n/* Remove icon */\n.my-multi-value__remove {\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.my-multi-value__remove:hover {\n  color: #ffdddd;\n}\n\n\n/* .navbar-menu .navbar-nav .nav-link.active {\n  background-color: #000000;\n  color: #ffffff;\n} */\n\n.navbar-menu .navbar-nav .nav-link.active {\n  background-color: #155dfc;\n  color: #ffffff;\n}\n\n.text-secondary {\n  color: #9E9E9E !important;\n}\n\n.saved-card {\n  position: relative;\n  overflow: hidden;\n  transition: box-shadow 0.3s;\n  min-height: 180px;\n  color: #fff;\n  border-radius: 18px;\n  min-height: 180px;\n  box-shadow: 0 4px 16px rgba(20, 40, 60, .10);\n}\n\n.saved-card .card-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(24, 28, 37, 0.60);\n  /* semi-transparent dark */\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.25s;\n  z-index: 10;\n}\n\n.saved-card:hover .card-overlay {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.saved-card .card-content {\n  filter: none;\n  transition: filter 0.3s;\n}\n\n.saved-card:hover .card-content {\n  filter: blur(2px) brightness(0.85);\n}\n\n.saved-card .overlay-btn {\n  min-width: 120px;\n  margin-bottom: 12px;\n  font-size: 1.05rem;\n  z-index: 1;\n}\n\n.search-blk {\n  border-color: \"#cccccc\";\n  white-space: \"nowrap\";\n  overflow: \"hidden\";\n  text-overflow: \"ellipsis\";\n}\n\n.add-image {\n  width: 120px;\n  height: 160px;\n  box-shadow: 0 0 1px 1px #cccccc;\n  margin: 10px;\n  text-align: center;\n  line-height: 150px;\n  font-size: xxx-large;\n  cursor: pointer;\n  color: #cccccc;\n}\n\n.gallery-image {\n  width: 120px;\n  height: 160px;\n  box-shadow: 0 0 2px 1px #cccccc;\n  margin: 10px;\n}\n\n.gallery-image img {\n  width: 120px;\n  height: 130px;\n}\n\n.no-image {\n  width: 34vw;\n  height: 96vh;\n  padding: 60px;\n  border: 1px solid #cccccc;\n  text-align: center;\n  font-size: 18px;\n}\n\n.br-8 {\n  border-radius: 10px !important;\n}\n\nform input {\n  border-radius: 10px !important;\n}\n\n.small-input {\n  width: 250px;\n  border-radius: 10px;\n  padding: 8px;\n  border: 1px solid #ccc;\n}\n\n.lines {\n  border: none;\n  border-top: 2px solid #405189;\n  margin-top: 0;\n}\n\n.w-11 {\n  width: 11%;\n}\n\n.profile {\n  width: 100px;\n  height: 100px;\n  background-color: #e0e7ff;\n  font-size: 36px;\n  font-weight: bold;\n  color: #2563eb;\n}\n\n.css-14oxtc6 {\n  height: 42px !important;\n}\n\n.bg-light {\n  background-color: transparent !important;\n}\n\n/* .row>* {\n  margin-top: 15px !important;\n  padding-left: 24px;\n} */\n\n.custom-input {\n  border-color: #c6dce5 !important;\n  /* Default light border */\n}\n\n.custom-input:focus {\n  border-color: #0d6efd !important;\n  /* Bootstrap primary color on focus */\n  box-shadow: none;\n}\n\n.custom-floating-group {\n  position: relative;\n}\n\n.custom-floating-label {\n  position: absolute;\n  top: 14px;\n  left: 0;\n  font-size: 16px;\n  color: #6c757d;\n  pointer-events: none;\n  transition: all 0.2s ease;\n  padding-left: 2px;\n}\n\n.custom-floating-group input:focus+.custom-floating-label,\n.custom-floating-group input:not(:placeholder-shown)+.custom-floating-label {\n  top: -8px;\n  font-size: 13px;\n  color: #0d6efd;\n  background: white;\n  padding: 0 4px;\n}\n\n.top-27 {\n  top: 27%;\n  left: 8%;\n}\n\n.radio-width {\n  width: 1.5em;\n  height: 1.5em;\n  border: 1px solid #6a6767\n}\n\n.sticky-top {\n  top: -1px !important\n}\n\n.Attributes-table {\n  max-height: 500px;\n  overflow-y: auto;\n  background-color: #f8f9fa;\n  padding: 1rem;\n}\n\n.combinationstable {\n  width: 100%;\n  height: 470px;\n  border: 1px solid #cccccc;\n  background-color: #f8f9fa;\n}\n\n.react-select-container {\n  min-height: 38px;\n}\n\n.react-select__control {\n  min-height: 38px;\n  border-radius: 4px;\n}\n\n#row-overlap {\n  margin-top: 0px !important;\n  padding-left: 0px !important;\n}\n\n.fixed-header-table {\n  max-height: 300px;\n  overflow-y: auto;\n  display: block;\n}\n\n.fixed-header-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.fixed-header-table thead th {\n  position: sticky;\n  top: 0;\n  background-color: #f8f9fa;\n  /* same as Bootstrap's .table-light */\n  z-index: 2;\n  text-align: center;\n}\n\n\n.custom-table-wrapper {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  table-layout: fixed;\n}\n\n.responsive-btn {\n  font-size: 12px;\n  padding: 3px 8px;\n}\n\n@media (min-width: 1200px) {\n  .responsive-btn {\n    font-size: 10px;\n    padding: 5px 12px;\n  }\n}\n\n@media (min-width: 1600px) {\n  .responsive-btn {\n    font-size: 14px;\n    padding: 6px 16px;\n  }\n}\n\n\n/* Responsive font scaling */\n@media (min-width: 1200px) {\n\n  .table-header-text,\n  .table-cell-text {\n    font-size: 13px;\n  }\n}\n\n@media (min-width: 1600px) {\n\n  .table-header-text,\n  .table-cell-text {\n    font-size: 17px;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .input-group-responsive {\n    width: 25% !important;\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1594.98px) {\n  .input-group-responsive {\n    width: 39% !important;\n  }\n}\n\n@media (min-width: 1595px) {\n  .input-group-responsive {\n    width: 28% !important;\n  }\n}\n\n.page-container {\n  /* background-color: #ecf0f4;  */\n  padding: 1rem 1.5rem;\n  /* vertical & horizontal padding */\n  border-radius: 8px;\n  /* box-shadow: 0 0 8px rgba(31, 29, 29, 0.05); */\n  display: flex;\n  /* justify-content: center; */\n  align-items: center;\n  min-height: 70px;\n  /* ensures height and vertical centering */\n}\n\n.addheaders {\n  padding-left: 1.1rem;\n}\n\n.addheaders-content {\n  border: 1px solid #e3e5e7;\n  border-radius: 8px;\n}\n\n.viewdetailsfont {\n  font-size: 15px;\n}\n\n.form-check-input[disabled] {\n  opacity: 1;\n}\n\n#selectwidthdecrease {\n  width: 90% !important;\n}\n\n/* pagination.css */\n/* wrap everything in a soft pill with a subtle inset border */\n.pagination-container {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 40px;\n  box-shadow: inset 0 0 0 1px #e0e0e0;\n}\n\n.pagination-arrow {\n  width: 36px;\n  height: 36px;\n  margin: 0 6px;\n  border: none;\n  background: #ffffff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #a251ad;\n  font-size: 20px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.pagination-arrow:hover:not(:disabled) {\n  background: #a251ad;\n  color: #ffffff;\n}\n\n.export-button {\n  background-color: #00a63e !important;\n  color: white;\n  font-weight: 500 !important;\n  border-radius: 0.625rem;\n\n}\n\n.export-button:hover{\n  background-color: #008236 !important;\n}\n\n.export-button:hover:not(:disabled) {\n  background: #3e995e;\n  color: #ffffff;\n}\n\n.pagination-arrow:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* page bubbles: white circles, coral ring when active */\n.pagination-circle {\n  width: 36px;\n  height: 36px;\n  margin: 0 4px;\n  border: 2px solid transparent;\n  border-radius: 50%;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #555555;\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s, background 0.2s;\n}\n\n.pagination-circle:hover {\n  background: #f0f0f0;\n}\n\n.pagination-circle.active {\n  border-color: #bec1c7;\n  color: #292d32;\n  background: #ffffff;\n}\n\n/* the “…” bubble */\n.pagination-ellipsis {\n  width: 36px;\n  height: 36px;\n  margin: 0 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  /* color: #888888; */\n  user-select: none;\n}\n\n.table-headers {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 15px !important;\n  white-space: nowrap;\n}\n\n.table-cells {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 15px !important;\n  white-space: nowrap;\n  /* overflow: hidden; */\n  text-overflow: ellipsis;\n}\n\n.table-cellsvalues {\n  font-family: \"Roboto\";\n  font-size: 13px !important;\n  white-space: nowrap;\n}\n\n.viewheaders {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 20px !important;\n  white-space: nowrap;\n}\n\n.viewecells {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 18px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fw-semibold {\n  font-size: 15px !important;\n\n}\n\n/* .btn:hover {\n  background-color: #1D4ED8 !important;\n} */\n\n.btn-danger:hover {\n  background-color: #ef0d25 !important;\n}\n\n.warebutton:hover {\n  background-color: #E5E7EB !important;\n}\n\n/* .btn-info:hover {\n  background-color: #119de9 !important;\n} */\n/* .btn-danger:hover {\n  background-color: #d11d1d !important;\n}  */\n\n.css-1jqq78o-placeholder {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 13px !important;\n  color: black !important;\n}\n\n.activetabs {\n  padding: 0.5rem 1.2rem;\n  font-weight: 500;\n  color: #333;\n  background-color: #f1f5f9;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n  display: inline-block;\n  text-align: center;\n}\n\n/* .activetabs.active {\n  background-color: #93C5FD !important;\n  color: #000 !important;\n  font-weight: 600;\n  border-radius: 8px;\n} */\n\n.activetabs:hover:not(.active) {\n  background-color: #e0eefe;\n  color: #222 !important;\n}\n\n\n\n\n.modal-content {\n  left: -26px;\n  border-radius: 26px;\n}\n\n\n#checvkoutpopup {\n  left: -3px !important;\n  border-radius: 26px;\n}\n\n\n.modal-backdrop {\n  width: 125vw !important;\n  height: 125vh !important;\n}\n\n#selectwidthdecreaseWarehouse {\n  width: 35% !important;\n  padding: .5rem 4.7rem .5rem .9rem !important\n}\n\n#selectwidthdecreaseWarehouseagent {\n  width: 71% !important;\n  padding: .5rem 4.7rem .5rem .9rem !important\n}\n\n#selectionagentproduct {\n  background-position: right 2.7rem center;\n  width: 35% !important;\n}\n\n#selectionagentproduct1 {\n  /* background-position: right 2.9rem center; */\n  width: 32% !important;\n}\n\n\n#selectionincomingagentproduct {\n  width: 34% !important;\n}\n\n.css-1u9des2-indicatorSeparator {\n  width: 0 !important;\n}\n\n.css-13cymwt-control {\n  border-radius: 8px !important;\n}\n\n.calculation-input:focus {\n  box-shadow: none;\n  border-color: #86b7fe;\n}\n\n.calculation-table th,\n.calculation-table td {\n  border: none !important;\n  background: transparent !important;\n}\n\n#warehousemodel {\n  left: 382px !important;\n  border-radius: 26px;\n  width: 15vw !important;\n}\n\n#model-adjust {\n  left: 118px !important;\n  border-radius: 26px;\n}\n\n#modal-shipping {\n  left: 118px !important;\n  border-radius: 26px;\n}\n\n#selectionInstallationsdates {\n  width: 15% !important;\n}\n\n#selectionInstallationspayments {\n  width: 17% !important;\n}\n\n#selectionInstallationspriority {\n  width: 12% !important;\n}\n\n#modeladdress {\n  left: 118px !important;\n  border-radius: 26px;\n}\n\n.css-894a34-indicatorSeparator {\n  width: 0 !important;\n}\n\n.css-16xfy0z-control {\n  border-radius: 10px !important;\n}\n\n/* 1) Enable ellipsis on the input box */\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* 2) Make the placeholder itself obey ellipsis too */\ninput.text-ellipsis::placeholder,\ninput.text-ellipsis:focus::placeholder {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.office-list {\n  display: flex;\n  overflow-x: auto;\n  max-width: 200px;\n}\n\n.office-list::-webkit-scrollbar {\n  display: none;\n}\n\n.officetooltip {\n  color: white;\n}\n\n.mt-9 {\n  margin-top: 80px;\n}\n\n.leftmodel {\n  left: 8% !important;\n}\n\n.css-9jq23d {\n  font-size: 105% !important;\n}\n\n/* .isResizing {\n  background-color: #1976d2 !important; \n} */\n\n.table-colors {\n  color: black !important;\n}\n\n/* input::placeholder {\n  text-align: center !important;\n} */\n\n\n.product-location-status-badge {\n  border: 1px solid #fbf6f6;\n  border-radius: 8px;\n  background-color: #d4a8da;\n  color: #292d32;\n  width: 100px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n  margin: 0 auto;\n  /* Center horizontally if used in a table cell */\n}\n\n/* Force Google Places dropdown to appear above the input field */\n.pac-container {\n  transform: translateY(56%) !important;\n  /* margin-top: -4px !important; */\n  z-index: 9999 !important;\n}\n\n.file-upload-form {\n  width: fit-content;\n  height: fit-content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-upload-label input {\n  display: none;\n}\n\n.file-upload-label svg {\n  height: 50px;\n  fill: rgb(82, 82, 82);\n  margin-bottom: 20px;\n}\n\n.file-upload-label {\n  cursor: pointer;\n  background-color: #ddd;\n  padding: 30px 70px;\n  border-radius: 40px;\n  border: 2px dashed rgb(82, 82, 82);\n  box-shadow: 0px 0px 200px -50px rgba(0, 0, 0, 0.719);\n}\n\n.file-upload-design {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.browse-button {\n  background-color: rgb(82, 82, 82);\n  padding: 5px 15px;\n  border-radius: 10px;\n  color: white;\n  transition: all 0.3s;\n}\n\n.browse-button:hover {\n  background-color: rgb(14, 14, 14);\n}\n\n.timeline-item {\n  position: relative;\n}\n\n.timeline-item .badge {\n  font-size: 0.8rem;\n  padding: 0.4em 0.6em;\n  border-radius: 0.4rem;\n}\n\n\n.timeline {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.timeline::before {\n  content: '';\n  /* position: absolute; */\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 100%;\n  /* background-color: #dee2e6; */\n  z-index: 0;\n}\n\n.timeline-item {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 3rem;\n}\n\n.timeline-icon {\n  position: relative;\n  z-index: 1;\n  background-color: #fff;\n}\n\n.timeline-icon::before,\n.timeline-icon::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  width: 2px;\n  background-color: #dee2e6;\n  transform: translateX(-50%);\n}\n\n.timeline-icon::before {\n  top: -40px;\n  height: 40px;\n}\n\n.timeline-icon::after {\n  bottom: -107px;\n  height: 107px;\n}\n\n\n.mdi:before,\n.mdi-set {\n  margin-top: 2px !important;\n  margin-left: 2px ! important;\n  padding: 5px !important\n}\n\n.ms-8 {\n  margin-left: 94px !important;\n}\n\n.payment-cards-save {\n  max-height: 410px;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n.mr-5 {\n  margin-right: 5vw !important;\n}\n\n.timeline-icon.delivered-last::after {\n  height: 40px;\n  /* shorter line before Delivered */\n  bottom: -40px;\n}\n\n.select-control {\n  font-size: 0.875rem;\n  border: 1px solid #ced4da;\n  border-radius: 8px;\n  background-color: white;\n  height: 41px;\n}\n\n.select-option {\n  padding: 6px 12px;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.select-option.focused {\n  background-color: #f1f1f1;\n}\n\n.select-option.selected {\n  background-color: #e9ecef;\n  font-weight: 600;\n}\n\n.select-menu {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Prevent clipping by table or modal */\n.table-responsive,\n.modal,\n.modal-body {\n  overflow: visible !important;\n  /* position: static !important; if it's position: relative, dropdowns get misaligned */\n}\n\n.notestablesdata {\n  font-size: 17px !important;\n  font-family: \"roboto\" !important;\n}\n\n.producttittle {\n  font-size: 24px !important;\n  font-family: \"roboto\" !important;\n}\n\n@media print {\n  .invoice-container {\n    font-size: 13px;\n    line-height: 1.5;\n    letter-spacing: 0.25px;\n    -webkit-font-smoothing: antialiased;\n    print-color-adjust: exact;\n  }\n\n  .table th,\n  .table td {\n    padding: 6px !important;\n  }\n\n  .alert {\n    page-break-inside: avoid;\n  }\n\n  hr {\n    margin: 0.5rem 0;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n.Invoice-headers {\n  font-size: 23px !important;\n  font-family: \"roboto\" !important;\n  letter-spacing: 2px;\n}\n\n.inovice-subheaders {\n  font-size: 19px !important;\n  font-family: \"roboto\" !important;\n}\n\n.tight-label,\n.tight-value {\n  padding: 6px 10px !important;\n  font-size: 14px;\n  vertical-align: middle;\n}\n\n.paymentcards::-webkit-scrollbar {\n  display: none;\n}\n\n.ordercard {\n  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.22);\n  margin-bottom: 1.5rem;\n}\n\n#allocate-model {\n  left: 120px !important;\n  border-radius: 26px;\n}\n\n.dashed-line {\n  border-top: 1px dashed #999;\n  width: 100%;\n}\n\n.product-gallery .main-image-container {\n  width: 100%;\n  max-width: 600px;\n  margin: auto;\n}\n\n.product-gallery .main-image {\n  width: 100%;\n  height: 500px;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n}\n\n.thumbnail-image {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.thumbnail-image:hover {\n  border-color: #007bff;\n  /* hover effect */\n}\n\n.thumbnail-image.active {\n  border-color: #007bff;\n  /* ✅ highlight active thumbnail */\n  box-shadow: 0 0 6px rgba(0, 123, 255, 0.6);\n}\n\n\n.quantity-overlay {\n  position: relative;\n  top: 10px;\n  z-index: 10;\n}\n\n.product-image {\n  position: relative;\n}\n\n.product-image-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.quantity-overlay {\n  position: absolute;\n  bottom: 10px;\n  /* moves it up from bottom */\n  left: 50%;\n  /* centers horizontally */\n  transform: translateX(-50%);\n  background: rgba(255, 255, 255, 0.9);\n  padding: 5px 10px;\n  border-radius: 8px;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n}\n\n.select-center-control {\n  /* text-align: center; */\n  justify-content: center;\n}\n\n.select-center-value {\n  /* text-align: center; */\n  width: 100%;\n}\n\n.select-center-option {\n  /* text-align: center; */\n  padding: 8px 0;\n}\n\n.select-center-option.is-focused {\n  background-color: #f1f1f1;\n}\n\n.select-center-option.is-selected {\n  background-color: #1e63e9;\n  color: #fff;\n}\n\n.swiper-button-next::after {\n  content: \"\\276F\" !important;\n  font-size: 22px !important;\n}\n\n.swiper-button-prev::after {\n  content: \"\\276E\" !important;\n  font-size: 22px !important;\n}\n\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: var(--swiper-navigation-top-offset, 40%) !important;\n}\n\n.image-box {\n  width: 60px;\n  height: 60px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9f9f9;\n  margin-right: 12px;\n}\n\n.imageuploadui {\n  border: 2px dashed rgb(0, 123, 255);\n  border-radius: 12px;\n  padding: 30px;\n  background-color: #f8f9fa;\n  cursor: pointer;\n}\n\n.imagepreview {\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.uploadedimages {\n  height: 150px;\n  object-fit: contain;\n  width: 100%;\n}\n\n.quantitybutton {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n  /* padding: 6px 12px; */\n  width: 110px;\n}\n\n.quantityaddsubbutton {\n  border: none;\n  background: transparent;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.quantitytext {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.profileimage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.profileimagecircle {\n  width: 60px;\n  height: 60px;\n  background-color: #007bff;\n  /* default color when no image */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.profileimagecircle.image-mode {\n  background-color: transparent !important;\n  /* removes bg when image is present */\n  border: 2px solid #007bff;\n  /* only show border */\n}\n\n/* ✅ Smooth slide-in animation */\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.css-1xc3v61-indicatorContainer {\n  display: none !important;\n}\n\n.custom-fields-container {\n  /* word-break: break-word; */\n  max-width: 400px;\n}\n\n.custom-fields-container img {\n  /* border: 1px solid #ccc; */\n  border-radius: 6px;\n  padding: 4px;\n  background-color: #fff;\n}\n\n.custom-cells {\n  font-family: \"Roboto\", sans-serif !important;\n  font-size: 15px !important;\n  font-weight: 400;\n}\n\n\n[data-sonner-toaster],\n[data-sonner-toaster][data-sonner-toaster-position=\"top-right\"] {\n  --gap: 5px !important;\n  --offset-top: 12px !important;\n  --offset-right: 12px !important;\n  --offset-bottom: 12px !important;\n  --offset-left: 12px !important;\n  --mobile-offset-top: 8px !important;\n  --mobile-offset-right: 8px !important;\n  --mobile-offset-bottom: 8px !important;\n  --mobile-offset-left: 8px !important;\n}\n\n[data-sonner-toast]>button[data-close-button=\"true\"] {\n  position: absolute !important;\n  top: 8px;\n  right: 8px;\n  left: auto !important;\n  z-index: 10;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n[data-sonner-toast]>button[data-close-button=\"true\"] svg {\n  width: 14px;\n  height: 14px;\n}\n\n[data-sonner-toast] button[aria-label=\"Close\"] {\n  position: absolute !important;\n  top: 8px;\n  right: 8px;\n  background: none !important;\n  border: none !important;\n  box-shadow: none !important;\n  font-size: 16px;\n  color: #555;\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n[data-sonner-toast] button[aria-label=\"Close\"]:hover {\n  color: #000;\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n\n\n\n[data-sonner-toast][data-type=\"success\"] {\n  background: #ecfdf5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n/* ✅ Error Toast (Soft Red) */\n[data-sonner-toast][data-type=\"error\"] {\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n/* ✅ Info Toast (Soft Blue) */\n[data-sonner-toast][data-type=\"info\"] {\n  background: #eff6ff;\n  color: #1e3a8a;\n  border: 1px solid #bfdbfe;\n}\n\n/* ✅ Hover effect for premium feel */\n[data-sonner-toast]:hover {\n  transform: scale(1.02);\n  transition: transform 0.2s ease;\n}\n\n\n.shipping-option-card {\n  transition: all 0.3s ease;\n  border: 2px solid #e9ecef;\n}\n\n.shipping-option-card:hover {\n  border-color: #0d6efd;\n  box-shadow: 0 0.125rem 0.25rem rgba(13, 110, 253, 0.075);\n  transform: translateY(-1px);\n}\n\n.shipping-option-card.border-primary {\n  border-color: #0d6efd !important;\n  background-color: rgba(13, 110, 253, 0.05) !important;\n  box-shadow: 0 0.125rem 0.25rem rgba(13, 110, 253, 0.15);\n}\n\n.shipping-cost .badge {\n  font-size: 0.75rem;\n  padding: 0.375rem 0.75rem;\n}\n\n.form-check-input:checked {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n.form-check-input.invoice-sent-checkbox:checked:disabled {\n  background-color: #d2f5d2 !important;\n  border-color: #368727 !important;\n  color: #2a6b2a;\n  opacity: 1;\n  --vz-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%232a6b2a' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n  background-image: var(--vz-form-check-bg-image) !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.transition-all {\n  transition: all 0.3s ease;\n}\n\n.customizations-header {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fafafa;\n  min-height: 60px\n}\n\n.customizations-fieldname {\n  flex: 0 0 120px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #333;\n  text-align: left\n}\n\n.customizations-fieldimage {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  padding: 4px;\n  background: #fff\n}\n\n.customizations-fonts {\n  font-size: 14px;\n  color: #555\n}\n\n.marker-legend-container {\n  background: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  padding: 10px 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.marker-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border: 1px solid #ccc;\n  border-radius: 999px;\n  background-color: #fff;\n  transition: background 0.3s;\n  cursor: default;\n}\n\n.marker-legend-item:hover {\n  background-color: #f0f0f0;\n}\n\n.marker-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid #999;\n  display: inline-block;\n}\n\n.dot-finalized {\n  background-color: #fdf569;\n}\n\n.dot-scheduled {\n  background-color: #6993fd;\n}\n\n.dot-inprogress {\n  background-color: #ff9900;\n}\n\n.dot-completed {\n  background-color: #00e74c;\n}\n\n.dot-cancelled {\n  background-color: #e74c3c;\n}\n\n.marker-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #555;\n}\n\n.custom-scroll {\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.custom-scroll::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari */\n}\n\n/* #checkoutpopup {\n  top: 50px;\n  left: 126px !important;\n  border-radius: 26px;\n} */\n\n/* ===== Desktop base ===== */\n#installationoutpopup {\n  /* your original offsets */\n  top: 50px;\n  left: 155px !important;\n  width: 100% !important;\n  border-radius: 18px;\n\n  /* make modal-content a flex column with capped height */\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 80px);\n  overflow: hidden;\n  /* header/footer fixed; inner body scrolls */\n}\n\n/* Only the inner body/table wrapper scrolls */\n#installationoutpopup .modal-body {\n  flex: 1 1 auto;\n  overflow: hidden;\n  /* table wrapper controls scroll */\n}\n\n/* Header & footer stick */\n#installationoutpopup .modal-header {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: var(--bs-body-bg, #fff);\n}\n\n#installationoutpopup .modal-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 3;\n  background: var(--bs-body-bg, #fff);\n}\n\n/* Search sizing */\n#installationoutpopup .search-group {\n  width: 320px;\n}\n\n/* Table readability */\n#installationoutpopup .table {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n#installationoutpopup th,\n#installationoutpopup td {\n  vertical-align: middle;\n}\n\n/* wrap ONLY the Product Name column; others stay tight */\n#installationoutpopup .td-name {\n  white-space: normal;\n  word-break: break-word;\n}\n\n#installationoutpopup .td-tight {\n  white-space: nowrap;\n}\n\n/* Ensure both scrollbars appear when needed */\n#installationoutpopup .table-responsive {\n  overflow-y: auto !important;\n  overflow-x: auto !important;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ===== Tablet ===== */\n@media (min-width: 768px) and (max-width: 1199.98px) {\n  #installationoutpopup {\n    position: fixed;\n    top: 32px !important;\n    left: 4% !important;\n    width: 92% !important;\n    border-radius: 22px;\n    max-height: calc(100vh - 64px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    background: var(--bs-body-bg, #fff);\n  }\n\n  #installationoutpopup .search-group {\n    width: 360px;\n  }\n}\n\n/* ===== Mobile ===== */\n@media (max-width: 767.98px) {\n  #installationoutpopup {\n    position: fixed;\n    top: calc(env(safe-area-inset-top, 0px) + 16px) !important;\n    left: 50% !important;\n    transform: translateX(-50%);\n    width: 94% !important;\n    border-radius: 16px;\n    max-height: calc(100vh - (env(safe-area-inset-top, 0px) + env(safe-area-inset-bottom, 0px) + 40px));\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);\n    background: var(--bs-body-bg, #fff);\n    padding: 12px;\n  }\n\n  #installationoutpopup .search-group {\n    width: 100%;\n    order: 3;\n    /* push under title on small screens */\n  }\n\n  #installationoutpopup .modal-title {\n    font-size: 18px;\n  }\n\n  /* keep columns readable: enforce a minimum table width */\n  #installationoutpopup .table {\n    min-width: 560px;\n  }\n}\n\n/* Mobile landscape (short v-height) */\n@media (max-width: 767.98px) and (orientation: landscape) {\n  #installationoutpopup {\n    max-height: calc(100vh - 24px);\n  }\n}\n\n/* Ultra-small phones */\n@media (max-width: 360px) {\n  #installationoutpopup {\n    width: 96% !important;\n    border-radius: 12px;\n    padding: 8px;\n  }\n}\n\n\n.variant-name {\n  font-size: 15px;\n}\n\n/* Let the browser size columns by content */\n.content-sized-table {\n  table-layout: auto;\n  /* default, but make it explicit */\n  width: 100%;\n}\n\n/* Center headers and cells */\n.content-sized-table th,\n.content-sized-table td {\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  /* keep content on one line so columns can shrink */\n}\n\n/* Make a few tiny columns shrink-to-fit */\n.content-sized-table col.serial,\n.content-sized-table col.image,\n.content-sized-table col.sku,\n.content-sized-table col.category {\n  width: 1%;\n  /* forces minimal width based on content */\n}\n\n/* horizontal + vertical scrollbar size */\n.product-picker-wrap::-webkit-scrollbar {\n  height: 8px;\n  /* horizontal scrollbar thickness */\n  width: 8px;\n  /* vertical scrollbar thickness */\n}\n\n.product-picker-wrap::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.25);\n  border-radius: 8px;\n}\n\n.product-picker-wrap::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Firefox */\n.product-picker-wrap {\n  scrollbar-width: thin;\n  /* 'auto' | 'thin' | 'none' */\n  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;\n}\n@media screen and (max-width: 1021px) {\n\n#newAddressAddmodal {\n  left: -3px !important;\n  border-radius: 26px;\n}\n}\n@media screen and (min-width: 1022px) {\n #newAddressAddmodal {\n  left: 120px !important;\n  border-radius: 26px;\n}\n}\n\n\n.min-h-50 {\n  min-height: 50%;\n  max-height: 50%;\n  overflow-y: scroll;\n  scrollbar-width: thin;\n}\n\n/* === Order Stepper (Installation + Removal) =============================== */\n/* Card container */\n.os-card {\n  border: 1px solid var(--bs-border-color, #e9ecef);\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 6px 18px rgba(16, 24, 40, .06);\n}\n\n/* Grid rail */\n.os-line {\n  display: grid;\n  grid-template-columns: repeat(var(--steps, 6), 1fr);\n  gap: 0;\n  list-style: none;\n  padding-top: 10px;\n  margin: 0;\n}\n\n/* Step base */\n.os-step {\n  position: relative;\n  text-align: center;\n  padding: 18px 8px 6px;\n  user-select: none;\n}\n\n/* Connector rail (gray) and fill (blue/red/purple) */\n.os-step::before,\n.os-step::after {\n  content: \"\";\n  position: absolute;\n  top: 34px;\n  /* center with node */\n  height: 2px;\n  left: -50%;\n  width: 100%;\n  z-index: 0;\n}\n\n.os-step::before {\n  background: #e5e7eb;\n}\n\n/* rail */\n.os-step::after {\n  background: #34c38f;\n  /* normal fill */\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform .3s ease;\n  box-shadow: 0 2px 8px rgba(13, 110, 253, .18);\n}\n\n.os-step.is-first::before,\n.os-step.is-first::after {\n  display: none;\n}\n\n.os-step.is-done::after,\n.os-step.is-active::after {\n  transform: scaleX(1);\n}\n\n/* Completed steps should have green connecting lines */\n.os-step.is-done::after {\n  background: #34c38f;\n  box-shadow: 0 2px 8px rgba(52, 195, 143, .18);\n}\n\n/* Node (circle) */\n.os-node {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 999px;\n  background: #fff;\n  border: 2px solid #d1d5db;\n  color: #6b7280;\n  box-shadow: 0 2px 6px rgba(16, 24, 40, .05);\n  z-index: 1;\n  position: relative;\n}\n\n.os-step.is-active .os-node {\n  border-color: #0d6efd;\n  color: #0d6efd;\n  background: radial-gradient(ellipse at center, #e6f0ff 0, #fff 55%);\n  box-shadow: 0 0 0 6px rgba(13, 110, 253, .12);\n}\n\n.os-step.is-done .os-node {\n  border-color: #34c38f;\n  color: #1b7a55;\n  background: #e9fff4;\n}\n\n/* Next step styling (blue node but green connecting line) */\n.os-step.is-next .os-node {\n  border-color: #0d6efd;\n  color: #0d6efd;\n  background: radial-gradient(ellipse at center, #e6f0ff 0, #fff 55%);\n  box-shadow: 0 0 0 6px rgba(13, 110, 253, .12);\n}\n\n/* The line before the next step (coming from current) should be green */\n.os-step.is-next::before {\n  background: #34c38f !important;\n  box-shadow: 0 2px 8px rgba(52, 195, 143, .18);\n}\n\n/* The line after the next step remains blue */\n.os-step.is-next::after {\n  background: #0d6efd;\n  box-shadow: 0 2px 8px rgba(13, 110, 253, .18);\n}\n\n/* Payment variants (applies to the Payment step only) */\n.os-step.is-pay-success .os-node {\n  /* Paid / Overpaid */\n  border-color: #34c38f;\n  color: #1b7a55;\n  background: #e9fff4;\n  box-shadow: 0 0 0 6px rgba(52, 195, 143, .12);\n}\n\n.os-step.is-pay-warning .os-node {\n  /* Partial Payment */\n  border-color: #f0ad4e;\n  color: #a26a00;\n  background: #fff7e6;\n  box-shadow: 0 0 0 6px rgba(240, 173, 78, .12);\n}\n\n/* Pending / Awaiting / No payment → neutral (keep default gray ring) */\n.os-step.is-pay-neutral .os-node {\n  border-color: #d1d5db;\n  color: #6b7280;\n  background: #fff;\n}\n\n/* Completed — only when active or done */\n.os-step.is-complete.is-active .os-node,\n.os-step.is-complete.is-done .os-node {\n  border-color: #34c38f;\n  color: #1b7a55;\n  background: #e9fff4;\n}\n\n/* Terminal states (cancel/void) affect active step underline + node */\n.os-step.is-cancel.is-active::after {\n  background: #dc3545;\n  box-shadow: 0 2px 8px rgba(220, 53, 69, .18);\n}\n\n/* Cancelled — only when active */\n.os-step.is-cancel.is-active .os-node {\n  border-color: #dc3545;\n  color: #dc3545;\n  background: #fff5f5;\n}\n\n.os-step.is-void.is-active::after {\n  background: #6f42c1;\n  box-shadow: 0 2px 8px rgba(111, 66, 193, .18);\n}\n\n/* Void — only when active */\n.os-step.is-void.is-active .os-node {\n  border-color: #6f42c1;\n  color: #6f42c1;\n  background: #f6f0ff;\n}\n\n/* Labels */\n.os-label {\n  display: block;\n  margin-top: 10px;\n  font-weight: 500;\n  color: #64748b;\n  /* slate-500 */\n}\n\n/* Icon size inside node */\n.os-node i {\n  font-size: 18px;\n}\n\n/* Hover (optional) */\n.os-step:hover .os-node {\n  filter: brightness(0.98);\n}\n\n/* Responsive */\n@media (max-width:768px) {\n  .os-node {\n    width: 38px;\n    height: 38px;\n  }\n\n  .os-step {\n    padding: 14px 6px 4px;\n  }\n\n  .os-label {\n    font-size: .9rem;\n  }\n}\n\n/* Optional: dark mode tweaks (if you toggle .dark on <html> or <body>) */\n.dark .os-card {\n  background: #0f1115;\n  border-color: #222733;\n  box-shadow: none;\n}\n\n.dark .os-step::before {\n  background: #202736;\n}\n\n.dark .os-node {\n  background: #0f1115;\n  border-color: #2a3242;\n  color: #9aa4b2;\n}\n\n.dark .os-label {\n  color: #95a0ad;\n}\n\n.dark .os-step.is-active .os-node {\n  background: radial-gradient(ellipse at center, #0f244a 0, #0f1115 55%);\n  border-color: #5b8dff;\n  color: #85a9ff;\n  box-shadow: 0 0 0 6px rgba(91, 141, 255, .12);\n}\n\n.dark .os-step.is-done .os-node {\n  border-color: #29c08a;\n  color: #7be0ba;\n  background: #0f1f1a;\n}\n\n.dark .os-step.is-next .os-node {\n  border-color: #5b8dff;\n  color: #85a9ff;\n  background: radial-gradient(ellipse at center, #0f244a 0, #0f1115 55%);\n  box-shadow: 0 0 0 6px rgba(91, 141, 255, .12);\n}\n\n/* Dark mode: line before next step (from current) should be green */\n.dark .os-step.is-next::before {\n  background: #29c08a !important;\n  box-shadow: 0 2px 8px rgba(41, 192, 138, .18);\n}\n\n/* Dark mode: line after next step remains blue */\n.dark .os-step.is-next::after {\n  background: #5b8dff;\n  box-shadow: 0 2px 8px rgba(91, 141, 255, .18);\n}\n\n.dark .os-step.is-pay-success .os-node {\n  border-color: #29c08a;\n  color: #7be0ba;\n  background: #0f1f1a;\n}\n\n.dark .os-step.is-pay-warning .os-node {\n  border-color: #e3a23c;\n  color: #ffd28a;\n  background: #1f1a0f;\n}\n\n.dark .os-step.is-cancel .os-node {\n  border-color: #ff6b81;\n  color: #ff9aaa;\n  background: #271318;\n}\n\n.dark .os-step.is-void .os-node {\n  border-color: #9d7eff;\n  color: #c3b6ff;\n  background: #1b1630;\n}\n\n.dark .os-step.is-active::after {\n  box-shadow: 0 2px 8px rgba(91, 141, 255, .18);\n}\n\n/* Dark mode: completed steps should have green connecting lines */\n.dark .os-step.is-done::after {\n  background: #29c08a;\n  box-shadow: 0 2px 8px rgba(41, 192, 138, .18);\n}\n\n.dark .os-step.is-cancel.is-active::after {\n  box-shadow: 0 2px 8px rgba(255, 107, 129, .18);\n}\n\n.dark .os-step.is-void.is-active::after {\n  box-shadow: 0 2px 8px rgba(157, 126, 255, .18);\n}\n\n\n\n/* ---used in add installation sections icons core --- */\n/* Base */\n.section-header {\n  --section-accent: var(--bs-primary);\n  color: var(--bs-body-color);\n}\n\n.section-header--divider {\n  border-bottom: 1px solid var(--bs-border-color);\n  padding-bottom: .25rem;\n}\n\n/* Icon */\n.section-header__icon {\n  color: var(--section-accent);\n  line-height: 1;\n}\n\n/* Title */\n.section-header__title {\n  font-weight: 600;\n  letter-spacing: .15px;\n}\n\n/* Sizes */\n.section-header--sm .section-header__icon i {\n  font-size: 18px;\n}\n\n.section-header--md .section-header__icon i {\n  font-size: 20px;\n}\n\n.section-header--lg .section-header__icon i {\n  font-size: 22px;\n}\n\n.section-header--sm .section-header__title {\n  font-size: 1rem;\n}\n\n.section-header--md .section-header__title {\n  font-size: 1.10rem;\n}\n\n.section-header--lg .section-header__title {\n  font-size: 1.25rem;\n}\n\n/* Bootstrap variant mapping */\n.section-header[data-variant=\"primary\"] {\n  --section-accent: var(--bs-primary);\n}\n\n.section-header[data-variant=\"success\"] {\n  --section-accent: var(--bs-success);\n}\n\n.section-header[data-variant=\"info\"] {\n  --section-accent: var(--bs-info);\n}\n\n.section-header[data-variant=\"warning\"] {\n  --section-accent: var(--bs-warning);\n}\n\n.section-header[data-variant=\"danger\"] {\n  --section-accent: var(--bs-danger);\n}\n\n.section-header[data-variant=\"secondary\"] {\n  --section-accent: var(--bs-secondary);\n}\n\n\n/* \nglobal css class Names */\n\n.box-shadow {\n  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f\n}\n\n.box-shadow-datatables {\n  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f\n}\n\n.shadow-border-datatables {\n  border: 1px solid #e5e7eb;\n  border-radius: 20px;\n  background: #fff;\n}\n\n.supplier-select {\n  height: 37px !important;\n}\n\n.supplier-select-r {\n  height: 39px !important;\n}\n\n.shadow-border-1 {\n  border: 1px solid #e5e7eb;\n  border-radius: 20px;\n  background: #fff;\n}\n\n.shadow-border-2 {\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  background: #fff;\n}\n\n.shadow-border-3 {\n  border: 3px solid #e5e7eb;\n  border-radius: 20px;\n  background: #fff;\n}\n\n.surface-btn {\n  border-radius: 12px;\n  min-width: 90px;\n  padding: 8px 16px;\n}\n\n.br-gray {\n  border: 0.5px solid #80808052\n}\n\n.back-btn {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #101828;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);\n}\n\n.back-btn:hover {\n  background: #f9fafb;\n  border-color: #d0d5dd;\n}\n\n.save-btn {\n  background: #155dfc;\n  border: 0;\n  color: #fff;\n  box-shadow: 0 6px 12px rgba(21, 93, 252, 0.20);\n  transform: translateY(0);\n  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;\n}\n\n.save-btn:hover {\n  color: #fff;\n  background-color: #2563eb !important;\n  transform: translateY(-3px);\n  /* bottom → top */\n  box-shadow: 0 12px 20px rgba(21, 93, 252, 0.28);\n}\n\n.save-btn:active {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 14px rgba(21, 93, 252, 0.22);\n}\n\n.no-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.no-scrollbar::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.bg-gray-50 {\n  background-color: #fbf9fa\n}\n\n.form-select:focus {\n  border-color: #c9ced6 !important;\n  box-shadow: none !important;\n  /* removes blue */\n}\n\n.form-select:hover:not(:disabled) {\n  background-color: #F5F6FA;\n  border-color: #c9ced6;\n}\n\n/* square checkbox look to match screenshot */\n.square-checkbox {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px !important;\n  /* slight rounding like the image */\n  border: 1px solid #c8ced6;\n  box-shadow: none;\n  margin-top: 0;\n  /* keep aligned with label baseline */\n}\n\n.square-checkbox:focus {\n  box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .15);\n}\n\n.square-checkbox:checked {\n  background-color: #fff;\n  /* white box with tick (Bootstrap default) */\n  border-color: #5b9bd5;\n  /* subtle blue border when checked */\n}\n\n/* tighten label look */\n.form-check-label {\n  font-size: 13px;\n  color: #1f2d3d;\n}\n\n.form-check-input.square-checkbox {\n  width: 18px;\n  height: 18px;\n  border-radius: 6px;\n  border: 1.5px solid #D0D5DD;\n  cursor: pointer;\n  transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;\n  accent-color: #155dfc;\n  background-color: #eaeef5;\n  /* modern browsers */\n}\n\n.form-check-input.square-checkbox:checked {\n  background-color: #155dfc;\n  /* fallback */\n  border-color: #155dfc;\n}\n\n.form-check-input.square-checkbox:focus {\n  box-shadow: 0 0 0 .2rem rgba(21, 93, 252, .2);\n}\n\n/* Optional: bold label when checked */\n.form-check-input.square-checkbox:checked+.form-check-label {\n  font-weight: 600;\n}\n\n/* Only interactive fields get the hover styling */\n/* input.form-control:hover:not(:focus):not([readonly]):not(:disabled),\n[role=\"combobox\"]:hover:not(:focus):not([aria-disabled=\"true\"]),\nbutton[role=\"combobox\"]:hover:not(:focus):not([aria-disabled=\"true\"]) {\n  background-color: #fafafa;\n  transition: background-color .2s ease-in-out, border-color .2s ease-in-out;\n  border-color: #9ca3af !important;\n} */\n\n\n/* file upload css */\n.border-dashed {\n  border-style: dashed\n}\n\n\n/* dropzone behavior */\n.dropzone {\n  transition: border-color .2s ease, background-color .2s ease, box-shadow .2s ease;\n}\n\n.view-cards {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.dropzone.editable {\n  cursor: pointer;\n}\n\n.dropzone.disabled {\n  cursor: not-allowed;\n}\n\n/* hover highlight like your 2nd screenshot */\n.dropzone.editable:hover,\n.dropzone.editable:focus-within {\n  border-color: var(--bs-primary) !important;\n  background-color: var(--bs-primary-bg-subtle, rgba(13, 110, 253, .06));\n  box-shadow: 0 0 0 .125rem rgba(13, 110, 253, .12);\n}\n\n/* thumbnail hover-remove */\n.thumb {\n  position: relative;\n}\n\n.thumb .thumb-remove {\n  position: absolute;\n  top: -9px;\n  right: -7px;\n  opacity: 0;\n  transition: opacity .15s ease;\n  z-index: 1;\n}\n\n.thumb:hover .thumb-remove {\n  opacity: 1;\n}\n\n.image-icons {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n  -webkit-mask-size: contain;\n  mask-size: contain;\n  line-height: 1\n}\n\n.image-icons-sub {\n  width: 19px;\n  height: 19px;\n  display: inline-block;\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n  -webkit-mask-size: contain;\n  mask-size: contain;\n  line-height: 1\n}\n\n.order-card {\n  box-shadow: 0 4px 6px -1px #0000001a, 0 2px 4px -1px #0000000f;\n  background-color: #fff;\n  border-radius: .625rem;\n  border-width: 1px;\n}\n\n.order-tittle {\n  font-size: 16px;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  font-weight: 500 !important;\n}\n\n.order-card-title {\n  font-size: 14px;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  font-weight: 500 !important;\n}\n\n.order-card-cells {\n  font-size: 17px;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n\n}\n\n.order-card-log {\n  font-size: 12px;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n\n}\n\n.header-color-product {\n  font-size: 18px;\n  color: #101828;\n  font-weight: 400;\n}\n\n/* ===== Allocate modal v2 (scoped) ===== */\n#allocModalV2 {\n  left: auto !important;\n  /* neutralize any old left:120px */\n  border-radius: 26px;\n  display: flex;\n  flex-direction: column;\n  background: var(--bs-body-bg, #fff);\n}\n\n/* Sticky header/footer (stay visible) */\n#allocModalV2 .re-alloc__header,\n#allocModalV2 .re-alloc__footer {\n  position: sticky;\n  z-index: 3;\n  background: var(--bs-body-bg, #fff);\n}\n\n#allocModalV2 .re-alloc__header {\n  top: 0;\n}\n\n#allocModalV2 .re-alloc__footer {\n  bottom: 0;\n}\n\n/* Body: the vertical scroller (force scroll even if other CSS tries to override) */\n.modal-dialog-scrollable #allocModalV2 .re-alloc__body {\n  overflow-y: auto !important;\n  /* V scroll */\n  overflow-x: hidden;\n  max-height: calc(100vh - 160px) !important;\n  /* header+footer buffer */\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Table wrapper: horizontal scrolling only */\n#allocModalV2 .re-alloc__tableWrap {\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Table: keep readable and allow H-scroll on small widths */\n#allocModalV2 .re-alloc__table {\n  border-collapse: separate;\n  border-spacing: 0;\n  min-width: 720px;\n  /* triggers H-scroll when viewport is narrow */\n}\n\n#allocModalV2 th,\n#allocModalV2 td {\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n#allocModalV2 td:first-child {\n  white-space: normal;\n  /* Serial No. can wrap if long */\n  word-break: break-word;\n}\n\n/* React-Select (scoped via classNamePrefix=\"allocV2\") */\n#allocModalV2 .allocV2__control {\n  min-height: 40px;\n  border-radius: 8px;\n}\n\n#allocModalV2 .allocV2__value-container {\n  padding: 2px 8px;\n}\n\n#allocModalV2 .allocV2__menu,\n.allocV2__menu-portal {\n  z-index: 99999 !important;\n}\n\n/* sit above modal + sticky table header */\n\n#allocModalV2 .re-alloc__table thead.sticky-top {\n  z-index: 2;\n}\n\n/* Add Brokerage Teammember modal — narrower width + scrollable body */\n\n.brokerage-teammember-add-modal-content {\n left :125px !important\n}\n.brokerage-teammember-add-modal {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  box-sizing: border-box;\n  overflow: hidden !important;\n  overflow-y: hidden !important;\n}\n\n.brokerage-teammember-add-modal .brokerage-teammember-add-modal-dialog {\n  max-width: 900px;\n  width: 100%;\n  margin: 0;\n  max-height: calc(100vh - 2rem) !important;\n  height: calc(100vh - 2rem) !important;\n  min-height: 0 !important;\n  display: flex;\n  flex-direction: column;\n}\n\n.brokerage-teammember-add-modal .brokerage-teammember-add-modal-content {\n  max-height: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.brokerage-teammember-add-modal .brokerage-teammember-add-modal-body {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  overflow-x: hidden !important;\n  overflow-y: scroll !important;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-gutter: stable;\n}\n\n.brokerage-teammember-add-modal .modal-dialog-scrollable .brokerage-teammember-add-modal-body {\n  overflow-y: scroll !important;\n}\n\n.brokerage-teammember-add-modal .brokerage-teammember-add-modal-body .brokerage-teammember-creation-embedded {\n  padding: 1rem 1.25rem 1.5rem;\n}\n\n@media (max-width: 767.98px) {\n  /* Mobile: right-side drawer panel */\n  .brokerage-teammember-add-modal {\n    justify-content: flex-end !important;\n    align-items: stretch !important;\n    padding: 0 !important;\n  }\n\n  .brokerage-teammember-add-modal .brokerage-teammember-add-modal-dialog {\n    max-width: min(92vw, 420px);\n    width: min(92vw, 420px);\n    margin: 0 !important;\n    margin-left: auto !important;\n    max-height: 100vh !important;\n    height: 100vh !important;\n    min-height: 100vh !important;\n    animation: brokerage-teammember-drawer-in 0.28s ease-out forwards;\n  }\n\n  .brokerage-teammember-add-modal.fade .brokerage-teammember-add-modal-dialog,\n  .brokerage-teammember-add-modal.show .brokerage-teammember-add-modal-dialog {\n    transform: translate3d(0, 0, 0) !important;\n  }\n\n  .brokerage-teammember-add-modal .brokerage-teammember-add-modal-content {\n    height: 100%;\n    max-height: 100vh;\n    border-radius: 14px 0 0 14px;\n    border-right: none;\n  }\n\n  .brokerage-teammember-add-modal .brokerage-teammember-add-modal-body {\n    overflow-y: scroll !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .brokerage-teammember-add-modal\n    .brokerage-teammember-add-modal-body\n    .brokerage-teammember-creation-embedded {\n    padding: 0.75rem 1rem 1.25rem;\n  }\n}\n\n@keyframes brokerage-teammember-drawer-in {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n/* ===== Tablet ===== */\n@media (min-width: 768px) and (max-width: 1199.98px) {\n  .modal-dialog.modal-xl {\n    max-width: 960px;\n  }\n\n  .modal-dialog-scrollable #allocModalV2 .re-alloc__body {\n    max-height: calc(100vh - 140px) !important;\n  }\n}\n\n/* ===== Mobile ===== */\n@media (max-width: 767.98px) {\n  .modal-dialog.modal-xl {\n    margin: 0 auto;\n    max-width: 94%;\n  }\n\n  #allocModalV2 {\n    border-radius: 16px;\n  }\n\n  #allocModalV2 .re-alloc__table {\n    min-width: 560px;\n  }\n\n  /* keep columns readable */\n  .modal-dialog-scrollable #allocModalV2 .re-alloc__body {\n    max-height: calc(100vh - (env(safe-area-inset-top, 0) + env(safe-area-inset-bottom, 0) + 120px)) !important;\n  }\n}\n\n/* Mobile landscape (short screens) */\n@media (max-width: 767.98px) and (orientation: landscape) {\n  .modal-dialog-scrollable #allocModalV2 .re-alloc__body {\n    max-height: calc(100vh - 96px) !important;\n  }\n}\n\n\n\n\n/* datatables most importent css */\n\n\n\n/* =========================\n   Responsive Data Table CSS\n   ========================= */\n\n/* Scroll wrapper for desktop/tablet */\n/* ===== Horizontal scrollbar skin (matches your screenshot) ===== */\n.production-scroll {\n  position: relative;\n  overflow-x: auto;\n  overflow-y: visible;\n  max-width: 100%;\n  -webkit-overflow-scrolling: touch;\n\n  /* keep a little room so the pill isn't glued to the bottom edge */\n  padding-bottom: 6px;\n\n  /* Firefox fallback */\n  scrollbar-width: thin;\n  scrollbar-color: #c9ced6;\n  /* scrollbar-color: #9fb6e9 #eaf2ff;\n   */\n  /* thumb track */\n}\n\n/* WebKit (Chrome/Edge/Safari) */\n.production-scroll::-webkit-scrollbar {\n  height: 10px;\n  /* thickness of the bar */\n}\n\n.production-scroll::-webkit-scrollbar-track {\n  background: #eaf2ff;\n  /* soft blue track */\n  border-radius: 999px;\n  /* fully rounded */\n  margin: 0 10px;\n  /* inset from left/right to show curved ends */\n}\n\n.production-scroll::-webkit-scrollbar-thumb {\n  background: #9fb6e9;\n  /* thumb color */\n  border-radius: 999px;\n  border: 2px solid #eaf2ff;\n  /* creates that “pill inset” look */\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .35);\n}\n\n.production-scroll::-webkit-scrollbar-thumb:hover {\n  background: #8fb0ea;\n  /* slight hover brighten */\n}\n\n.production-scroll::-webkit-scrollbar-thumb:active {\n  background: #6e9ded;\n  /* pressed */\n}\n\n/* Make the pill visually sit inside the table’s rounded container */\n.production-scroll {\n  border-bottom-left-radius: 14px;\n  border-bottom-right-radius: 14px;\n  background-clip: padding-box;\n  margin-bottom: 13px;\n}\n\n/* .table-1>:not(caption)>*>* {\n  padding: 1.75rem .6rem !important;\n} */\n\n/* ===== Table sizing so the bar actually appears ===== */\n/* Fill wide containers, but force overflow on smaller ones via min-width */\n.production-table {\n  width: 100% !important;\n  min-width: 1100px;\n  /* tweak this to taste */\n  table-layout: auto;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n/* Sticky header */\n.production-thead {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f6f8fb;\n}\n\n.production-th {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #1f2937;\n  padding: 16px 24px;\n  border: 0;\n  white-space: nowrap;\n  /* prevent wrapping so columns take full width */\n}\n\n.production-th .table-headers {\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-weight: inherit;\n  color: inherit;\n}\n\n.production-td .table-cells {\n  display: block;\n  width: 100%;\n  text-align: center;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  color: \"#364153\";\n  font-family: \"Roboto\", sans-serif;\n}\n\n/* Body cells */\n.production-td {\n  padding: 10px 8px !important;\n  border: 0;\n  vertical-align: middle;\n  white-space: nowrap;\n  /* default: no wrap = table expands -> scroll appears */\n}\n\n.production-tr:not(:last-child) .production-td {\n  box-shadow: inset 0 -1px 0 #eef2f6;\n}\n\n/* If you want a specific cell to wrap (e.g., email/product),\n   add className=\"rdt-wrap\" to that cell’s renderer. */\n.rdt-wrap {\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.form-check-input {\n  background-color: #e9ebec;\n}\n\n/* Common inline bits */\n.order-link-1 {\n  color: #155dfc;\n  /* font-weight: 700; */\n  /* text-decoration: none; */\n}\n\n.order-link:hover {\n  text-decoration: underline;\n}\n\n.email-muted {\n  color: #8a94a6;\n}\n\n/* Action buttons */\n.action-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 12px;\n  background: #fff;\n  border: 1px solid #e5eaf0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, .02);\n  color: #111827;\n}\n\n.action-btn:hover {\n  background: #e9ebef;\n  border-color: #cbd5e1;\n}\n\n/* Keep react-select menus above sticky header when used inside cells */\n.production-scroll .rs__menu {\n  z-index: 50;\n}\n\n.view-value {\n  font-size: 18px;\n  color: #495363;\n}\n\n/* images uploadbutton */\n\n/* soft rounded outline button like the screenshot */\n.upload-btn {\n  height: 38px;\n  /* close to your image */\n  padding: 0 16px;\n  border: 1.5px solid #d6dbe6;\n  /* light gray outline */\n  border-radius: 11px;\n  /* rounded corners */\n  background: #fff;\n  color: #1f2937;\n  /* dark slate text */\n  font-weight: 600;\n  /* semi-bold label */\n  box-shadow: 0 2px 6px rgba(15, 23, 42, .08);\n  /* soft shadow */\n  line-height: 38px;\n  /* vertically center text */\n}\n\n.upload-btn:hover {\n  border-color: #c3cbda;\n  box-shadow: 0 3px 10px rgba(15, 23, 42, .12);\n}\n\n.upload-btn:active {\n  transform: translateY(1px);\n}\n\n.upload-btn:focus {\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, .15), 0 2px 6px rgba(15, 23, 42, .08);\n}\n\n.view-circle {\n  background-color: #2b7fff;\n  color: #fff\n}\n\n/* Entity profile header card (team member / agent / brokerage view pages) */\n.re-profile-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04);\n  padding: 26px 32px;\n  margin-bottom: 22px;\n}\n\n.re-profile-card__top {\n  display: flex;\n  align-items: flex-start;\n  gap: 18px;\n  padding-bottom: 22px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 22px;\n}\n\n.re-profile-card__top--no-fields {\n  padding-bottom: 0;\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.re-profile-card__avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: #3b6fe8;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.re-profile-card__avatar--image {\n  background: transparent;\n  border-radius: 0;\n}\n\n.re-profile-card__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.re-profile-card__id {\n  flex: 1;\n  min-width: 0;\n  padding-top: 2px;\n}\n\n.re-profile-card__name-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.re-profile-card__name {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n  line-height: 1.2;\n}\n\n.re-profile-card__subtitle {\n  font-size: 13px;\n  color: #6b7280;\n  margin-top: 3px;\n}\n\n.re-profile-card__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #111827;\n}\n\n.re-profile-card__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #059669;\n  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.16);\n  flex-shrink: 0;\n}\n\n.re-profile-card__dot--inactive {\n  background: #9ca3af;\n  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.16);\n}\n\n.re-profile-card__edit-btn {\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #3b6fe8;\n  transition: background 0.15s;\n  text-decoration: none;\n  line-height: 0;\n}\n\n.re-profile-card__edit-btn svg {\n  display: block;\n  width: 16px;\n  height: 16px;\n}\n\n.re-profile-card__edit-btn:hover {\n  background: #f3f6ff;\n  color: #3b6fe8;\n}\n\n.re-profile-card__fields {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px 40px;\n}\n\n.re-profile-card__label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  letter-spacing: 0.2px;\n  margin-bottom: 5px;\n}\n\n.re-profile-card__value {\n  font-size: 15px;\n  color: #495363 !important;\n  font-weight: 400;\n  word-break: break-word;\n}\n\n.re-profile-card__value.empty {\n  color: #495363 !important;\n}\n\n.re-profile-card__link {\n  color: #495363 !important;\n  text-decoration: none;\n}\n\n.re-profile-card__link:hover {\n  color: #3b6fe8 !important;\n  text-decoration: underline;\n}\n\n@media (max-width: 720px) {\n  .re-profile-card {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .re-profile-card__fields {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .re-profile-card__fields {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* =========================\n   MOBILE CARD VIEW\n   ========================= */\n.po-card {\n  background: #fff;\n  border: 1px solid #e8edf3;\n  border-radius: 12px;\n  padding: 14px;\n  box-shadow: 0 8px 20px rgba(2, 6, 23, .06);\n}\n\n/* Top-right actions (supports multiple buttons) */\n.po-card-actions {\n  align-items: center;\n}\n\n.po-card-actions>* {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Stacked fields: label above value */\n.po-field {\n  padding: 10px 0;\n  border-top: 1px solid #eef2f6;\n}\n\n.po-field:first-child {\n  border-top: 0;\n  padding-top: 0;\n}\n\n.po-field-label {\n  color: #64748b;\n  font-size: .9rem;\n  line-height: 1.2;\n  margin-bottom: 6px;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.po-field-value {\n  color: #0f172a;\n  /* font-weight: 600; */\n  line-height: 1.35;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.po-header {\n  position: relative;\n  background: #fff;\n  border: 1px solid #e9edf2;\n  border-radius: 14px;\n  padding: 18px 20px;\n  border-left: 6px solid #2563eb;\n  /* box-shadow: 0 8px 20px rgba(2, 6, 23, 0.06); */\n  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;\n}\n\n\n.po-title-search {\n  color: #0b1320;\n  font-size: 16px;\n}\n\n/* Title + subtitle */\n.po-title {\n  /* font-weight: 800; */\n  color: #101828;\n  letter-spacing: -0.2px;\n}\n\n.po-subtitle {\n  font-size: 0.95rem;\n  color: #4a5565;\n  margin-top: 2px;\n}\n\n/* Pill search (double-ring feel, soft bg, icon on the left) */\n.po-search {\n  height: 42px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f3f3f5;\n  border-color: #d1d5dc;\n  box-shadow:\n    inset 0 0 0 2px #c9ced6,\n    0 8px 20px rgba(2, 6, 23, .06);\n}\n\n.po-search .input-group-text {\n  background: transparent;\n  border: none;\n  padding: 8px 10px 8px 12px;\n  color: #7587a3;\n  display: flex;\n  align-items: center;\n}\n\n.po-search .form-control {\n  border: none !important;\n  background: transparent;\n  padding: 8px 12px 8px 0;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.po-search .form-control::placeholder {\n  color: #99a1af;\n}\n\n.po-search:focus-within {\n  box-shadow:\n    inset 0 0 0 2px #93c5fd,\n    /* blue ring on focus */\n    0 0 0 4px rgba(59, 130, 246, .14),\n    /* subtle glow */\n    0 8px 20px rgba(2, 6, 23, .06);\n}\n\n/* Make sure input height stays pill-perfect across browsers */\n.po-search .form-control,\n.po-search .input-group-text {\n  height: 42px;\n  line-height: 42px;\n}\n\n\n/* Footer bar container (rounded, subtle shadow & border like screenshot) */\n/* .po-pagination {\n  background: #fff;\n  border: 1px solid #e8edf3;\n  border-radius: 12px;\n  padding: 10px 14px;\n  box-shadow: 0 8px 20px rgba(2, 6, 23, 0.06);\n  font-size: 0.9rem;\n} */\n\n/* left text */\n.po-range {\n  color: #1f2937;\n  /* slate-800 */\n}\n\n/* \"Rows per page:\" label in blue like ref */\n.po-rows-label {\n  color: #3e434d;\n  white-space: nowrap;\n  /* font-weight: 600; */\n}\n\n/* pill-like select */\n.po-page-size {\n  /* height: 36px; */\n  /* line-height: 36px;\n  padding: 4px 32px 4px 10px; */\n  border-radius: 10px;\n  border: 1px solid #d1d8e2;\n  background-color: #ffffff;\n  box-shadow: inset 0 0 0 1px #d1d8e2;\n  font-weight: 600;\n}\n\n.po-page-size:focus {\n  border-color: #93c5fd;\n  box-shadow:\n    inset 0 0 0 1px #93c5fd,\n    0 0 0 4px rgba(59, 130, 246, 0.14);\n}\n\n/* nav buttons */\n.po-nav .po-btn {\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #6b7280;\n  /* gray-500 */\n  font-weight: 600;\n}\n\n.po-nav .po-btn:hover:not(:disabled) {\n  border-color: #cfd7e3;\n  background: #f8fafc;\n  color: #374151;\n}\n\n.po-nav .po-btn:disabled {\n  opacity: .55;\n  cursor: not-allowed;\n}\n\n/* current page pill (blue rounded square, white text) */\n.po-nav .po-page {\n  height: 36px;\n  min-width: 36px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #111827;\n  font-weight: 700;\n}\n\n.po-nav .po-page.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15) inset;\n}\n\n.page-item.disabled .page-link:disabled {\n  pointer-events: none;\n  opacity: .65;\n}\n\n.label-1 {\n  font-weight: 300 !important;\n}\n\n.clear-button {\n  border-radius: 7px !important;\n}\n\n.pagination-button {\n  background-color: #2563eb !important;\n  border: 1px solid #2563eb !important;\n}\n\n/* keep the whole right area on one line */\n.po-pagination>.d-flex {\n  flex-wrap: nowrap;\n}\n\n/* (optional) if any global styles force wrapping inside buttons/selects */\n.po-page-size,\n.po-btn,\n.po-page {\n  white-space: nowrap;\n}\n\n.preview-buttons {\n  font-weight: 100 !important;\n}\n\n/* Outer container: same rounded white card feel */\n.po-pagination {\n  /* background: #fff;\n  border: 1px solid #e8edf3;\n  border-radius: 12px; */\n  padding: 12px 14px;\n  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;\n\n  /* NEW: grid for bulletproof responsiveness */\n  display: grid;\n  grid-template-columns: 1fr auto;\n  /* range | actions */\n  align-items: center;\n  gap: 12px;\n}\n\n\n/* Range text */\n.po-range {\n  color: #1f2937;\n}\n\n/* Right side cluster */\n.po-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: flex-end;\n  min-width: 0;\n}\n\n/* Rows-per-page (kept on one line) */\n.rows-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  min-width: max-content;\n}\n\n/* .po-page-size {\n  height: 36px;\n  line-height: 36px;\n  padding: 2px 32px 2px 10px;\n  border-radius: 10px;\n  border: 1px solid #d1d8e2;\n  background: #fff;\n  box-shadow: inset 0 0 0 1px #d1d8e2;\n  font-weight: 600;\n} */\n\n.po-page-size:focus {\n  border-color: #93c5fd;\n  box-shadow: inset 0 0 0 1px #93c5fd, 0 0 0 4px rgba(59, 130, 246, .14);\n}\n\n/* Pager buttons */\n.po-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.po-btn {\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.po-btn:hover:not(:disabled) {\n  border-color: #cfd7e3;\n  background: #f8fafc;\n  color: #374151;\n}\n\n.po-btn:disabled {\n  opacity: .55;\n  cursor: not-allowed;\n}\n\n.po-page {\n  height: 36px;\n  min-width: 36px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #111827;\n  font-weight: 700;\n}\n\n.po-page.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, .15) inset;\n}\n\n/* ===== Responsive ===== */\n\n/* Tablets and down (≤ 768px): keep two rows, actions on the second row right-aligned */\n@media (max-width: 768px) {\n  .po-pagination {\n    grid-template-columns: 1fr;\n    /* single column */\n    grid-auto-rows: minmax(0, auto);\n  }\n\n  .po-range {\n    text-align: center;\n    /* like your screenshot */\n  }\n\n  .po-actions {\n    width: 100%;\n    justify-content: flex-end;\n    /* controls stay on the right */\n    flex-wrap: wrap;\n    /* if too tight, lines wrap cleanly */\n    gap: 10px 12px;\n  }\n\n  .po-page-size,\n  .po-btn,\n  .po-page {\n    height: 34px;\n    border-radius: 8px;\n    /* slightly smaller controls */\n  }\n}\n\n/* Extra small phones (≤ 400px): rows-group and pager still align right */\n@media (max-width: 400px) {\n  .rows-group {\n    order: 2;\n  }\n\n  /* pager first if you prefer: set order:1 here */\n  .po-nav {\n    order: 1;\n  }\n}\n\n\n\n/* Desktop table row hover */\n.table-row-hover {\n  transition: background-color .15s ease, box-shadow .15s ease;\n}\n\n.table-row-hover:hover {\n  background-color: #f7f8fb;\n  /* subtle gray like your screenshot */\n  box-shadow: inset 0 0 0 1px #eef2f7;\n  /* faint inner border to “lift” the row */\n}\n\n/* Mobile: card-style rows (≤1021px) */\n@media (max-width: 1021px) {\n  .mobile-row-card {\n    transition: background-color .15s ease, box-shadow .15s ease;\n  }\n\n  .mobile-row-card:hover {\n    background-color: #f7f8fb;\n    box-shadow: inset 0 0 0 1px #eef2f7;\n  }\n}\n\n\n\n\n/* fillter expand css */\n\n/* header card (you already use this) */\n/* .po-header {\n  position: relative;\n  background: #fff;\n  border: 1px solid #e9edf2;\n  border-radius: 14px;\n  padding: 18px 20px;\n  box-shadow: 0 8px 20px rgba(2, 6, 23, .06);\n} */\n\n/* .po-header::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 6px;\n  background: linear-gradient(180deg, #3b82f6 0%, #60a5fa 100%);\n  border-top-left-radius: 20px !important;\n  border-bottom-left-radius: 20px !important;\n} */\n\n/* Title + subtitle */\n/* .po-title {\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -.2px;\n} */\n\n.po-subtitle {\n  font-size: .95rem;\n  color: #64748b;\n}\n\n/* tools area */\n.po-tools {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n\n.po-search {\n  flex: 0 0 360px;\n  /* don't grow; fixed-ish width */\n  width: 360px;\n}\n\n@media (min-width: 1200px) {\n  .po-search {\n    flex-basis: 345px;\n    width: 420px;\n  }\n}\n\n/* Tablets & phones: stack and make search full-width */\n@media (max-width: 992px) {\n  .po-tools {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .po-search {\n    flex: 1 1 100%;\n    width: 100%;\n  }\n\n  .po-tools .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* filter toggle */\n.po-filter-btn {\n  height: 42px;\n  border-radius: 12px;\n  border-color: #d5deeb;\n  background: #fff;\n}\n\n.po-filter-btn.active,\n.po-filter-btn:focus {\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, .14);\n}\n\n.po-filter-btn .ri-filter-3-line {\n  color: #2563eb;\n}\n\n.rotate-180 {\n  transform: rotate(180deg);\n  transition: transform .2s ease;\n}\n\n/* collapsible panel */\n.po-filters {\n  border-top: 1px solid #eef2f6;\n  margin-top: 12px;\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition: max-height .25s ease, opacity .25s ease;\n}\n\n.po-filters.show {\n  max-height: 260px;\n  opacity: 1;\n}\n\n/* Brokerage teammembers filter: menu opens below select inside panel (same as Agents) */\n.po-header:has(#brokerage-teammembers-filters.show) {\n  overflow: visible;\n  z-index: 10;\n}\n\n#brokerage-teammembers-filters.show {\n  overflow: visible;\n  max-height: 420px;\n}\n\n#brokerage-teammembers-filters.show .po-filters-bar {\n  overflow: visible;\n}\n\n.brokerage-teammember-firm-select {\n  position: relative;\n  z-index: 20;\n  width: 220px;\n  max-width: 100%;\n}\n\n.brokerage-teammember-firm-select > div {\n  width: 220px;\n  max-width: 100%;\n}\n\n.brokerage-teammember-firm-select .rs__menu {\n  z-index: 9999 !important;\n}\n\n.po-filters-bar {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 14px;\n  margin-top: 12px;\n}\n\n/* make selects consistent height */\n.po-filters .form-select {\n  height: 40px;\n  border-radius: 10px;\n}\n\n/* Default: mobile visible, desktop hidden */\n.rdt-mobile {\n  display: block;\n}\n\n.rdt-desktop {\n  display: none;\n}\n\n/* ≥ 1022px: desktop visible, mobile hidden */\n@media (min-width: 1022px) {\n  .rdt-mobile {\n    display: none;\n  }\n\n  .rdt-desktop {\n    display: block;\n  }\n}\n\n@media (max-width: 992px) {\n  .po-filters.show {\n    max-height: 100%;\n  }\n}\n\n/* Ensure dropdowns don't get clipped and fit at mobile sizes */\n@media (max-width: 576px) {\n  .supplier-actions-grid {\n    width: 100%;\n  }\n\n  .po-card,\n  .po-field,\n  .po-field-value {\n    overflow: visible;\n  }\n\n  .po-select,\n  .po-notes {\n    width: 100% !important;\n    max-width: 100%;\n  }\n}\n\n/* keep pill look */\n.po-select {\n  height: 38px;\n  line-height: 36px;\n  border-radius: 12px;\n  border: 1px solid #cfe3ff;\n  background: #f8fbff;\n  padding: 4px 32px 4px 10px;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, .02);\n}\n\n.po-notes {\n  min-height: 40px;\n  border-radius: 12px;\n  border: 1px solid #d1d8e2;\n}\n\n/* focus ring on top of base Bootstrap shadow */\n.bs-focus-ring {\n  box-shadow:\n    0 1px 2px rgba(0, 0, 0, .05);\n  /* fallback base */\n  transition: box-shadow .2s ease;\n}\n\n.bs-focus-ring.is-focused {\n  box-shadow:\n    0 0 0 var(--bs-focus-ring-width, .25rem) rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity, .25)),\n    var(--bs-box-shadow, 0 1px 2px rgba(0, 0, 0, .05));\n}\n\n/* brokerage data table css */\n\n/* License buttons */\n.license-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: .5rem;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 1;\n  border: 1px solid transparent;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, .08);\n}\n\n.license-activate {\n  background-color: #155dfc;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.license-activate:hover {\n  background-color: #1447e6;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.license-deactivate {\n  background: #fff;\n  /* white + red outline */\n  color: #ef4444;\n  border-color: #fca5a5;\n}\n\n.license-deactivate:hover {\n  border-color: #fef2f2;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, .12);\n  color: #030213;\n}\n\n/* Status dot (uses your radio input – visually a dot) */\n.status-radio {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 12px;\n  height: 12px;\n  border-radius: 999px;\n  border: 2px solid transparent;\n  margin: 0;\n  /* keep perfectly centered */\n  background: #e5e7eb;\n}\n\n.status-radio-active {\n  background: #10b981;\n  /* green */\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, .15);\n}\n\n.status-radio-inactive {\n  background: #99a1af;\n  /* muted gray */\n  border-color: #99a1af;\n}\n\n.ri-search-line:before {\n  content: \"\\f0d1\";\n  color: blue;\n}\n\n/* Square icon buttons */\n.icon-square {\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  color: #0b1320;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, .06);\n  transition: background .15s, box-shadow .15s, border-color .15s;\n}\n\n\n.icon-square.danger {\n  color: #ef4444;\n  /* border-color: #fca5a5; */\n  padding: 15px;\n}\n\n.icon-square.cancel {\n  color: #dc2626;\n  background: #fef2f2;\n  border-color: #fecaca;\n  padding: 15px;\n}\n\n.icon-square:hover {\n  background: #e9ebef;\n}\n\n.icon-square.danger:hover {\n  /* border-color: #ef4444; */\n  color: #000;\n  background-color: #fef2f2;\n}\n\n.icon-square.cancel:hover {\n  color: #b91c1c;\n  background: #fee2e2;\n  border-color: #fca5a5;\n}\n\n\n\n.table-addbutton {\n  background-color: #155dfc;\n  color: #fff;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n\n.table-addbutton:hover {\n  background-color: #1447e6;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.icon-square1 {\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  color: #0b1320;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, .06);\n  transition: background .15s, box-shadow .15s, border-color .15s;\n}\n\n.icon-square1:hover {\n  background: #f8fafc;\n}\n\n.icon-square1.danger {\n  color: #ef4444;\n  border-color: #fca5a5;\n}\n\n.icon-square1.danger:hover {\n  border-color: #ef4444;\n}\n\n#incoming-filters,\n#incoming-filters .po-filters,\n#incoming-filters .po-filters-bar,\n#incoming-filters .po-title-wrap {\n  overflow: visible !important;\n}\n\n/* Batch Invoice filters: keep Payment/Status menus above the table UI */\n.po-header:has(#batch-payment-filters.show) {\n  overflow: visible;\n  z-index: 10;\n}\n\n#batch-payment-filters,\n#batch-payment-filters.po-filters,\n#batch-payment-filters .po-filters-bar {\n  overflow: visible !important;\n}\n\n#batch-payment-filters.show {\n  max-height: 420px;\n  opacity: 1;\n}\n\n.pi-badge {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pi-icon {\n  width: 16px;\n  height: 16px;\n  -webkit-mask-size: 100% 100%;\n  mask-size: 100% 100%;\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n}\n\n.upload-tile {\n  width: 88px;\n  height: 88px;\n  border: 2px dashed #d0d5dd;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  transition: background .15s ease, border-color .15s ease, box-shadow .15s ease;\n}\n\n.upload-tile:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  box-shadow: 0 1px 6px rgba(16, 24, 40, .06);\n}\n\n.upload-ghost {\n  border: 1px solid #d0d5dd;\n  background: #fff;\n  border-radius: 10px;\n  font-weight: 600;\n  padding: 8px 14px;\n}\n\n.upload-ghost:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n\n\n.wrap-anywhere {\n  max-width: clamp(160px, 22vw, 420px);\n  /* adjust once, used everywhere */\n  white-space: normal;\n  /* allow wrapping */\n  overflow-wrap: anywhere;\n  /* break long tokens (no spaces) */\n  word-break: break-word;\n  /* legacy fallback */\n  line-height: 1.25;\n}\n\n.wrap-anywhere1 {\n  white-space: normal;\n  max-width: 100%;\n  /* allow wrapping */\n  overflow-wrap: anywhere;\n  /* break long tokens (no spaces) */\n  word-break: break-word;\n  /* legacy fallback */\n  line-height: 1.25;\n}\n\n/* Base square */\n.sqbtn {\n  --sq-size: 28px;\n  --sq-radius: 8px;\n  --sq-inset: 3px;\n\n  /* defaults (overridden by variant classes) */\n  --sq-icon-color: #0A0A0A;\n  --sq-border: #E5E7EB;\n  /* --sq-hover-fill: #F1F5F9; */\n\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  width: var(--sq-size);\n  height: var(--sq-size);\n  border-radius: var(--sq-radius);\n\n  background: #fff;\n  border: 1px solid var(--sq-border);\n  color: var(--sq-icon-color);\n  padding: 0;\n  text-decoration: none;\n  overflow: hidden;\n  transition: border-color .12s ease;\n}\n\n.sqbtn::after {\n  content: \"\";\n  position: absolute;\n  inset: var(--sq-inset);\n  border-radius: calc(var(--sq-radius) - 2px);\n  background: var(--sq-hover-fill);\n  opacity: 0;\n  transition: opacity .12s ease;\n  z-index: 0;\n}\n\n.sqbtn:hover::after {\n  opacity: 1;\n}\n\n.sqbtn:hover {\n  border-color: #D1D5DB;\n}\n\n.sqbtn__icon {\n  position: relative;\n  z-index: 1;\n  line-height: 0;\n  display: inline-flex;\n}\n\n\n.sqbtn:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, .18);\n  border-color: #cbd5e1;\n}\n\n.sqbtn[disabled] {\n  opacity: .6;\n  cursor: not-allowed;\n}\n\n/* Variants */\n.sqbtn--neutral {\n  --sq-icon-color: #0A0A0A;\n  --sq-border: #E5E7EB;\n  /* --sq-hover-fill: #F1F5F9; */\n  padding: 15px;\n  /* gray hover for view/edit */\n}\n\n.sqbtn--neutral:hover {\n  background: #e9ebef;\n  /* --sq-hover-fill: #F1F5F9; */\n  padding: 15px;\n  /* gray hover for view/edit */\n}\n\n.sqbtn--danger {\n  --sq-icon-color: #DC2626;\n  /* red icon */\n  --sq-border: #F3D4D4;\n  /* red border tint */\n  padding: 15px;\n  /* red inner fill on hover */\n}\n\n.sqbtn--danger:hover {\n  background: #fef2f2;\n  padding: 15px;\n  color: #000\n    /* red inner fill on hover */\n}\n\n.sqbtn--cancel {\n  --sq-icon-color: #DC2626;\n  --sq-border: #FECACA;\n  background: #fef2f2;\n  padding: 15px;\n}\n\n.sqbtn--cancel:hover {\n  background: #fee2e2;\n  border-color: #FCA5A5;\n  color: #B91C1C;\n}\n\n.S-No {\n  padding-left: 20px;\n}\n\n.S-No-V {\n  padding-left: 17px;\n}\n\n.custombutton.rc-tab-active,\n.rc-tab.custombutton.rc-tab-active {\n  background-color: #f97316 !important;\n  /* your blue */\n  color: #fff !important;\n  box-shadow: 0 1px 28px rgba(37, 99, 235, .35);\n  border-radius: 12px;\n  /* pill look */\n}\n\n.imagebutton.rc-tab-active,\n.rc-tab.imagebutton.rc-tab-active {\n  background-color: #8b5cf6 !important;\n  /* your blue */\n  color: #fff !important;\n  box-shadow: 0 1px 28px rgba(37, 99, 235, .35);\n  border-radius: 12px;\n  /* pill look */\n}\n\n/* ACTIVE */\n.detailsbutton.rc-tab-active,\n.rc-tab.detailsbutton.rc-tab-active {\n  background-color: #2563eb !important;\n  /* your blue */\n  color: #fff !important;\n  box-shadow: 0 1px 28px rgba(37, 99, 235, .35);\n  border-radius: 12px;\n  /* pill look */\n}\n\n\n/* Card shell */\n.gall-card {\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 18px;\n  box-shadow: 0 10px 24px rgba(2, 6, 23, .06);\n  padding: 2px;\n}\n\n/* Big light area + subtle white base at bottom (like your ref) */\n.gall-main {\n  position: relative;\n  /* background: #f6f8fb; */\n  border-radius: 16px;\n  min-height: 520px;\n  /* tweak 480–560 if you want */\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n.gall-main::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 14px;\n  background: #fff;\n  /* white strip at bottom */\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n  box-shadow: 0 -1px 0 rgba(2, 6, 23, .03) inset;\n}\n\n/* Swiper inside the light area */\n.gall-swiper {\n  width: 100%;\n  height: 100%;\n}\n\n.gall-img {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  margin: auto;\n  border-radius: 14px;\n}\n\n/* Hide default nav arrows (your ref shows none) */\n.swiper-button-next,\n.swiper-button-prev {\n  display: none !important;\n}\n\n/* Thumbs row */\n.gall-thumbs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  padding: 14px 4px 14px;\n}\n\n/* Individual thumb */\n.gall-thumb {\n  width: 80px;\n  height: 80px;\n  padding: 6px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  box-shadow: 0 8px 18px rgba(2, 6, 23, .08);\n  display: grid;\n  place-items: center;\n  transition: transform .15s ease;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.gall-thumb:hover {\n  transform: translateY(-2px);\n}\n\n.gall-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n  display: block;\n}\n\n/* Active thumb with strong blue ring, like your first image */\n.gall-thumb.is-active {\n  outline: 3px solid #3b82f6;\n  /* blue */\n  outline-offset: 0;\n}\n\n/* Header styles */\n.p2-name {\n  font-size: 1.2rem;\n  font-weight: 400;\n  color: #101828;\n  margin: 0 0 6px\n}\n\n.bg-colors {\n  background-color: #155dfc !important;\n}\n\n.p2-price {\n  color: #00a63e;\n  font-size: 26px;\n  font-weight: 800;\n  line-height: 1\n}\n\n.p2-sku {\n  color: #6b7280;\n  font-size: 14px;\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* Badges */\n.p2-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 9999px;\n  font-weight: 500;\n  font-size: 12px;\n  border: 1px solid transparent\n}\n\n.p2-pill-review {\n  background: #fff7ed;\n  border-color: #f6d8b0;\n  color: #b45309\n}\n\n.p2-pill-stock {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #065f46\n}\n\n.p2-pill-popular {\n  background: #fff7ed;\n  border-color: #fde2c7;\n  color: #b45309\n}\n\n/* Card */\n.p2-card {\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 16px;\n  box-shadow: 0 12px 30px rgba(2, 6, 23, .06)\n}\n\n.p2-card-title {\n  font-weight: 500;\n  color: #111827;\n  font-size: 20px;\n}\n\n/* Attributes line (label left, control/value right) */\n.p2-fieldrow {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 14px\n}\n\n.p2-fieldlabel {\n  color: #6b7280;\n  font-weight: 600\n}\n\n.p2-select {\n  min-width: 140px;\n  height: 38px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 0 10px;\n  background: #fff;\n  color: #111827;\n  font-weight: 600\n}\n\n.p2-attrval {\n  display: inline-block;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: #eef2f7;\n  color: #111827;\n  font-weight: 500\n}\n\n/* Customization fields */\n.p2-label {\n  display: block;\n  font-weight: 700;\n  font-size: 14px;\n  color: #111827;\n  margin-bottom: 6px\n}\n\n.p2-input {\n  height: 44px;\n  border-radius: 12px;\n  background: #f6f7fb;\n  border: 1px solid #e5e7eb;\n  color: #111827\n}\n\n.p2-input:focus {\n  background: #fff;\n  border-color: #3b82f6;\n  box-shadow: none\n}\n\n.p2-input.is-invalid {\n  border-color: #ef4444 !important;\n  background: #fff\n}\n\n.p2-error {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #ef4444\n}\n\n/* File input row like screenshot */\n.p2-file {\n  width: 100%;\n  height: 44px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  color: #ef4444;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700\n}\n\n.p2-file.is-invalid {\n  border-color: #ef4444\n}\n\n/* Card shell */\n.desc-card {\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 18px;\n  box-shadow: 0 12px 30px rgba(2, 6, 23, .06);\n  padding: 18px;\n  margin-top: 18px\n}\n\n.desc-title {\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 10px\n}\n\n/* Pill tab bar */\n.desc-tabbar {\n  background: #eef2f7;\n  border-radius: 9999px;\n  padding: 6px;\n  display: inline-flex;\n  gap: 8px\n}\n\n.desc-tab {\n  border: 0;\n  background: transparent;\n  border-radius: 9999px;\n  padding: 8px 18px;\n  font-weight: 700;\n  color: #6b7280;\n  position: relative\n}\n\n.desc-tab.is-active {\n  background: #fff;\n  color: #1d4ed8;\n  box-shadow:\n    0 1px 3px rgba(2, 6, 23, .08),\n    inset 0 0 0 2px #dbeafe,\n    /* inner ring */\n    inset 0 0 0 4px #e5e7eb;\n  /* second ring for double outline look */\n}\n\n/* Body spacing */\n.desc-body {\n  margin-top: 18px\n}\n\n/* Specs table */\n.desc-key {\n  color: #6b7280;\n  font-weight: 700;\n  white-space: nowrap;\n  width: 220px\n}\n\n.desc-val {\n  color: #111827\n}\n\n.table> :not(caption)>*>* {\n  border-bottom-color: #eef2f7\n}\n\n/* Details defaults */\n.desc-details .desc-subtitle {\n  font-weight: 700;\n  margin-bottom: 6px\n}\n\n.desc-list {\n  margin: 0;\n  padding-left: 1.2rem\n}\n\n.desc-list li {\n  margin: 4px 0\n}\n\n.desc-details-html p {\n  margin-bottom: 10px\n}\n\n/* Reviews list */\n.desc-reviews {\n  display: flex;\n  flex-direction: column;\n  gap: 16px\n}\n\n.desc-review {\n  background: #fff;\n  border: 1px solid #eef2f7;\n  border-radius: 14px;\n  box-shadow: 0 6px 16px rgba(2, 6, 23, .05);\n  padding: 16px\n}\n\n.desc-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 9999px;\n  background: #eaf2ff;\n  color: #3b82f6;\n  display: grid;\n  place-items: center;\n  font-size: 22px\n}\n\n.desc-stars {\n  color: #f59e0b;\n  font-weight: 700\n}\n\n.desc-chip {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 10px;\n  padding: 5px 10px;\n  font-weight: 700;\n  font-size: 12px;\n  border: 1px solid transparent\n}\n\n.desc-chip-green {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #065f46\n}\n\n.desc-chip-blue {\n  background: #eaf2ff;\n  border-color: #c7ddff;\n  color: #1e63da\n}\n\n.desc-help {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  border-radius: 10px;\n  padding: 4px 10px;\n  font-weight: 600;\n  color: #374151\n}\n\n.desc-help:hover {\n  background: #f9fafb\n}\n\n.desc-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px dashed #c7d2fe;\n  background: #f8fafc;\n  padding: 8px 12px;\n  border-radius: 10px;\n  color: #334155\n}\n\n\n/* ---------- general small fixes ---------- */\n.desc-key,\n.desc-val {\n  word-break: break-word;\n}\n\n/* Smooth horizontal scroll for tabs on touch */\n.desc-tabbar {\n  /* keep your existing lines */\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #c7d2fe transparent;\n}\n\n.desc-tabbar::-webkit-scrollbar {\n  height: 6px;\n}\n\n.desc-tabbar::-webkit-scrollbar-thumb {\n  background: #c7d2fe;\n  border-radius: 9999px;\n}\n\n/* ---------- tablet (≤ 992px) ---------- */\n@media (max-width: 991.98px) {\n  .desc-card {\n    padding: 14px;\n    border-radius: 16px;\n  }\n\n  .desc-title {\n    font-size: 18px;\n  }\n\n  .desc-tabbar {\n    width: 100%;\n    justify-content: flex-start;\n    gap: 6px;\n    padding: 4px 6px;\n  }\n\n  .desc-tab {\n    padding: 8px 14px;\n    font-size: 14px;\n  }\n\n  .desc-body {\n    margin-top: 14px;\n  }\n\n  /* Loosen the fixed key width so table doesn’t overflow */\n  .desc-key {\n    width: 180px;\n  }\n\n  .desc-review {\n    padding: 14px;\n  }\n\n  .desc-avatar {\n    width: 38px;\n    height: 38px;\n    font-size: 19px;\n  }\n}\n\n/* ---------- mobile (≤ 768px) ---------- */\n@media (max-width: 767.98px) {\n  .desc-card {\n    padding: 12px;\n    border-radius: 14px;\n    margin-top: 14px;\n  }\n\n  .desc-title {\n    margin-bottom: 8px;\n    font-size: 16px;\n  }\n\n  .desc-tabbar {\n    gap: 6px;\n    padding: 4px;\n    border-radius: 14px;\n  }\n\n  .desc-tab {\n    padding: 6px 12px;\n    font-size: 13px;\n    flex: 0 0 auto;\n  }\n\n  /* pills scroll horizontally */\n  .desc-tab.is-active {\n    box-shadow: 0 1px 2px rgba(2, 6, 23, .06), inset 0 0 0 2px #dbeafe;\n  }\n\n  .desc-body {\n    margin-top: 12px;\n  }\n\n  /* Specs table: allow wrapping + auto width keys */\n  .desc-key {\n    width: auto;\n    white-space: normal;\n  }\n\n  .table.mb-0 td,\n  .table.mb-0 th {\n    padding: .55rem .6rem;\n  }\n\n  .desc-details .row>[class*=\"col-\"] {\n    margin-bottom: 6px;\n  }\n\n  /* tighter rows */\n  .desc-details-html p {\n    margin-bottom: 8px;\n  }\n\n  .desc-reviews {\n    gap: 12px;\n  }\n\n  .desc-review {\n    padding: 12px;\n  }\n\n  .desc-avatar {\n    width: 34px;\n    height: 34px;\n    font-size: 17px;\n  }\n\n  .desc-chip {\n    padding: 4px 8px;\n    font-size: 11px;\n  }\n\n  .desc-help {\n    padding: 4px 8px;\n    font-weight: 600;\n    font-size: 12px;\n  }\n\n  /* On small screens, make the yes/no sit side-by-side nicely */\n  .desc-review .d-flex.align-items-center.gap-3 {\n    gap: 8px !important;\n    flex-wrap: wrap;\n  }\n\n  .desc-review .desc-help {\n    flex: 1 1 auto;\n  }\n}\n\n/* ---------- small mobile (≤ 480px) ---------- */\n@media (max-width: 480px) {\n  .desc-card {\n    padding: 10px;\n    border-radius: 12px;\n  }\n\n  .desc-tabbar {\n    padding: 3px;\n    gap: 4px;\n  }\n\n  .desc-tab {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n\n  .desc-chip {\n    padding: 3px 7px;\n    font-size: 10.5px;\n  }\n\n  .desc-loading {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n\n  /* Stack the “helpful?” row cleanly */\n  .desc-review .d-flex.align-items-center.gap-3 {\n    gap: 6px !important;\n  }\n\n  .desc-review .desc-help {\n    width: 48%;\n    text-align: center;\n  }\n}\n\n.p2-card {\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 16px;\n  box-shadow: 0 12px 30px rgba(2, 6, 23, .06)\n}\n\n.qty-label {\n  font-weight: 500;\n  color: #334155\n}\n\n.qty-wrap {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid rgba(2, 6, 23, .12);\n  border-radius: 14px;\n  overflow: hidden\n}\n\n.qty-btn {\n  width: 40px;\n  height: 40px;\n  border: 0;\n  background: #fff\n}\n\n.qty-btn:hover {\n  background: #f3f4f6\n}\n\n.qty-val {\n  min-width: 54px;\n  text-align: center;\n  font-weight: 800;\n  color: #0f172a\n}\n\n.qty-input {\n  border: none;\n  outline: none;\n  background: transparent;\n}\n\n.qty-input:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n/* Hide spin buttons in Chrome, Safari, Edge, Opera */\n.qty-input::-webkit-outer-spin-button,\n.qty-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide spin buttons in Firefox */\n.qty-input {\n  -moz-appearance: textfield;\n}\n\n.btn-pill {\n  border-radius: 14px;\n  padding: 10px 16px;\n  font-weight: 500;\n}\n\n.btn-ghost {\n  border: 1px solid rgba(2, 6, 23, .12);\n  background: #fff;\n  color: #374151\n}\n\n.btn-ghost:hover {\n  background: #f9fafb\n}\n\n.btn-cart {\n  background: #1292e6;\n  color: #fff;\n  border: none\n}\n\n.btn-cart:hover {\n  background: #0f86d6\n}\n\n.btn-cart:disabled {\n  opacity: .6;\n  cursor: not-allowed\n}\n\n.pd-page {\n  background: #fbf9fa;\n}\n\n.container-xl {\n  max-width: 1200px\n}\n\n.pd-back {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 12px;\n  border: 1px solid #e6ebf1;\n  border-radius: 12px;\n  background: #fff;\n  color: #1e63da;\n  font-weight: 700;\n  box-shadow: 0 4px 10px rgba(2, 6, 23, .05)\n}\n\n.pd-back:hover {\n  background: #f8fafe\n}\n\n.pd-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #101828;\n  margin: 10px 0 18px\n}\n\n\n\n\n\n\n\n\n\n/* Page BG + container rhythm */\n.prd-page {\n  background: #f2f6fb;\n}\n\n.prd-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 16px 0 18px;\n}\n\n.container-xl {\n  max-width: 1200px\n}\n\n/* Back pill */\n.prd-back {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 12px;\n  margin-top: 18px;\n  border: 1px solid #e6ebf1;\n  border-radius: 12px;\n  background: #fff;\n  color: #1e63da;\n  font-weight: 700;\n  box-shadow: 0 4px 10px rgba(2, 6, 23, .05);\n}\n\n.prd-back:hover {\n  background: #f8fafe\n}\n\n/* Generic soft card */\n.card-soft {\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 18px;\n  box-shadow: 0 10px 30px rgba(2, 6, 23, .06);\n}\n\n.card-soft-title {\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 8px;\n}\n\n/* Gallery */\n.prd-main-img {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  display: grid;\n  place-items: center;\n}\n\n.prd-main-img img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 14px;\n}\n\n.prd-thumb {\n  width: 58px;\n  height: 58px;\n  border-radius: 14px;\n  padding: 6px;\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  box-shadow: 0 8px 20px rgba(2, 6, 23, .08);\n}\n\n.prd-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 10px\n}\n\n.prd-thumb.active {\n  outline: 3px solid #3b82f6;\n  outline-offset: 0\n}\n\n/* Right header */\n.prd-name {\n  font-size: 32px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 6px\n}\n\n.prd-price {\n  color: #22c55e;\n  font-size: 26px;\n  font-weight: 800\n}\n\n.prd-sku {\n  color: #6b7280;\n  font-size: 14px\n}\n\n/* Pills / badges */\n.badge-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 9999px;\n  font-weight: 700;\n  font-size: 12px\n}\n\n.badge-review {\n  background: #fff3e6;\n  border: 1px solid #f6d8b0;\n  color: #b45b07\n}\n\n.badge-stock {\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  color: #065f46\n}\n\n.badge-popular {\n  background: #fff7ed;\n  border: 1px solid #fde2c7;\n  color: #b45309\n}\n\n/* Attributes row */\n.attr-line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e9eef5;\n  background: #fbfcfe;\n  border-radius: 14px;\n  padding: 10px 14px\n}\n\n.attr-key {\n  color: #6b7280;\n  font-size: 14px\n}\n\n.attr-val {\n  color: #0f172a;\n  font-weight: 800;\n  font-size: 14px;\n  background: #eef2f7;\n  border-radius: 10px;\n  padding: 6px 10px\n}\n\n/* Labels + inputs */\n.lbl {\n  display: block;\n  font-weight: 700;\n  font-size: 14px;\n  color: #0f172a;\n  margin-bottom: 6px\n}\n\n.inpt {\n  height: 44px;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb\n}\n\n.inpt.is-invalid {\n  border-color: #fda4af !important\n}\n\n.err {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #e11d48\n}\n\n.file-btn {\n  width: 100%;\n  height: 44px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600\n}\n\n.file-btn:hover {\n  background: #f9fafb\n}\n\n.file-preview {\n  margin-top: 8px;\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb\n}\n\n/* Quantity + buttons */\n.qty-label {\n  font-weight: 500;\n  color: #334155\n}\n\n.qty-wrap {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid rgba(2, 6, 23, .12);\n  border-radius: 14px;\n  overflow: hidden\n}\n\n.qty-btn {\n  width: 40px;\n  height: 40px;\n  border: 0;\n  background: #fff\n}\n\n.qty-btn:hover {\n  background: #f3f4f6\n}\n\n.qty-val {\n  min-width: 54px;\n  text-align: center;\n  font-weight: 800;\n  color: #0f172a\n}\n\n.btn-pill {\n  border-radius: 14px;\n  padding: 10px 16px;\n  font-weight: 800\n}\n\n.btn-ghost {\n  border: 1px solid rgba(2, 6, 23, .12);\n  background: #fff;\n  color: #374151\n}\n\n.btn-ghost:hover {\n  background: #f9fafb\n}\n\n.btn-cart {\n  background: #1292e6;\n  color: #fff;\n  border: none\n}\n\n.btn-cart:hover {\n  background: #0f86d6\n}\n\n.btn-cart:disabled {\n  opacity: .6;\n  cursor: not-allowed\n}\n\n/* Description */\n.desc-title {\n  font-weight: 700;\n  color: #0f172a\n}\n\n.pillbar {\n  background: #eef2f7;\n  border-radius: 9999px;\n  padding: 6px;\n  display: inline-flex;\n  gap: 6px\n}\n\n.pill {\n  border: 0;\n  background: transparent;\n  border-radius: 9999px;\n  padding: 8px 16px;\n  font-weight: 800;\n  color: #6b7280\n}\n\n.pill.active {\n  background: #fff;\n  color: #1d4ed8;\n  box-shadow: 0 1px 4px rgba(2, 6, 23, .08)\n}\n\n.spec-key {\n  color: #6b7280;\n  font-weight: 800\n}\n\n.spec-val {\n  color: #0f172a\n}\n\n\n\n/* supplier Details page css */\n\n\n/* Page scaffold */\n.vd-page {\n  background: #f7f9fc;\n  padding-bottom: 28px\n}\n\n.container-xl {\n  max-width: 1200px\n}\n\n/* Back + breadcrumbs */\n.vd-back {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 12px;\n  border: 1px solid #e6ebf1;\n  border-radius: 12px;\n  background: #fff;\n  color: #1e63da;\n  font-weight: 700;\n  box-shadow: 0 4px 10px rgba(2, 6, 23, .05);\n  text-decoration: none\n}\n\n.vd-back:hover {\n  background: #f8fafe\n}\n\n\n/* Vendor header card */\n.vd-vendor-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 18px;\n  padding: 18px 20px;\n  margin-bottom: 18px\n}\n\n.vd-vendor-card1 {\n  gap: 16px;\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 18px;\n  padding: 18px 20px;\n  margin-bottom: 18px\n}\n\n.vd-logo {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  background: linear-gradient(#eef2ff, #eaf2ff);\n  display: grid;\n  place-items: center;\n  overflow: hidden\n}\n\n.vd-logo img {\n  width: 44px;\n  height: 44px;\n  object-fit: contain\n}\n\n.vd-vendor-name {\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f172a\n}\n\n.vd-subtitle {\n  color: #1e63da;\n  font-weight: 700;\n  text-decoration: none;\n  display: block;\n  margin-top: 2px\n}\n\n.vd-rating {\n  color: #b45309;\n  font-weight: 700\n}\n\n.vd-chip {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #e5e7eb;\n  padding: 6px 10px;\n  font-weight: 700;\n  font-size: 12px;\n  background: #fff;\n  color: #334155\n}\n\n.vd-chip-green {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #065f46\n}\n\n.vd-chip-blue {\n  background: #eaf2ff;\n  border-color: #c7ddff;\n  color: #1e63da\n}\n\n.vd-chip-amber {\n  background: #fff7ed;\n  border-color: #fde2c7;\n  color: #b45309\n}\n\n.vd-chip-gray {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #475569\n}\n\n.vd-ghost-btn {\n  border: 1px solid rgba(2, 6, 23, .12);\n  background: #fff;\n  color: #334155;\n  border-radius: 12px;\n  padding: 10px 14px;\n  font-weight: 700;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center\n}\n\n.vd-ghost-btn:hover {\n  background: #f9fafb\n}\n\n/* === Filters container stays as a card (yours already adds vd-vendor-card) === */\n.vd-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n/* ---- Search box ---- */\n.vd-search {\n  position: relative;\n  flex: 1 1 420px;\n  min-width: 280px;\n  height: 48px;\n  border-radius: 14px;\n\n  /* exact look */\n  background: #F6F7FB;\n  /* soft gray fill */\n  border: 1.5px solid #E6EBF1;\n  /* precise border color/width */\n  box-shadow: none;\n  /* remove blue-ish shadow */\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.vd-search i {\n  color: #98A2B3;\n  font-size: 18px;\n}\n\n.vd-search-input {\n  border: 0;\n  outline: 0;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.vd-search-input::placeholder {\n  color: #9AA3B2;\n  font-weight: 600;\n}\n\n.vd-search:focus-within {\n  background: #FFFFFF;\n  /* ref shows white on focus */\n  border-color: #BCD6FF;\n  /* subtle blue border */\n  box-shadow: inset 0 0 0 2px #DBEAFE;\n  /* inner ring (double-outline feel) */\n}\n\n/* ---- Selects ---- */\n.vd-select {\n  height: 48px;\n  min-width: 150px;\n  border-radius: 14px;\n  padding: 0 14px;\n  font-weight: 700;\n  color: #0F172A;\n\n  /* exact look */\n  background: #F6F7FB;\n  /* same as search */\n  border: 1.5px solid #E6EBF1;\n  /* same border as search */\n  box-shadow: none;\n  appearance: none;\n  /* cleaner across browsers */\n  background-clip: padding-box;\n}\n\n.vd-select:focus {\n  outline: none;\n  background: #FFFFFF;\n  border-color: #BCD6FF;\n  box-shadow: inset 0 0 0 2px #DBEAFE;\n}\n\n/* Optional: consistent radius + spacing for the filters-as-card row */\n.vd-filters.vd-vendor-card {\n  padding: 18px;\n  /* match header card padding */\n  border-radius: 18px;\n}\n\n/* Product card */\n.vd-card {\n  background: #fff;\n  border: 1px solid rgba(2, 6, 23, .06);\n  border-radius: 18px;\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  flex-direction: column\n}\n\n/* consistent image box */\n.vd-figure {\n  height: 180px;                 /* pick a single height */\n  background:#f6f8fb;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  overflow:hidden;               /* crop overflow */\n  border-top-left-radius:18px;\n  border-top-right-radius:18px;\n}\n\n/* make all images fill the box consistently */\n.vd-img {\n  width:100%;\n  height:100%;\n  object-fit:contain;              /* use 'contain' if you prefer no cropping */\n  display:block;\n}\n\n/* optional alt text */\n.vd-noimg {\n  color:#94a3b8;\n  font-weight:700;\n}\n\n.vd-card-title {\n  display: block;\n  margin-top: 4px;\n  color: #0f172a;\n  font-weight: 500;\n  text-decoration: none;\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.vd-card-title:hover {\n  text-decoration: underline\n}\n\n.vd-card-desc {\n  color: #64748b;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin-top: 4px\n}\n\n.vd-price {\n  color: #16a34a;\n  font-weight: 900;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n/* Price / stock row on supplier product cards */\n.vd-card-meta-row {\n  min-width: 0;\n}\n\n.vd-card-meta-row .vd-chip {\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  text-align: center;\n}\n\n.vd-cta {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1e63da;\n  color: #fff;\n  border-radius: 12px;\n  padding: 10px 14px;\n  text-decoration: none;\n  font-weight: 800\n}\n\n.vd-cta:hover {\n  background: #1856bf\n}\n\n/* Footer */\n.vd-footer-note {\n  color: #94a3b8;\n  text-align: right;\n  margin-top: 20px;\n  font-size: 12px\n}\n\n.success-btn{\n  background-color: #009966;\n  color: white;\n}\n\n.success-btn:hover{\n  background-color: #007a55;\n  color: white;\n}\n.container-1440 { width: 100%; }\n@media (min-width: 1440px) {\n  .container-1440 {\n    max-width: 1320px;     /* or whatever width you want */\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 12px;    /* match Bootstrap gutter if you want */\n    padding-right: 12px;\n  }\n}\n\n\n\n.form-select.po-select {\n  /* size & spacing */\n  height: 48px;\n  padding: 10px 40px 10px 12px;\n  /* leave room on right for caret */\n  border-radius: 10px;\n\n  /* look & feel (match your existing palette) */\n  background-color: #f5f6fa;\n  border: 2px solid #c9ced6;\n  line-height: 1.4;\n  /* ensures vertical centering */\n  color: #111827;\n\n  /* remove native arrows so we can draw our own */\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  /* custom caret (down arrow), centered vertically on right — single-line data URI (multiline breaks CssMinimizer) */\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2020%2020'%20fill%3D'%236b7280'%3E%3Cpath%20d%3D'M5.23%207.21a.75.75%200%200%201%201.06.02L10%2010.13l3.71-2.9a.75.75%200%201%201%20.92%201.19l-4.17%203.26a.75.75%200%200%201-.92%200L5.21%208.42a.75.75%200%200%201%20.02-1.21z'%2F%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  /* right aligned + vertically centered */\n  background-size: 16px;\n}\n\n\n.form-select.po-select:focus {\n  border-color: #9ca3af;\n  background-color: #fafafa;\n  box-shadow: none;\n  outline: 0;\n}\n\n\n.form-select.po-select::-ms-expand {\n  display: none;\n}\n\n\n.form-select.po-select:disabled {\n  background-color: #f2f2f2;\n  color: #000;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n/* ===== Product Description Textarea ===== */\n/* Desktop and Tablet - 280px default height */\n@media (min-width: 768px) {\n  .product-description-textarea {\n    height: 340px;\n    min-height: 100px !important;\n    resize: vertical !important;\n  }\n}\n\n/* Mobile view - no fixed height, normal behavior */\n@media (max-width: 767.98px) {\n  .product-description-textarea {\n    height: auto;\n    min-height: auto !important;\n    resize: vertical !important;\n  }\n}\n\n.table-addbutton:disabled , .save-btn:disabled{\n  color: #000000;\n  background-color: #93c5fd;\n  opacity:0.8;\n  border: none;\n}\n\n\n/* ===== Email Template Styles ===== */\n/* Email Typography */\n.email-heading-h2 {\n  margin: 0 0 16px 0;\n  color: #111827;\n  font-size: 24px;\n  font-weight: 500;\n  font-family: 'Roboto', Arial, sans-serif;\n}\n\n.email-heading-h3 {\n  margin: 0 0 16px 0;\n  color: #111827;\n  font-size: 20px;\n  font-weight: 500;\n  font-family: 'Roboto', Arial, sans-serif;\n  display: flex;\n  gap: 5px ! important;\n}\n\n.email-paragraph {\n  margin: 0 0 32px 0;\n  color: #4b5563;\n  font-size: 16px;\n  line-height: 24px;\n  font-family: 'Roboto', Arial, sans-serif;\n}\n\n.email-paragraph-small {\n  margin: 0 0 24px 0;\n  color: #4b5563;\n  font-size: 16px;\n  line-height: 24px;\n  font-family: 'Roboto', Arial, sans-serif;\n}\n\n/* Order Details Card */\n.email-order-details-card {\n  background-color: #f9fafb;\n  border-radius: 8px;\n  padding: 25px;\n  margin: 0 0 32px 0;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n}\n\n.email-order-details-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  max-width: 100%;\n}\n\n.email-order-details-field {\n  padding: 8px 0;\n  color: #6b7280;\n  font-size: 14px;\n  vertical-align: top;\n  width: 35%;\n  word-wrap: break-word;\n  border-top: 1px solid #e5e7eb !important;\n}\n\n.email-order-details-value {\n  padding: 8px 0;\n  color: black;\n  font-size: 14px;\n  font-weight: 600;\n  vertical-align: top;\n  border-top: 1px solid #e5e7eb !important;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  max-width: 0;\n}\n\n.email-order-details-value-first {\n  padding: 8px 0;\n  color: #111827;\n  font-size: 13px;\n  font-weight: 600;\n  vertical-align: top;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  max-width: 0;\n}\n\n.email-order-details-value-bold {\n  padding: 8px 0;\n  color: #111827;\n  font-size: 13px;\n  font-weight: 600;\n  vertical-align: top;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  max-width: 0;\n  border-top: 1px solid #e5e7eb !important;\n}\n\n.email-order-details-value-bold-first {\n  padding: 8px 0;\n  color: #111827;\n  font-size: 13px;\n  font-weight: 600;\n  vertical-align: top;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  max-width: 0;\n  /* border-top: 1px solid #e5e7eb !important; */\n}\n\n.email-order-details-value-link {\n  padding: 8px 0;\n  color: #2563EB;\n  font-size: 13px;\n  font-weight: 600;\n  vertical-align: top;\n  border-top: 1px solid #e5e7eb !important;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n  max-width: 0;\n}\n\n.email-order-details-field-first {\n  padding: 8px 0;\n  color: #6b7280;\n  font-size: 13px;\n  vertical-align: top;\n  width: 35%;\n  word-wrap: break-word;\n}\n\n/* Line Items Card */\n.email-line-items-heading {\n  margin: 32px 0 16px 0;\n  color: #111827;\n  font-size: 20px;\n  font-weight: 500;\n  font-family: 'Roboto', Arial, sans-serif;\n  display: flex;\n  gap: 5px;\n}\n\n.email-line-items-container {\nbackground-color: #f9fafb ! important;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 0 0 32px 0;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n}\n\n.email-line-item-row {\n  padding: 12px 0;\n  /* border-top: 1px solid #e5e7eb; */\n  background-color: #f9fafb;\n}\n\n.email-line-item-row:first-child {\n  padding: 0;\n  border-top: none;\n}\n\n.email-line-item-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.email-line-item-product {\n  padding: 0;\n  vertical-align: top;\n}\n\n.email-line-item-product-name {\n  color: black;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.email-line-item-product-desc {\n  color: #6b7280;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.email-line-item-qty {\n  padding: 0 0 0 16px;\n  vertical-align: top;\n  text-align: right;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  color:black;\n}\n\n.email-line-item-qty-text {\n  color: #111827;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n/* Email Footer */\n.email-footer {\n  background-color: #f8f8f8;\n  padding: 32px 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.email-footer-link {\n  color: #6b7280 !important;\n  font-size: 14px;\n  text-decoration: none;\n  padding: 0 8px;\n}\n\n.email-footer-separator {\n  color: #d1d5db;\n}\n\n.email-footer-text {\n  margin: 0;\n  color: #9ca3af;\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.email-footer-social-icon {\n  display: block;\n  width: 32px;\n  height: 32px;\n  background-color: #e5e7eb;\n  border-radius: 50%;\n  text-decoration: none;\n}\n\n.email-footer-social-icon-table {\n  width: 32px;\n  height: 32px;\n}\n\n.email-footer-social-icon-text {\n  font-size: 18px;\n  color: #6b7280;\n  font-weight: bold;\n}\n\n.t-dashboards{\n  color: #1f2937 !important;\n}\n.t-dashboards:hover{\n  color: #1e63da !important;\n}\n\n.logcolor{\n   color: #1f2937 !important;\n}\n\n.logcolor:hover{\n  color: #1e63da !important;\n}\n\n/* Cart header icon (RealtorHeader / CartDropdown trigger) */\n.cart-header-icon {\n  position: relative;\n  font-size: 20px;\n  color: #666666;\n  cursor: pointer;\n  text-decoration: none;\n  overflow: visible;\n}\n.cart-header-icon:hover {\n  color: #1e5db8;\n}\n.cart-header-icon-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.cart-header-icon .cart-badge {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: #e53935;\n  color: white;\n  font-size: 10px;\n  font-weight: 700;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* Prevent Bootstrap dropdown toggle from breaking cart trigger layout */\n.cart-dropdown-trigger.btn {\n  line-height: 1;\n}\n.cart-dropdown-trigger.dropdown-toggle::after {\n  display: none;\n}\n\n\n.btn-success{\n  background-color: #00a63e !important;\n  border-color: #00a63e !important;\n  color: white;\n}\n\n.btn-success:hover{\n  background-color: #008236 !important;\n  border-color: #008236 !important;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
